
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("OCz5m", function(module, exports) {
/* editorSSRExtensionHandlers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $h9yJL = parcelRequire("h9yJL");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");


var $5kjCz = parcelRequire("5kjCz");


var $dwS6P = parcelRequire("dwS6P");

const $e673ff442c42ddbb$var$cssContext = {
    insertCss: (styles)=>styles._insertCss()
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e673ff442c42ddbb$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ajq _bfhksm61",
            __cmplp.className
        ])
    });
});
const $e673ff442c42ddbb$var$createEditorSSRExtensionHandlers = ({ contentId: contentId, spaceKey: spaceKey, cloudId: cloudId, userId: userId })=>{
    return {
        'com.atlassian.confluence.macro.core': (extension, doc)=>{
            const { extensionKey: extensionKey } = extension;
            const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
            const macroDefaultProps = {
                mode: (0, $5kjCz.EDITOR),
                node: extension,
                context: $e673ff442c42ddbb$var$cssContext,
                extensionKey: extensionKey,
                attributes: attributes,
                references: [],
                contentId: contentId,
                spaceKey: spaceKey
            };
            if (extensionKey === 'toc') {
                const editorTransformer = new (0, $h9yJL.JSONTransformer)();
                const adf = editorTransformer.encode(doc);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e673ff442c42ddbb$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dwS6P.TableOfContentsLoader), {
                    isInEditMode: true,
                    adf: adf,
                    userId: userId || '',
                    cloudId: cloudId,
                    macroDefaultProps: macroDefaultProps
                }));
            }
            // Unsupported (yet) extensions should default to existing provider-based handling
            // and rendering on a client side only.
            return null;
        }
    };
};
const $e673ff442c42ddbb$export$206691819bb24df7 = (contentId, spaceKey, extensionProviders)=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [providersReady, setProvidersReady] = (0, $42omo.useState)(false);
    const isTransition = (0, $dPJCf.useIsTransition)();
    (0, $42omo.useEffect)(()=>{
        const providerPromises = extensionProviders?.map((provider)=>{
            return typeof provider.manifestsPromise !== 'undefined' ? provider.manifestsPromise : provider;
        });
        Promise.all(providerPromises).then(()=>setProvidersReady(true)).catch((_error)=>{
            // NOOP: Here, if any of the provider promises fail, the best we can do is to
            // fall back the original experience where macros are resolved and rendered on
            // the client only, although in this case the extensions experience would likely
            // be hosed anyway.
            setProvidersReady(true);
        });
    }, [
        extensionProviders
    ]);
    const extensionHandlers = (0, $42omo.useMemo)(()=>$e673ff442c42ddbb$var$createEditorSSRExtensionHandlers({
            contentId: contentId,
            spaceKey: spaceKey,
            cloudId: cloudId,
            userId: userId
        }), [
        contentId,
        spaceKey,
        cloudId,
        userId
    ]);
    return isTransition || providersReady ? undefined : extensionHandlers;
};
module.exports["useEditorSSRExtensionHandlers"] = $e673ff442c42ddbb$export$206691819bb24df7;

});

parcelRegister("jFkNO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $1ITQ3 = parcelRequire("1ITQ3");

const $bbc19db46e52068c$var$FORGE_VIEWPORT_SIZES = [
    'small',
    'medium',
    'default',
    'large',
    'xlarge'
];
const $bbc19db46e52068c$var$FORGE_MANIFEST_VIEWPORT_HEIGHTS = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
/**
 * Currently, very few legacy (connect) macros provide their expected rendered height/width
 * values in their macro parameters. Of those that do, there's a slight but consistent
 * margin of error for the height value. Others that don't render dynamic content we can
 * set a default height for (such as Miro embed).
 *
 * Any changes here should be mirrored in content-renderer-legacy-macros/src/useConnectExtensionViewportSize.ts
 * and getCalculatedHeightFromNode.ts
 */ const $bbc19db46e52068c$var$DRAW_IO_HEIGHT_OFFSET = 52;
const $bbc19db46e52068c$var$GOOGLE_DRIVE_EMBED_FILE_OFFSET_HEIGHT = 79;
const $bbc19db46e52068c$var$PLANTUML_OFFSET_HEIGHT = 40;
// Default sizes
const $bbc19db46e52068c$var$MIRO_EMBED_DEFAULT_HEIGHT = 570;
const $bbc19db46e52068c$var$EASY_MATH_BLOCK_DEFAULT_HEIGHT = 47;
const $bbc19db46e52068c$var$MATH_BLOCK_DEFAULT_HEIGHT = 58;
const $bbc19db46e52068c$var$PAGE_SIGNATURES_DEFAULT_HEIGHT = 23;
const $bbc19db46e52068c$var$QUESTIONS_LIST_DEFAULT_HEIGHT = 800;
const $bbc19db46e52068c$var$JIRA_ROADMAP_DEFAULT_HEIGHT = 600;
const $bbc19db46e52068c$var$LUCID_CHART_DEFAULT_HEIGHT = 500;
const $bbc19db46e52068c$var$GLIFFY_DEFAULT_HEIGHT = 150;
const $bbc19db46e52068c$var$AURA_DIVIDER_DEFAULT_HEIGHT = 21;
const $bbc19db46e52068c$var$AURA_CARDS_DEFAULT_HEIGHT = 226;
const $bbc19db46e52068c$var$getForgeExtensionHeight = (extensionId, extensionViewportSizes)=>{
    if (!extensionViewportSizes || !extensionId || !Array.isArray(extensionViewportSizes)) return;
    const viewportSize = extensionViewportSizes.find((ext)=>ext.extensionId === extensionId)?.viewportSize;
    if (!viewportSize) return undefined;
    if ($bbc19db46e52068c$var$FORGE_VIEWPORT_SIZES.includes(viewportSize)) return $bbc19db46e52068c$var$FORGE_MANIFEST_VIEWPORT_HEIGHTS[viewportSize];
    return undefined;
};
const $bbc19db46e52068c$var$getHeightFromNode = (node)=>{
    if (!node) return;
    const extensionKey = node.attrs.extensionKey;
    const params = node.attrs.parameters?.macroParams;
    /**
	 * DrawIo will resize diagrams based on the viewport they are rendered in
	 * if the diagram's width is greater than 530px. This means that the natural dimensions
	 * provided in macro parameters could be the incorrect height to reserve so we will
	 * conservatively exclude them.
	 */ if (extensionKey === 'drawio' || extensionKey === 'inc-drawio' || extensionKey === 'drawio-sketch') {
        const diagramWidth = Number(params?.width?.value);
        const zoomFactor = Number(params?.zoom?.value);
        if (diagramWidth && diagramWidth > 530 || zoomFactor !== 1) // Exclude wide diagrams due to allow resizing by vendor
        return;
    }
    if (extensionKey === 'plantumlcloud') return params?.originalHeight?.value;
    return params?.height?.value;
};
const $bbc19db46e52068c$export$bdad5f6d3f57f201 = ()=>{
    /**
	 * To attribute impact to each ecosystem, we plan to rollout Forge improvements separately
	 * via (confluence_preload_forge_viewport_heights_editor) with Connect improvements after
	 * via (confluence_connect_macro_preset_height). Thus we'll isolate Forge functionality first with
	 * the long term plan to merge both into a single function after successful rollout.
	 */ const extensionViewportSizes = (0, $1ITQ3.useExtensionViewportSizes)(!(0, $9wGTI.fg)('confluence_preload_forge_viewport_heights_editor'));
    const getForgeViewportHeight = (node)=>{
        // Forge in-content macros contain an ARI/environment/appKey extensionId value
        const extensionId = node.attrs.parameters?.extensionId;
        const forgeExtensionHeight = $bbc19db46e52068c$var$getForgeExtensionHeight(extensionId, extensionViewportSizes);
        if (forgeExtensionHeight) return forgeExtensionHeight;
    };
    const getCalculatedHeightFromNode = (0, $42omo.useCallback)((node)=>{
        // Check if it's a Connect extension with macro parameters
        const extensionKey = node.attrs.extensionKey;
        const nodeHeight = $bbc19db46e52068c$var$getHeightFromNode(node);
        let height = Number(nodeHeight);
        if (!Number.isNaN(height)) // for extensions that provide a number, add their offset
        switch(extensionKey){
            case 'drawio':
            case 'inc-drawio':
            case 'drawio-sketch':
                height += $bbc19db46e52068c$var$DRAW_IO_HEIGHT_OFFSET;
                break;
            case 'lref-gdrive-embedded-file':
                height += $bbc19db46e52068c$var$GOOGLE_DRIVE_EMBED_FILE_OFFSET_HEIGHT;
                break;
            case 'plantumlcloud':
                height += $bbc19db46e52068c$var$PLANTUML_OFFSET_HEIGHT;
                break;
            default:
                break;
        }
        else // for extensions that don't resize based on their content, we can set a default height
        switch(extensionKey){
            case 'gliffy':
                height = $bbc19db46e52068c$var$GLIFFY_DEFAULT_HEIGHT;
                break;
            case 'aura-divider':
                height = $bbc19db46e52068c$var$AURA_DIVIDER_DEFAULT_HEIGHT;
                break;
            case 'aura-cards':
                height = $bbc19db46e52068c$var$AURA_CARDS_DEFAULT_HEIGHT;
                break;
            case 'miro-macro-resizing':
                height = $bbc19db46e52068c$var$MIRO_EMBED_DEFAULT_HEIGHT;
                break;
            case 'easy-math-block':
                height = $bbc19db46e52068c$var$EASY_MATH_BLOCK_DEFAULT_HEIGHT;
                break;
            case 'mathblock':
                height = $bbc19db46e52068c$var$MATH_BLOCK_DEFAULT_HEIGHT;
                break;
            case 'page-signatures':
                height = $bbc19db46e52068c$var$PAGE_SIGNATURES_DEFAULT_HEIGHT;
                break;
            case 'questionslist-macro':
                height = $bbc19db46e52068c$var$QUESTIONS_LIST_DEFAULT_HEIGHT;
                break;
            case 'jiraroadmap':
                height = $bbc19db46e52068c$var$JIRA_ROADMAP_DEFAULT_HEIGHT;
                break;
            case 'lucidchart':
                height = $bbc19db46e52068c$var$LUCID_CHART_DEFAULT_HEIGHT;
                break;
            default:
                height = undefined;
                break;
        }
        return height?.toString();
    }, []);
    if ((0, $9wGTI.fg)('confluence_preload_forge_viewport_heights_editor')) return getForgeViewportHeight;
    if ((0, $9wGTI.fg)('confluence_connect_macro_preset_height')) return getCalculatedHeightFromNode;
};
module.exports["useExtensionNodeParams"] = $bbc19db46e52068c$export$bdad5f6d3f57f201;

});

parcelRegister("fthpM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $b5IZN = parcelRequire("b5IZN");


var $2NcJL = parcelRequire("2NcJL");

function $75195e6585fa4719$export$a15423dd96de66f2(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5IZN.CoreEditor), {
        ...props,
        appearance: props.appearance ?? 'full-page',
        AppearanceComponent: (0, $2NcJL.FullPageEditor),
        __livePage: props.__livePage
    });
}
module.exports["FullPageEditor"] = $75195e6585fa4719$export$a15423dd96de66f2;

});

parcelRegister("diJQD", function(module, exports) {

var $4TXTZ = parcelRequire("4TXTZ");


var $l998X = parcelRequire("l998X");

parcelRequire("42omo");





var $42omo = parcelRequire("42omo");


var $eiA8Z = parcelRequire("eiA8Z");


var $awHlv = parcelRequire("awHlv");


var $keGcB = parcelRequire("keGcB");


var $bEEXh = parcelRequire("bEEXh");


var $1Wy2j = parcelRequire("1Wy2j");

const $7e2add9d3c9e37d0$var$SyncedBlockRendererComponent = ({ useFetchSyncBlockData: useFetchSyncBlockData, syncBlockRendererOptions: syncBlockRendererOptions, api: api })=>{
    const { syncBlockInstance: syncBlockInstance, providerFactory: providerFactory, isLoading: isLoading, reloadData: reloadData } = useFetchSyncBlockData();
    const { isOffline: isOffline } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], ({ connectivityState: connectivityState })=>({
            isOffline: connectivityState?.mode === 'offline'
        }));
    if (isOffline) return /*#__PURE__*/ (0, $l998X.jsx)((0, $bEEXh.SyncedBlockErrorComponent), {
        error: (0, $awHlv.SyncBlockError).Offline
    });
    if (!syncBlockInstance) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1Wy2j.SyncedBlockLoadingState), {});
    if (syncBlockInstance.error || !syncBlockInstance.data) return /*#__PURE__*/ (0, $l998X.jsx)((0, $bEEXh.SyncedBlockErrorComponent), {
        error: syncBlockInstance.error ?? (0, $awHlv.SyncBlockError).Errored,
        sourceAri: syncBlockInstance.data?.sourceAri,
        sourceProduct: syncBlockInstance.data?.product,
        onRetry: reloadData,
        isLoading: isLoading
    });
    const syncBlockDoc = {
        content: syncBlockInstance.data.content,
        version: 1,
        type: 'doc'
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keGcB.AKRendererWrapper), {
        doc: syncBlockDoc,
        dataProviders: providerFactory,
        options: syncBlockRendererOptions
    });
};
const $7e2add9d3c9e37d0$export$a53459da4a5011e9 = /*#__PURE__*/ (0, $42omo.memo)($7e2add9d3c9e37d0$var$SyncedBlockRendererComponent);


const $110d37d9cdb1248f$export$8add922a5c506966 = ({ syncBlockRendererOptions: syncBlockRendererOptions })=>({ useFetchSyncBlockData: useFetchSyncBlockData, api: api })=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $7e2add9d3c9e37d0$export$a53459da4a5011e9), {
            syncBlockRendererOptions: syncBlockRendererOptions,
            useFetchSyncBlockData: useFetchSyncBlockData,
            api: api
        });
    };





parcelRequire("42omo");


var $2FNjD = parcelRequire("2FNjD");


var $gmMgo = parcelRequire("gmMgo");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $ftzrq = parcelRequire("ftzrq");


var $2XqLN = parcelRequire("2XqLN");

const $5c15d883298a980d$export$2073a24f9367a16f = (0, $2XqLN.default)(()=>{
    // directly use CSS would cause failed SSR tests.
    if (typeof window !== 'undefined' && window.CSS && window.CSS.supports) return window.CSS.supports('anchor-name: --a');
    return false;
});
class $5c15d883298a980d$export$e1d230f644ff05aa {
    clear() {
        this.isDirty = true;
        this.anchorRectMap = {};
    }
    getRects() {
        if (this.isDirty) {
            const anchorElements = this.view?.dom.querySelectorAll('[data-section-cta-anchor-name]') || [];
            this.anchorRectMap = Array.from(anchorElements).reduce((prev, curr)=>{
                const anchorName = curr.getAttribute('data-section-cta-anchor-name');
                if (anchorName) return {
                    ...prev,
                    [anchorName]: {
                        height: curr.clientHeight,
                        top: curr.offsetTop,
                        left: curr.offsetLeft,
                        right: curr.offsetLeft + curr.clientWidth,
                        width: curr.clientWidth,
                        bottom: curr.offsetTop + curr.clientHeight
                    }
                };
                return prev;
            }, {});
            this.isDirty = false;
        }
        return this.anchorRectMap;
    }
    setEditorView(view) {
        if (this.view !== view) this.view = view;
    }
    getHeight(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.height;
    }
    getWidth(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.width;
    }
    getLeft(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.left;
    }
    getTop(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.top;
    }
    getRight(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName]?.right;
    }
    getRect(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName];
    }
    constructor(){
        this.anchorRectMap = {};
        this.isAnchorSupported = $5c15d883298a980d$export$2073a24f9367a16f();
        this.isDirty = true;
        this.view = null;
    }
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $aFUXX = parcelRequire("aFUXX");


var $g5gZt = parcelRequire("g5gZt");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");


var $3gadb = parcelRequire("3gadb");


var $cgtv4 = parcelRequire("cgtv4");

const $20ed47d9991fb6d4$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    addSection: {
        id: "company-hub-section-cta.plus-button.add-section",
        defaultMessage: "Add section"
    },
    contentHeader: {
        id: "company-hub-section-cta.section-node.content.header",
        defaultMessage: "Give your section a title"
    },
    contentSubHeader: {
        id: "company-hub-section-cta.section-node.content.sub-header",
        defaultMessage: "Organize elements into sections with customizable backgrounds."
    },
    lozengeTitle: {
        id: "company-hub-section-cta.section-node.lozenge-title",
        defaultMessage: "Section"
    },
    placeHolderTitle: {
        id: "company-hub-section-cta.section-node.content.placeholder-title",
        defaultMessage: "Placeholder"
    }
});



const $43c0e35ecb9920ae$var$styles = {
    containerBaseStyles: "_v5641p41 _18zr1i3y _kqswstnw _1bsb16wv _1e0c1txw _1bah1h6o _4cvr1h6o _4t3izwfg _tzy4idpf _1pbyb4wl _16l4kb7n",
    lineStyles: "_16jlkb7n _1o9zkb7n _i0dlf1ug _4t3iyh40 _bfhk1aqn",
    pressable: "_2rko1rr0 _bfhk1aqn _4t3izwfg _1bsbzwfg _irr31ibz _1di6of27"
};
const $43c0e35ecb9920ae$var$Line = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($43c0e35ecb9920ae$var$styles.lineStyles)
    });
const $43c0e35ecb9920ae$export$e50c8b7ca0cd488e = ({ anchorId: anchorId, onClick: onClick, view: view, prevNodeTypeName: prevNodeTypeName, isLastPosition: isLastPosition, anchorRectCache: anchorRectCache })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [dynamicStyles, setDynamicStyles] = (0, $42omo.useState)({});
    (0, $42omo.useEffect)(()=>{
        const calculatePosition = ()=>{
            const isSectionNode = prevNodeTypeName === 'multiBodiedExtension';
            const isParagraphNode = prevNodeTypeName === 'paragraph';
            const isTableNode = prevNodeTypeName === 'table';
            let verticalOffset = '-50%'; // Default for top and after normal nodes
            if (isSectionNode || isTableNode) verticalOffset = '-100%';
            else if (isLastPosition && isParagraphNode) verticalOffset = '0';
            const baseStyles = {
                // Linter errors if we use variables/non-tokens in cssMap so we need to use style prop
                // add 40px to the max width to account for the padding of the editor
                maxWidth: `${(0, $aFUXX.akEditorFullWidthLayoutWidth) + 40}px`
            };
            if ((0, $5c15d883298a980d$export$2073a24f9367a16f)()) {
                setDynamicStyles({
                    ...baseStyles,
                    positionAnchor: `--${anchorId}`,
                    top: 'anchor(bottom)',
                    left: '50%',
                    transform: `translate(-50%, ${verticalOffset})`
                });
                return;
            } // Fallback logic
            anchorRectCache?.clear();
            const rect = anchorRectCache?.getRect(anchorId);
            if (!rect) {
                setDynamicStyles({
                    ...baseStyles,
                    display: 'none'
                });
                return;
            }
            const top = rect.top + rect.height;
            setDynamicStyles({
                ...baseStyles,
                top: `${top}px`,
                left: '50%',
                transform: `translate(-50%, ${verticalOffset})`
            });
        };
        // Set position on initial render and whenever dependencies change.
        calculatePosition(); // Observe for layout changes to recalculate position.
        const observer = new ResizeObserver(calculatePosition);
        observer.observe(view.dom);
        return ()=>{
            observer.disconnect();
        };
    }, [
        anchorId,
        prevNodeTypeName,
        isLastPosition,
        anchorRectCache,
        view.dom
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: dynamicStyles,
        "data-testid": "company-hub-plus-button",
        className: (0, $gMc0m.default)([
            $43c0e35ecb9920ae$var$styles.containerBaseStyles
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($43c0e35ecb9920ae$var$Line, {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: formatMessage((0, $20ed47d9991fb6d4$export$a7357cdd1f0b0168).addSection),
                children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                        ...tooltipProps,
                        onClick: onClick,
                        xcss: $43c0e35ecb9920ae$var$styles.pressable,
                        "aria-label": formatMessage((0, $20ed47d9991fb6d4$export$a7357cdd1f0b0168).addSection),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                            label: "",
                            color: "var(--ds-icon-inverse, #FFFFFF)"
                        })
                    })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($43c0e35ecb9920ae$var$Line, {})
        ]
    });
};



var $dQl1W = parcelRequire("dQl1W");


var $f3dd73ebb486855e$export$3130b484681bf8bc = /*#__PURE__*/ function(CONTENT_WIDTH) {
    CONTENT_WIDTH["NARROW"] = "narrow";
    CONTENT_WIDTH["WIDE"] = "wide";
    CONTENT_WIDTH["FULL"] = "full";
    return CONTENT_WIDTH;
}({});
const $f3dd73ebb486855e$export$6cccba5fae1d609d = "wide";
const $f3dd73ebb486855e$export$617cdcc6afaae4f7 = "var(--ds-surface, #FFFFFF)";
const $f3dd73ebb486855e$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $f3dd73ebb486855e$export$ca3a94184e0fbd97 = 'hub-element-placeholder';
const $f3dd73ebb486855e$export$b39442728ee427d = 'hub-section';
const $f3dd73ebb486855e$export$12ee1d1507d066e8 = 'com.atlassian.confluence.hub-section';


const $fa22ef03bf87464a$export$993dca3597b448e8 = ({ header: header, subHeader: subHeader, placeholderTitle: placeholderTitle })=>({
        type: 'extensionFrame',
        content: [
            {
                type: 'heading',
                attrs: {
                    level: 1,
                    localId: null
                },
                content: [
                    {
                        type: 'text',
                        text: `${header}`
                    }
                ]
            },
            {
                type: 'paragraph',
                attrs: {
                    localId: null
                },
                content: [
                    {
                        type: 'text',
                        text: `${subHeader}`
                    }
                ]
            },
            {
                type: 'paragraph',
                attrs: {
                    localId: null
                }
            },
            {
                type: 'extension',
                attrs: {
                    extensionKey: (0, $f3dd73ebb486855e$export$ca3a94184e0fbd97),
                    extensionType: (0, $f3dd73ebb486855e$export$c14e692c91462ed4),
                    parameters: {
                        extensionTitle: placeholderTitle
                    },
                    text: null,
                    layout: 'default',
                    localId: null
                }
            }
        ]
    });
const $fa22ef03bf87464a$var$sectionContentNode = (state, initialContentText)=>state.schema.nodeFromJSON($fa22ef03bf87464a$export$993dca3597b448e8(initialContentText));
const $fa22ef03bf87464a$export$3cf963ab3631af75 = (state, intl)=>{
    const initialContentText = {
        header: intl.formatMessage((0, $20ed47d9991fb6d4$export$a7357cdd1f0b0168).contentHeader),
        subHeader: intl.formatMessage((0, $20ed47d9991fb6d4$export$a7357cdd1f0b0168).contentSubHeader),
        placeholderTitle: intl.formatMessage((0, $20ed47d9991fb6d4$export$a7357cdd1f0b0168).placeHolderTitle)
    };
    return state.schema.nodes.multiBodiedExtension.create({
        extensionType: (0, $f3dd73ebb486855e$export$12ee1d1507d066e8),
        extensionKey: (0, $f3dd73ebb486855e$export$b39442728ee427d),
        layout: 'full-width',
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        localId: (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))(),
        parameters: {
            extensionTitle: intl.formatMessage((0, $20ed47d9991fb6d4$export$a7357cdd1f0b0168).lozengeTitle),
            backgroundColor: (0, $f3dd73ebb486855e$export$617cdcc6afaae4f7),
            contentWidth: (0, $f3dd73ebb486855e$export$6cccba5fae1d609d)
        }
    }, $fa22ef03bf87464a$var$sectionContentNode(state, initialContentText));
};


const $8c3629cd1d541fcd$export$243f82fe09087876 = new (0, $ks2lK.PluginKey)('companyHubSectionCta');
const $8c3629cd1d541fcd$export$53e55076862e2785 = (state, pos)=>{
    const { schema: schema, doc: doc } = state;
    const $pos = doc.resolve(pos);
    const isParentDoc = $pos.parent.type === schema.nodes.doc;
    if (!isParentDoc) return false;
    const nodeBefore = $pos.nodeBefore;
    // The button should only appear at the start of the document or after section extensions.
    const isAtStart = !nodeBefore;
    const isAfterSectionExtension = nodeBefore?.attrs.extensionKey === 'hub-section' && nodeBefore?.attrs.extensionType === 'com.atlassian.confluence.hub-section';
    // The button should also appear at the very end of the document.
    const isAtEnd = !$pos.nodeAfter;
    return (isAtStart || isAfterSectionExtension || isAtEnd) && $pos.parent.canReplaceWith($pos.index(), $pos.index(), schema.nodes.multiBodiedExtension);
};
const $8c3629cd1d541fcd$var$createAnchorDecorations = (state)=>{
    const decs = [];
    const { doc: doc } = state;
    // A map of valid insertion positions to node info.
    const insertPositions = new Map();
    // 1. Check for an insertion point at the very start of the document.
    if ($8c3629cd1d541fcd$export$53e55076862e2785(state, 0)) {
        // It's the last position if the document is empty.
        const isLastPosition = doc.childCount === 0;
        insertPositions.set(0, {
            prevNodeTypeName: undefined,
            isLastPosition: isLastPosition
        });
    }
    // 2. Check for insertion points after each node in the document.
    doc.content.forEach((node, offset, index)=>{
        const insertPos = offset + node.nodeSize;
        if ($8c3629cd1d541fcd$export$53e55076862e2785(state, insertPos)) {
            const isLastPosition = index === doc.childCount - 1;
            insertPositions.set(insertPos, {
                prevNodeTypeName: node.type.name,
                isLastPosition: isLastPosition
            });
        }
    });
    // 3. Create decorations for all collected valid positions.
    insertPositions.forEach(({ prevNodeTypeName: prevNodeTypeName, isLastPosition: isLastPosition }, insertPos)=>{
        const anchorId = `section-cta-anchor-${insertPos}`;
        decs.push((0, $ftzrq.Decoration).widget(insertPos, ()=>{
            const anchorEl = document.createElement('span');
            anchorEl.style.cssText = `position: absolute; anchor-name: --${anchorId};`;
            anchorEl.setAttribute('data-section-cta-anchor-name', anchorId);
            return anchorEl;
        }, {
            key: anchorId,
            side: -1,
            anchorId: anchorId,
            prevNodeTypeName: prevNodeTypeName,
            isLastPosition: isLastPosition
        }));
    });
    return (0, $ftzrq.DecorationSet).create(doc, decs);
};
class $8c3629cd1d541fcd$var$SectionCtaPluginView {
    update(view, prevState) {
        this.view = view;
        this.anchorRectCache.setEditorView(this.view);
        // We re-render only if the decorations have changed - i.e. the user has modified top level nodes
        const oldState = $8c3629cd1d541fcd$export$243f82fe09087876.getState(prevState);
        const newState = $8c3629cd1d541fcd$export$243f82fe09087876.getState(view.state);
        if (oldState !== newState) {
            this.anchorRectCache.clear();
            this.renderButtons(view.state);
        }
    }
    destroy() {
        this.anchorRectCache.clear();
        this.root.unmount();
        this.container.remove();
    }
    renderButtons(state) {
        const decorationSet = $8c3629cd1d541fcd$export$243f82fe09087876.getState(state);
        if (!decorationSet) return;
        const handleClick = (insertPos)=>{
            const command = this.api?.companyHubSectionCtaPlugin?.commands?.insertSection(insertPos, this.intl);
            if (command) command(this.view.state, this.view.dispatch, this.view);
        };
        // Find all our anchor decorations
        const anchorDecos = decorationSet.find();
        this.root.render(/*#__PURE__*/ (0, $l998X.jsx)((0, $gmMgo.Provider), {
            value: this.intl,
            children: anchorDecos.map((deco)=>{
                const anchorId = deco.spec.anchorId;
                const insertPos = deco.from;
                const prevNodeTypeName = deco.spec.prevNodeTypeName;
                const isLastPosition = deco.spec.isLastPosition;
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $43c0e35ecb9920ae$export$e50c8b7ca0cd488e), {
                    anchorId: anchorId,
                    prevNodeTypeName: prevNodeTypeName,
                    isLastPosition: isLastPosition,
                    onClick: ()=>handleClick(insertPos),
                    anchorRectCache: this.anchorRectCache,
                    view: this.view
                }, anchorId);
            })
        }));
    }
    constructor(view, api, intl){
        this.view = void 0;
        this.container = void 0;
        this.root = void 0;
        this.api = void 0;
        this.intl = void 0;
        this.anchorRectCache = void 0;
        this.view = view;
        this.api = api;
        this.intl = intl;
        this.anchorRectCache = new (0, $5c15d883298a980d$export$e1d230f644ff05aa)();
        this.anchorRectCache.setEditorView(this.view);
        this.container = document.createElement('div');
        this.view.dom.parentElement?.appendChild(this.container);
        this.root = (0, (/*@__PURE__*/$parcel$interopDefault($2FNjD))).createRoot(this.container);
        this.renderButtons(this.view.state);
    }
}
const $8c3629cd1d541fcd$export$d82c0e619eaaa2c2 = ({ api: api })=>{
    return {
        name: 'companyHubSectionCtaPlugin',
        pmPlugins () {
            return [
                {
                    name: 'companyHubSectionCtaButton',
                    plugin: ({ getIntl: getIntl })=>{
                        const intl = getIntl();
                        return new (0, $1S4f7.SafePlugin)({
                            key: $8c3629cd1d541fcd$export$243f82fe09087876,
                            state: {
                                init (_, editorState) {
                                    return $8c3629cd1d541fcd$var$createAnchorDecorations(editorState);
                                },
                                apply (tr, oldDecs, newState) {
                                    return $8c3629cd1d541fcd$var$createAnchorDecorations(newState);
                                }
                            },
                            props: {
                                decorations (state) {
                                    // This makes the anchor decorations actually appear in the doc.
                                    return $8c3629cd1d541fcd$export$243f82fe09087876.getState(state);
                                }
                            },
                            view: (editorView)=>new $8c3629cd1d541fcd$var$SectionCtaPluginView(editorView, api, intl)
                        });
                    }
                }
            ];
        },
        commands: {
            insertSection: (position, intl)=>{
                return (state, dispatch)=>{
                    if (dispatch) {
                        const { tr: tr } = state;
                        const nodeToInsert = (0, $fa22ef03bf87464a$export$3cf963ab3631af75)(state, intl);
                        tr.insert(position, nodeToInsert);
                        const selection = (0, $ks2lK.NodeSelection).create(tr.doc, position);
                        tr.setSelection(selection);
                        dispatch(tr);
                    }
                    return true;
                };
            }
        }
    };
};



var $bupcf = parcelRequire("bupcf");


var $3ihIB = parcelRequire("3ihIB");


var $hr8mu = parcelRequire("hr8mu");


var $jmHSv = parcelRequire("jmHSv");


var $cpn0f = parcelRequire("cpn0f");


var $PJ00O = parcelRequire("PJ00O");


var $fi7Vj = parcelRequire("fi7Vj");


var $fPXRH = parcelRequire("fPXRH");


var $55skd = parcelRequire("55skd");


var $2E0F0 = parcelRequire("2E0F0");




parcelRequire("42omo");

const $30f00e6fa1b4cf3f$export$b5eca477c47c935a = ()=>{
    const components = [];
    const register = (blockMenuComponents)=>{
        blockMenuComponents.forEach((newComponent)=>{
            // Find if a component with the same key already exists
            const existingIndex = components.findIndex((comp)=>comp.key === newComponent.key);
            if (existingIndex !== -1) // Replace the existing component
            components[existingIndex] = newComponent;
            else // Add new component
            components.push(newComponent);
        });
    };
    return {
        register: register,
        components: components
    };
};



var $d925B = parcelRequire("d925B");


var $hWRJP = parcelRequire("hWRJP");





var $8m4tT = parcelRequire("8m4tT");




const $422f5af2e582b6ae$export$508727c68e01dec5 = (newTr, nodePos, targetType)=>{
    // Find the actual node that was transformed to get its positioning
    const transformedNodePos = newTr.doc.resolve(nodePos);
    const transformedNode = transformedNodePos.nodeAfter;
    if (!transformedNode) return newTr;
    // Check if target type is other than list, text, heading, blockquotes
    const isListNode = targetType === 'bulletList' || targetType === 'orderedList' || targetType === 'taskList';
    const isBlockquote = targetType === 'blockquote';
    const isContainer = [
        'panel',
        'expand',
        'codeBlock',
        'layoutSection'
    ].includes(targetType);
    if (isListNode || isBlockquote) {
        // For taskList, select all content within the list
        const textStart = transformedNodePos.pos + 1; // Inside the taskList
        const textEnd = transformedNodePos.pos + transformedNode.nodeSize - 1; // End of taskList content
        const textSelection = (0, $ks2lK.TextSelection).between(newTr.doc.resolve(textStart), newTr.doc.resolve(textEnd));
        return newTr.setSelection(textSelection);
    } else if (isContainer) {
        // Use NodeSelection for types other than list, text, heading, blockquotes
        const nodeSelection = (0, $ks2lK.NodeSelection).create(newTr.doc, transformedNodePos.pos);
        return newTr.setSelection(nodeSelection);
    }
    return newTr;
};



var $boKri = parcelRequire("boKri");


var $5SAOw = parcelRequire("5SAOw");


var $iD5M5 = parcelRequire("iD5M5");

var $4FFjp = parcelRequire("4FFjp");










const $cfdebf15105e07e3$export$a9e2e03e50da609d = (targetType, nodes)=>{
    switch(targetType){
        case 'heading1':
            return {
                nodeType: nodes.heading,
                attrs: {
                    level: 1
                }
            };
        case 'heading2':
            return {
                nodeType: nodes.heading,
                attrs: {
                    level: 2
                }
            };
        case 'heading3':
            return {
                nodeType: nodes.heading,
                attrs: {
                    level: 3
                }
            };
        case 'heading4':
            return {
                nodeType: nodes.heading,
                attrs: {
                    level: 4
                }
            };
        case 'heading5':
            return {
                nodeType: nodes.heading,
                attrs: {
                    level: 5
                }
            };
        case 'heading6':
            return {
                nodeType: nodes.heading,
                attrs: {
                    level: 6
                }
            };
        case 'paragraph':
            return {
                nodeType: nodes.paragraph
            };
        case 'blockquote':
            return {
                nodeType: nodes.blockquote
            };
        case 'expand':
            return {
                nodeType: nodes.expand
            };
        case 'panel':
            return {
                nodeType: nodes.panel,
                attrs: {
                    panelType: 'info'
                }
            };
        case 'codeBlock':
            return {
                nodeType: nodes.codeBlock
            };
        case 'bulletList':
            return {
                nodeType: nodes.bulletList
            };
        case 'orderedList':
            return {
                nodeType: nodes.orderedList
            };
        case 'taskList':
            return {
                nodeType: nodes.taskList
            };
        case 'layoutSection':
            return {
                nodeType: nodes.layoutSection
            };
        default:
            return null;
    }
};
const $cfdebf15105e07e3$export$1665e2275a3d717a = (node)=>{
    return [
        'paragraph',
        'heading',
        'codeBlock'
    ].includes(node.type.name);
};
const $cfdebf15105e07e3$export$3edba312cde09dde = (node)=>{
    return [
        'paragraph',
        'heading'
    ].includes(node.type.name);
};
const $cfdebf15105e07e3$export$a7d7d2b9ba4d4dbb = (node)=>{
    return [
        'bulletList',
        'orderedList',
        'taskList'
    ].includes(node.type.name);
};
const $cfdebf15105e07e3$export$5f94d2e4ba42a5c7 = (node)=>{
    return [
        'panel',
        'expand',
        'blockquote'
    ].includes(node.type.name);
};
const $cfdebf15105e07e3$export$d408678c021cd7ea = (nodeType)=>{
    return [
        'paragraph',
        'heading',
        'codeBlock'
    ].includes(nodeType.name);
};
const $cfdebf15105e07e3$export$4420be1ece169b6 = (nodeType)=>{
    return [
        'bulletList',
        'orderedList',
        'taskList'
    ].includes(nodeType.name);
};
const $cfdebf15105e07e3$export$849115f70b97842c = (nodeType)=>{
    return [
        'panel',
        'expand',
        'blockquote'
    ].includes(nodeType.name);
};
const $cfdebf15105e07e3$export$40ce0987b0df258c = (nodeType)=>{
    return nodeType.name === 'layoutSection';
};
const $cfdebf15105e07e3$export$a6a9bc90de7cbf3d = (node)=>{
    return node.type.name === 'layoutSection';
};
const $cfdebf15105e07e3$export$585a35852641b101 = (node)=>{
    const blockNodesForExtraction = [
        'table',
        'mediaSingle',
        'extension',
        'bodiedExtension',
        'blockCard',
        'embedCard'
    ];
    return blockNodesForExtraction.includes(node.type.name);
};
const $cfdebf15105e07e3$export$8e11e21255e483b1 = (targetNodeType)=>{
    return (node)=>{
        // Check if the target container type can contain this node
        try {
            return targetNodeType.validContent((0, $5SAOw.Fragment).from(node));
        } catch  {
            return false;
        }
    };
};
const $cfdebf15105e07e3$export$62a82724755d4945 = (node, schema)=>{
    // Extract text and inline nodes from any complex node
    const inlineNodes = [];
    node.descendants((childNode)=>{
        if (childNode.isText) inlineNodes.push(childNode);
        else if (childNode.isInline) inlineNodes.push(childNode);
        return true; // Continue traversing
    });
    // If no inline content was found but the node has text content,
    // create a text node with the full text content
    if (inlineNodes.length === 0 && node.textContent) return [
        schema.text(node.textContent)
    ];
    return inlineNodes;
};
const $cfdebf15105e07e3$export$67eaf7d8ed823877 = (content, targetNodeType)=>{
    const withValidMarks = [];
    content.forEach((node)=>{
        if (node.marks.length > 0) {
            const allowedMarks = targetNodeType.allowedMarks(node.marks);
            const updatedNode = node.mark(allowedMarks);
            withValidMarks.push(updatedNode);
        } else withValidMarks.push(node);
    });
    return (0, $5SAOw.Fragment).from(withValidMarks);
};
const $cfdebf15105e07e3$export$57ce4b649f0f2153 = (codeBlockNode, schema)=>{
    const paragraphNodes = [];
    const codeText = codeBlockNode.textContent;
    const lines = codeText.split('\n');
    lines.forEach((line)=>{
        const paragraphNode = schema.nodes.paragraph.create(null, line ? schema.text(line) : null);
        paragraphNodes.push(paragraphNode);
    });
    return paragraphNodes;
};
const $cfdebf15105e07e3$var$isBreakoutMarkSupported = (nodeType)=>{
    return [
        'codeBlock',
        'expand',
        'layoutSection'
    ].includes(nodeType.name);
};
const $cfdebf15105e07e3$export$bd208b4527240d24 = (sourceNode, targetNodeType)=>{
    const allowedMarks = targetNodeType.allowedMarks(sourceNode.marks);
    const sourceBreakoutMark = sourceNode.marks.find((mark)=>mark.type.name === 'breakout');
    if (sourceBreakoutMark && $cfdebf15105e07e3$var$isBreakoutMarkSupported(targetNodeType)) {
        // Check if breakout mark is already in allowedMarks to avoid duplicates
        const hasBreakoutMark = allowedMarks.some((mark)=>mark.type.name === 'breakout');
        return hasBreakoutMark ? allowedMarks : [
            ...allowedMarks,
            sourceBreakoutMark
        ];
    }
    return allowedMarks;
};
const $cfdebf15105e07e3$export$2cb3a3d130a876b7 = (from, to)=>{
    // Block node insertion: block-like elements inserted from empty line or wrapping text/list
    const blockNodes = [
        'panel',
        'expand',
        'codeBlock',
        'layoutSection',
        'taskList'
    ];
    const textNodes = [
        'paragraph',
        'blockquote'
    ];
    const headingNodes = [
        'heading1',
        'heading2',
        'heading3',
        'heading4',
        'heading5',
        'heading6'
    ];
    const listNodes = [
        'bulletList',
        'orderedList'
    ];
    // Check if converting to block nodes from text/heading/list nodes
    if (blockNodes.includes(to) && (textNodes.includes(from) || headingNodes.includes(from) || listNodes.includes(from))) return 'blockNodeInserted';
    // Check if converting from paragraph/blockquote to list
    if (listNodes.includes(to) && textNodes.includes(from)) return 'listInserted';
    // Check if converting from list to paragraph/heading/blockquote or between list types
    if (listNodes.includes(from) && (listNodes.includes(to) || textNodes.includes(to))) return 'listConverted';
    // Text formatting: conversions among paragraph/headings/blockquote
    if ((textNodes.includes(from) || headingNodes.includes(from)) && (textNodes.includes(to) || headingNodes.includes(to))) return 'textFormatted';
    // For other conversions, we do not have a matching event category
    return undefined;
};


const $1d8ffa42a72c82ca$export$1dd25037fa7d05ac = (sourceContent)=>{
    let validTransformedContent = '';
    const invalidContent = [];
    if (sourceContent.content.length < 1) return {
        inlineTextContent: '',
        invalidContent: invalidContent
    };
    // Headings are not valid inside headings so convert heading nodes to paragraphs
    sourceContent.forEach((node)=>{
        if ([
            'paragraph',
            'heading',
            'taskItem',
            'codeBlock'
        ].includes(node.type.name)) node.content.forEach((inlineNode)=>{
            if (inlineNode.type.name === 'status') validTransformedContent += inlineNode.attrs.text;
            else validTransformedContent += `${inlineNode.textContent}`;
        });
        else if (!(0, $cfdebf15105e07e3$export$4420be1ece169b6)(node.type)) invalidContent.push(node);
    });
    return {
        inlineTextContent: validTransformedContent,
        invalidContent: invalidContent
    };
};
const $1d8ffa42a72c82ca$export$e68c0af00a1f1abe = (sourceContent, schema)=>{
    const text = $1d8ffa42a72c82ca$export$1dd25037fa7d05ac(sourceContent).inlineTextContent;
    return schema.text(text);
};



const $77a09c7a67ee9a94$export$2f0459eee3cc6382 = (context, finalTargetNodeType)=>{
    const { tr: tr, sourceNode: sourceNode, targetNodeType: targetNodeType, targetAttrs: targetAttrs } = context;
    const schema = tr.doc.type.schema || {};
    const isValid = (0, $cfdebf15105e07e3$export$8e11e21255e483b1)(finalTargetNodeType);
    const createTextNode = (node)=>{
        const isTextNode = node.type.name === 'text';
        let nodeToTransform = node;
        if ((0, $cfdebf15105e07e3$export$849115f70b97842c)(finalTargetNodeType) || (0, $cfdebf15105e07e3$export$4420be1ece169b6)(finalTargetNodeType)) nodeToTransform = node.mark(node.marks.filter((mark)=>![
                'alignment',
                'indentation'
            ].includes(mark.type.name)));
        if (isValid(nodeToTransform) && !isTextNode) return nodeToTransform;
        return targetNodeType.createChecked(targetAttrs, isTextNode ? nodeToTransform : nodeToTransform.content, nodeToTransform.marks);
    };
    if ((0, $cfdebf15105e07e3$export$1665e2275a3d717a)(sourceNode)) {
        // code block acts like a container, we need to unwrap it
        if (sourceNode.type === schema.nodes.codeBlock) {
            const textNodes = sourceNode.textContent.split('\n').map((line)=>targetNodeType.createChecked(undefined, line ? schema.text(line) : null));
            return textNodes;
        }
        return [
            createTextNode(sourceNode)
        ];
    }
    if ((0, $cfdebf15105e07e3$export$5f94d2e4ba42a5c7)(sourceNode)) {
        const containerNodes = [];
        if (sourceNode.type.name === 'expand' && sourceNode.attrs?.title) containerNodes.push(createTextNode(schema.text(sourceNode.attrs.title)));
        sourceNode.content.forEach((childNode)=>{
            if ((0, $cfdebf15105e07e3$export$3edba312cde09dde)(childNode)) {
                containerNodes.push(createTextNode(childNode));
                return;
            }
            containerNodes.push(childNode);
        });
        return containerNodes;
    }
    if ((0, $cfdebf15105e07e3$export$a7d7d2b9ba4d4dbb)(sourceNode)) {
        if ((0, $cfdebf15105e07e3$export$d408678c021cd7ea)(finalTargetNodeType)) {
            if (sourceNode.type.name === 'taskList') {
                const taskItemsResult = (0, $8m4tT.findChildrenByType)(sourceNode, schema.nodes.taskItem);
                const taskItems = taskItemsResult.map((item)=>item.node);
                const taskItemFragments = taskItems.map((taskItem)=>taskItem.content);
                return taskItemFragments.map((fragment)=>targetNodeType.createChecked(targetAttrs, fragment.content));
            } else {
                const paragraphs = (0, $8m4tT.findChildrenByType)(sourceNode, schema.nodes.paragraph);
                const paragraphNodes = paragraphs.map((paragraph)=>paragraph.node);
                if (targetNodeType === schema.nodes.heading) return paragraphNodes.map((paragraphNode)=>targetNodeType.createChecked(targetAttrs, paragraphNode.content));
                return paragraphNodes;
            }
        }
        return [
            sourceNode
        ];
    }
    return [
        sourceNode
    ];
};
const $77a09c7a67ee9a94$var$transformToCodeBlock = (nodes, schema)=>{
    const newNodes = [];
    const addToNewNodes = (content)=>{
        if (newNodes.length === 0) newNodes.push({
            canBeTransformed: true,
            content: content
        });
        else {
            // Check if last node can also be transformed, if yes then append content
            const lastItem = newNodes[newNodes.length - 1];
            if (lastItem.canBeTransformed) newNodes[newNodes.length - 1] = {
                content: [
                    ...lastItem.content,
                    ...content
                ],
                canBeTransformed: true
            };
            else newNodes.push({
                content: content,
                canBeTransformed: true
            });
        }
    };
    nodes.forEach((node)=>{
        if (node.isTextblock) {
            const inlineTextContent = node.type === schema.nodes.codeBlock ? node.textContent : (0, $1d8ffa42a72c82ca$export$1dd25037fa7d05ac)((0, $5SAOw.Fragment).from(node)).inlineTextContent;
            addToNewNodes([
                inlineTextContent
            ]);
        } else if ((0, $cfdebf15105e07e3$export$a7d7d2b9ba4d4dbb)(node)) {
            const textContent = [];
            const listItemType = node.type === schema.nodes.taskList ? schema.nodes.taskItem : schema.nodes.listItem;
            const listItems = (0, $8m4tT.findChildrenByType)(node, listItemType).map((item)=>item.node);
            listItems.forEach((listItem)=>{
                if (listItem.type === schema.nodes.taskItem) {
                    const inlineTextContent = (0, $1d8ffa42a72c82ca$export$1dd25037fa7d05ac)((0, $5SAOw.Fragment).from(listItem)).inlineTextContent;
                    textContent.push(inlineTextContent);
                } else {
                    const inlineTextContent = (0, $1d8ffa42a72c82ca$export$1dd25037fa7d05ac)(listItem.content).inlineTextContent;
                    textContent.push(inlineTextContent);
                }
            });
            addToNewNodes(textContent);
        } else // If not text block or list node, then cannot be transformed
        newNodes.push({
            canBeTransformed: false,
            content: node
        });
    });
    return newNodes.map(({ canBeTransformed: canBeTransformed, content: content })=>{
        if (canBeTransformed) {
            const text = content.join('\n');
            if (text === '') return undefined;
            return schema.nodes.codeBlock.createChecked(null, schema.text(text));
        } else return content;
    }).filter(Boolean);
};
const $77a09c7a67ee9a94$var$transformToBlockNode = (nodes, targetNodeType, schema)=>{
    if (targetNodeType === schema.nodes.codeBlock) return $77a09c7a67ee9a94$var$transformToCodeBlock(nodes, schema);
    const newNodes = [];
    nodes.forEach((node)=>{
        if ((0, $cfdebf15105e07e3$export$a7d7d2b9ba4d4dbb)(node)) {
            const listItemType = node.type === schema.nodes.taskList ? schema.nodes.taskItem : schema.nodes.listItem;
            const listItems = (0, $8m4tT.findChildrenByType)(node, listItemType).map((item)=>item.node);
            listItems.forEach((listItem)=>{
                if (listItem.type === schema.nodes.taskItem) {
                    const inlineContent = [
                        ...listItem.content.content
                    ];
                    if (inlineContent.length > 0) newNodes.push(targetNodeType.createChecked(null, inlineContent));
                } else listItem.forEach((child)=>{
                    if ((0, $cfdebf15105e07e3$export$3edba312cde09dde)(child)) newNodes.push(targetNodeType.createChecked(null, [
                        ...child.content.content
                    ]));
                });
            });
        } else newNodes.push(node);
    });
    return newNodes;
};
const $77a09c7a67ee9a94$var$transformToContainerNode = (nodes, targetNodeType)=>{
    const newNodes = [];
    const isNodeValid = (0, $cfdebf15105e07e3$export$8e11e21255e483b1)(targetNodeType);
    nodes.forEach((node)=>{
        // If the node is not supported then we append as is
        if ((0, $cfdebf15105e07e3$export$585a35852641b101)(node)) newNodes.push({
            node: node,
            canBeTransformed: false
        });
        else {
            const isSameNodeType = node.type === targetNodeType;
            // If the node is not valid and not the same type, we cannot transform it
            if (!isNodeValid(node) && !isSameNodeType) {
                newNodes.push({
                    node: node,
                    canBeTransformed: false
                });
                return;
            }
            const nodes = isSameNodeType ? node.content.content : [
                node
            ];
            if (newNodes.length === 0) newNodes.push({
                node: nodes,
                canBeTransformed: true
            });
            else {
                const lastItem = newNodes[newNodes.length - 1];
                if (lastItem.canBeTransformed) newNodes[newNodes.length - 1] = {
                    node: [
                        ...lastItem.node,
                        ...nodes
                    ],
                    canBeTransformed: true
                };
                else newNodes.push({
                    node: nodes,
                    canBeTransformed: true
                });
            }
        }
    });
    return newNodes.map(({ node: node, canBeTransformed: canBeTransformed })=>{
        if (canBeTransformed) return targetNodeType.createChecked(null, (0, $5SAOw.Fragment).fromArray(node));
        else return node;
    });
};
const $77a09c7a67ee9a94$export$62d5f8706d1a448c = (nodes, targetNodeType, schema)=>{
    const isTargetTask = (0, $iD5M5.isTaskList)(targetNodeType);
    const listItems = [];
    const listItemType = isTargetTask ? schema.nodes.taskItem : schema.nodes.listItem;
    const unsupportedContent = [];
    const onhandleUnsupportedContent = (content)=>{
        unsupportedContent.push(content);
    };
    const isValid = (0, $cfdebf15105e07e3$export$8e11e21255e483b1)(listItemType);
    nodes.forEach((node)=>{
        // Append unsupported nodes as is
        if ((0, $cfdebf15105e07e3$export$585a35852641b101)(node)) listItems.push({
            canBeTransformed: false,
            node: node
        });
        else {
            let newListItems;
            // If the node is a list, we may need to transform it
            if ((0, $cfdebf15105e07e3$export$a7d7d2b9ba4d4dbb)(node)) {
                const isSourceBulletOrOrdered = (0, $iD5M5.isBulletOrOrderedList)(node.type);
                const isTargetTask = (0, $iD5M5.isTaskList)(targetNodeType);
                const isSourceTask = (0, $iD5M5.isTaskList)(node.type);
                const isTargetBulletOrOrdered = (0, $iD5M5.isBulletOrOrderedList)(targetNodeType);
                const supportedListTypes = (0, $iD5M5.getSupportedListTypesSet)(schema.nodes);
                if (node.type === targetNodeType) // For the same list type, we can keep the structure
                newListItems = node.content.content;
                else {
                    const newList = (0, $4FFjp.transformListRecursively)({
                        isSourceBulletOrOrdered: isSourceBulletOrOrdered,
                        isSourceTask: isSourceTask,
                        isTargetBulletOrOrdered: isTargetBulletOrOrdered,
                        isTargetTask: isTargetTask,
                        listNode: node,
                        schema: schema,
                        supportedListTypes: supportedListTypes,
                        targetNodeType: targetNodeType
                    }, onhandleUnsupportedContent);
                    newListItems = [
                        ...newList.content.content
                    ];
                }
            } else if ((0, $cfdebf15105e07e3$export$3edba312cde09dde)(node) || isValid(node)) {
                if (isTargetTask) {
                    const inlineContent = [
                        ...node.content.content
                    ];
                    if (inlineContent.length > 0) newListItems = [
                        listItemType.create(null, inlineContent)
                    ];
                } else newListItems = [
                    listItemType.create(null, node)
                ];
            } else if (!isValid(node)) listItems.push({
                canBeTransformed: false,
                node: node
            });
            if (newListItems) {
                if (listItems.length === 0) listItems.push({
                    canBeTransformed: true,
                    node: newListItems
                });
                else {
                    const lastItem = listItems[listItems.length - 1];
                    if (lastItem.canBeTransformed) listItems[listItems.length - 1] = {
                        node: [
                            ...lastItem.node,
                            ...newListItems
                        ],
                        canBeTransformed: true
                    };
                    else listItems.push({
                        node: newListItems,
                        canBeTransformed: true
                    });
                }
            }
        }
    });
    return [
        ...listItems.map(({ node: node, canBeTransformed: canBeTransformed })=>{
            if (canBeTransformed) return targetNodeType.createChecked(null, (0, $5SAOw.Fragment).fromArray(node));
            else return node;
        }),
        ...unsupportedContent
    ];
};
const $77a09c7a67ee9a94$export$5c5b2c532492f367 = (nodes, targetNodeType, schema, targetAttrs)=>{
    if (nodes.length === 1 && nodes[0].content.size === 0 && !(0, $cfdebf15105e07e3$export$849115f70b97842c)(targetNodeType)) {
        if ((0, $cfdebf15105e07e3$export$d408678c021cd7ea)(targetNodeType)) {
            if ([
                'heading',
                'paragraph'
            ].includes(targetNodeType.name)) return [
                targetNodeType.createChecked(targetAttrs)
            ];
            if (targetNodeType.name === 'codeBlock') return [
                targetNodeType.createChecked()
            ];
        }
        if ((0, $cfdebf15105e07e3$export$4420be1ece169b6)(targetNodeType)) {
            const listItem = (0, $iD5M5.isTaskList)(targetNodeType) ? schema.nodes.taskItem.createChecked() : schema.nodes.listItem.createChecked(null, schema.nodes.paragraph.createChecked());
            return [
                targetNodeType.createChecked(null, listItem)
            ];
        }
        return nodes;
    }
    if ((0, $cfdebf15105e07e3$export$d408678c021cd7ea)(targetNodeType)) return $77a09c7a67ee9a94$var$transformToBlockNode(nodes, targetNodeType, schema);
    if ((0, $cfdebf15105e07e3$export$849115f70b97842c)(targetNodeType)) return $77a09c7a67ee9a94$var$transformToContainerNode(nodes, targetNodeType);
    if ((0, $cfdebf15105e07e3$export$4420be1ece169b6)(targetNodeType)) return $77a09c7a67ee9a94$export$62d5f8706d1a448c(nodes, targetNodeType, schema);
    return [];
};



const $0e112dc22bdfddd5$export$24df8f7ba30643b8 = (schema, content, marks)=>{
    const { layoutSection: layoutSection, layoutColumn: layoutColumn, paragraph: paragraph } = schema.nodes;
    const layoutContent = (0, $5SAOw.Fragment).fromArray([
        layoutColumn.createChecked({
            width: (0, $boKri.DEFAULT_TWO_COLUMN_LAYOUT_COLUMN_WIDTH)
        }, content),
        layoutColumn.create({
            width: (0, $boKri.DEFAULT_TWO_COLUMN_LAYOUT_COLUMN_WIDTH)
        }, paragraph.createAndFill())
    ]);
    return layoutSection.createChecked(undefined, layoutContent, marks);
};
const $0e112dc22bdfddd5$export$74db2bafd1f977b0 = (context)=>{
    const { tr: tr, sourceNode: sourceNode, sourcePos: sourcePos } = context;
    const content = sourceNode.mark(sourceNode.marks.filter((mark)=>mark.type.name !== 'breakout'));
    // Layout supports breakout mark that can have width attribute
    // When other nodes with breakout (codeBlock and expand) are converted to a layout, the layout should get width of original node
    const marks = (0, $cfdebf15105e07e3$export$bd208b4527240d24)(sourceNode, tr.doc.type.schema.nodes.layoutSection);
    const layoutSectionNode = $0e112dc22bdfddd5$export$24df8f7ba30643b8(tr.doc.type.schema, content, marks);
    if ((0, $cfdebf15105e07e3$export$3edba312cde09dde)(sourceNode)) // -1 to fix when sourceNode is the last node in the document, unable to convert to layout
    tr.replaceRangeWith(sourcePos > 0 ? sourcePos - 1 : sourcePos, sourcePos + sourceNode.nodeSize - 1, layoutSectionNode);
    else tr.replaceRangeWith(sourcePos, sourcePos + sourceNode.nodeSize, layoutSectionNode);
    return tr;
};
const $0e112dc22bdfddd5$export$b4335274748f4fcd = (context)=>{
    const { tr: tr, sourceNode: sourceNode, targetNodeType: targetNodeType, sourcePos: sourcePos, targetAttrs: targetAttrs } = context;
    const schema = tr.doc.type.schema || {};
    const { layoutSection: layoutSection, layoutColumn: layoutColumn, paragraph: paragraph, heading: heading } = schema.nodes || {};
    const layoutColumnNodes = [];
    const targetTextNodeType = targetNodeType === heading ? heading : paragraph;
    sourceNode.children.forEach((child)=>{
        if (child.type === layoutColumn) {
            const unwrappedContent = [];
            child.content.forEach((node)=>{
                // Unwrap all nodes and convert to text nodes
                const context = {
                    tr: tr,
                    sourceNode: node,
                    targetNodeType: targetTextNodeType,
                    sourcePos: 0,
                    targetAttrs: targetAttrs
                };
                const newContent = (0, $77a09c7a67ee9a94$export$2f0459eee3cc6382)(context, targetNodeType);
                unwrappedContent.push(...newContent);
            });
            const newColumnContent = (0, $77a09c7a67ee9a94$export$5c5b2c532492f367)(unwrappedContent, targetNodeType, schema, targetAttrs);
            layoutColumnNodes.push(layoutColumn.createChecked(child.attrs, (0, $5SAOw.Fragment).fromArray(newColumnContent), child.marks));
        }
    });
    return tr.replaceRangeWith(sourcePos, sourcePos + sourceNode.nodeSize, layoutSection.createChecked(sourceNode.attrs, (0, $5SAOw.Fragment).fromArray(layoutColumnNodes), sourceNode.marks));
};










const $177665f91cdbd860$var$convertInvalidNodeToValidNodeType = (sourceContent, sourceNodeType, validNodeType, withMarks)=>{
    const validTransformedContent = [];
    // Headings are not valid inside headings so convert heading nodes to paragraphs
    sourceContent.forEach((node)=>{
        if (sourceNodeType === node.type) validTransformedContent.push(validNodeType.createChecked(node.attrs, node.content, withMarks ? node.marks : undefined));
        else validTransformedContent.push(node);
    });
    return (0, $5SAOw.Fragment).from(validTransformedContent);
};
const $177665f91cdbd860$export$3230cff5cca320fb = ({ tr: tr, sourceNode: sourceNode, targetNodeType: targetNodeType, targetAttrs: targetAttrs })=>{
    const selection = tr.selection;
    const schema = tr.doc.type.schema;
    const content = selection.content().content;
    let transformedContent = content;
    let marks = [];
    if (sourceNode.type === schema.nodes.codeBlock) {
        const paragraphNodes = (0, $cfdebf15105e07e3$export$57ce4b649f0f2153)(sourceNode, schema);
        transformedContent = (0, $5SAOw.Fragment).fromArray(paragraphNodes);
        marks = (0, $cfdebf15105e07e3$export$bd208b4527240d24)(sourceNode, targetNodeType);
    }
    if (targetNodeType === schema.nodes.blockquote) transformedContent = $177665f91cdbd860$var$convertInvalidNodeToValidNodeType(transformedContent, schema.nodes.heading, schema.nodes.paragraph, true);
    // Preserve marks that are allowed in the target node type
    // e.g. blocks (heading/ paragraph) with alignment need to remove alignment
    // as panel/ blockQuote/ expands does not support alignment
    if (sourceNode.type === schema.nodes.paragraph || sourceNode.type === schema.nodes.heading) transformedContent = (0, $cfdebf15105e07e3$export$67eaf7d8ed823877)(transformedContent, targetNodeType);
    const newNode = targetNodeType.createAndFill(targetAttrs, transformedContent, marks);
    if (!newNode) return null;
    tr.replaceRangeWith(selection.from, selection.to, newNode);
    return tr;
};
const $177665f91cdbd860$export$697cfbabf5d9e1ba = ({ tr: tr, sourceNode: sourceNode, sourcePos: sourcePos, targetNodeType: targetNodeType, targetAttrs: targetAttrs })=>{
    if (sourcePos === null) return null;
    // Transform container to block type - unwrap and convert content
    if ((0, $cfdebf15105e07e3$export$d408678c021cd7ea)(targetNodeType)) {
        // special case container to codeblock
        if (targetNodeType.name === 'codeBlock') return $177665f91cdbd860$export$1d1c915cd8929a09({
            tr: tr,
            sourceNode: sourceNode,
            sourcePos: sourcePos,
            targetNodeType: targetNodeType,
            targetAttrs: targetAttrs
        });
        return $177665f91cdbd860$export$5a68d77ddd9b434a({
            tr: tr,
            sourceNode: sourceNode,
            sourcePos: sourcePos,
            targetNodeType: targetNodeType,
            targetAttrs: targetAttrs
        });
    }
    // Transform container to list type
    if ((0, $cfdebf15105e07e3$export$4420be1ece169b6)(targetNodeType)) return $177665f91cdbd860$export$6fff4a20515e068e({
        tr: tr,
        sourceNode: sourceNode,
        sourcePos: sourcePos,
        targetNodeType: targetNodeType,
        targetAttrs: targetAttrs
    });
    // Transform between container types
    if ((0, $cfdebf15105e07e3$export$849115f70b97842c)(targetNodeType)) return $177665f91cdbd860$export$1d1c915cd8929a09({
        tr: tr,
        sourceNode: sourceNode,
        sourcePos: sourcePos,
        targetNodeType: targetNodeType,
        targetAttrs: targetAttrs
    });
    return null;
};
const $177665f91cdbd860$export$5a68d77ddd9b434a = (context)=>{
    const { tr: tr, targetNodeType: targetNodeType, targetAttrs: targetAttrs, sourceNode: sourceNode, sourcePos: sourcePos } = context;
    const { selection: selection } = tr;
    const schema = selection.$from.doc.type.schema;
    const { paragraph: paragraph, heading: heading, codeBlock: codeBlock, expand: expand } = schema.nodes;
    const rangeStart = sourcePos !== null ? sourcePos : selection.from;
    let sourceChildren = [
        ...sourceNode.children
    ];
    let transformedContent = [];
    // If the container is expand, we need to extract the title and convert it to a paragraph
    // and add it to the beginning of the content
    if (sourceNode.type === expand) {
        const title = sourceNode.attrs?.title;
        if (title) {
            const titleContent = schema.text(title);
            sourceChildren.unshift(paragraph.createChecked({}, titleContent));
        }
    }
    // if the container is a code block, convert text content to multiple paragraphs
    if (sourceNode.type === codeBlock) sourceChildren = (0, $cfdebf15105e07e3$export$57ce4b649f0f2153)(sourceNode, schema);
    // if target node is a paragraph, just do unwrap
    if (targetNodeType === paragraph) transformedContent = sourceChildren;
    // if target node is a headings, do unwrap and convert to heading
    if (targetNodeType === heading && targetAttrs) {
        const targetHeadingLevel = targetAttrs.level;
        sourceChildren.forEach((node, index)=>{
            if (node.isTextblock) {
                const headingNode = heading.create({
                    level: targetHeadingLevel
                }, node.content);
                sourceChildren[index] = headingNode;
            }
        });
        transformedContent = sourceChildren;
    }
    // if target node is code block, do unwrap and convert to code block
    if (targetNodeType === codeBlock) {
        const codeBlockContent = sourceChildren.map((node)=>node.content.textBetween(0, node.content.size, '\n')).join('\n');
        const marks = (0, $cfdebf15105e07e3$export$bd208b4527240d24)(sourceNode, targetNodeType);
        transformedContent = [
            codeBlock.createChecked({}, schema.text(codeBlockContent), marks)
        ];
    }
    const slice = new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).fromArray(transformedContent), 0, 0);
    tr.replaceRange(rangeStart, rangeStart + sourceNode.nodeSize, slice);
    return tr;
};
const $177665f91cdbd860$export$6fff4a20515e068e = ({ tr: tr, sourceNode: sourceNode, sourcePos: sourcePos, targetNodeType: targetNodeType, targetAttrs: targetAttrs })=>{
    const { schema: schema } = tr.doc.type;
    const { listItem: listItem, paragraph: paragraph, taskList: taskList, taskItem: taskItem, heading: heading } = schema.nodes;
    const isTargetTaskList = targetNodeType === taskList;
    const createListItemFromInline = (content)=>{
        if (!content) return isTargetTaskList ? taskItem.create() : listItem.create(null, paragraph.create());
        else return isTargetTaskList ? taskItem.create(null, content) : listItem.create(null, paragraph.create(null, content));
    };
    const getInlineContent = (textblock)=>{
        const inlineContent = [];
        textblock.forEach((inline)=>{
            inlineContent.push(inline);
        });
        return inlineContent;
    };
    const resultContent = [];
    let currentListItems = [];
    const targetListItemType = isTargetTaskList ? taskItem : listItem;
    // Expand's title should become the first item of the list
    if (sourceNode.type.name === 'expand') {
        const title = sourceNode.attrs?.title;
        if (title) {
            const titleContent = schema.text(title);
            currentListItems.push(createListItemFromInline(titleContent));
        }
    }
    const createListAndAddToContent = ()=>{
        if (currentListItems.length) {
            const currentList = targetNodeType.create(targetAttrs || null, (0, $5SAOw.Fragment).from(currentListItems));
            currentListItems = [];
            resultContent.push(currentList);
        }
    };
    if (sourceNode.type.name === 'codeBlock') {
        const codeText = sourceNode.textContent;
        // check if code block only contains newline characters
        // eslint-disable-next-line require-unicode-regexp
        const isOnlyNewLines = (codeText)=>codeText.replace(/\n/g, '').trim() === '';
        if (!codeText || isOnlyNewLines(codeText)) // Empty code block - create an empty list item
        currentListItems.push(createListItemFromInline());
        if (codeText) {
            const lines = codeText.split('\n');
            // Remove empty lines
            const nonEmptyLines = lines.filter((line)=>line.trim().length > 0);
            nonEmptyLines.forEach((line)=>{
                const lineText = schema.text(line);
                currentListItems.push(createListItemFromInline(lineText));
            });
        }
    } else sourceNode.forEach((child)=>{
        if (targetListItemType.validContent((0, $5SAOw.Fragment).from(child))) currentListItems.push(targetListItemType.create(null, child));
        else if (heading === child.type || isTargetTaskList && paragraph === child.type) {
            const inline = (0, $5SAOw.Fragment).from(getInlineContent(child));
            currentListItems.push(createListItemFromInline(inline));
        } else {
            // Create list and add list first
            createListAndAddToContent();
            // Then add content that can't be converted into listItem
            resultContent.push(child);
        }
    });
    if (!resultContent.length && !currentListItems.length) return null;
    createListAndAddToContent();
    return tr.replaceWith(sourcePos, sourcePos + sourceNode.nodeSize, (0, $5SAOw.Fragment).from(resultContent));
};
const $177665f91cdbd860$export$1d1c915cd8929a09 = (context)=>{
    const { tr: tr, sourceNode: sourceNode, sourcePos: sourcePos, targetNodeType: targetNodeType, targetAttrs: targetAttrs } = context;
    // Special handling for codeBlock target
    if (targetNodeType.name === 'codeBlock') {
        const contentSplits = $177665f91cdbd860$var$splitContentForCodeBlock(sourceNode, targetNodeType, targetAttrs, tr.doc.type.schema);
        if (contentSplits.length === 0) {
            const { schema: schema } = tr.doc.type;
            const marks = (0, $cfdebf15105e07e3$export$bd208b4527240d24)(sourceNode, targetNodeType);
            const codeBlock = schema.nodes.codeBlock.create(targetAttrs, null, marks);
            return tr.replaceWith(sourcePos, sourcePos + sourceNode.nodeSize, codeBlock);
        }
        return $177665f91cdbd860$var$applySplitsToTransaction(tr, sourcePos, sourceNode.nodeSize, contentSplits);
    }
    // Get content validation for target container type
    const isContentSupported = (0, $cfdebf15105e07e3$export$8e11e21255e483b1)(targetNodeType);
    // Process content and collect splits
    const contentSplits = $177665f91cdbd860$var$splitContentAroundUnsupportedBlocks(sourceNode, isContentSupported, targetNodeType, targetAttrs, tr.doc.type.schema);
    return $177665f91cdbd860$var$applySplitsToTransaction(tr, sourcePos, sourceNode.nodeSize, contentSplits);
};
/**
 * Apply content splits to transaction - shared utility for replacing and inserting splits
 */ const $177665f91cdbd860$var$applySplitsToTransaction = (tr, sourcePos, sourceNodeSize, contentSplits)=>{
    let insertPos = sourcePos;
    contentSplits.forEach((splitNode, index)=>{
        if (index === 0) {
            // Replace the original node with the first split
            tr.replaceWith(sourcePos, sourcePos + sourceNodeSize, splitNode);
            insertPos = sourcePos + splitNode.nodeSize;
        } else {
            // Insert additional splits after
            tr.insert(insertPos, splitNode);
            insertPos += splitNode.nodeSize;
        }
    });
    return tr;
};
/**
 * Split content for codeBlock transformation, creating codeBlocks for text content
 * and preserving unsupported blocks (like tables) separately
 */ const $177665f91cdbd860$var$splitContentForCodeBlock = (sourceNode, targetNodeType, targetAttrs, schema)=>{
    const splits = [];
    const children = sourceNode.content.content;
    let currentTextContent = [];
    const invalidContent = [];
    // Handle expand title - add as first text if source is expand with title
    if (sourceNode.type.name === 'expand' && sourceNode.attrs?.title) currentTextContent.push(sourceNode.attrs.title);
    const flushCurrentCodeBlock = ()=>{
        if (currentTextContent.length > 0) {
            const codeText = currentTextContent.join('\n');
            const marks = (0, $cfdebf15105e07e3$export$bd208b4527240d24)(sourceNode, targetNodeType);
            const codeBlockNode = targetNodeType.create(targetAttrs, schema.text(codeText), marks);
            splits.push(codeBlockNode);
            currentTextContent = [];
        }
    };
    const isCodeBlockCompatible = (node)=>{
        // Only text blocks (paragraph, heading) can be converted to codeBlock text
        return node.isTextblock || node.type.name === 'codeBlock';
    };
    children.forEach((childNode)=>{
        if (isCodeBlockCompatible(childNode)) {
            // Extract text content from compatible nodes
            if (childNode.type.name === 'codeBlock') // If it's already a codeBlock, extract its text
            currentTextContent.push(childNode.textContent);
            else if (childNode.isTextblock) {
                // Extract text from text blocks (paragraphs, headings, etc.)
                const text = (0, $1d8ffa42a72c82ca$export$1dd25037fa7d05ac)((0, $5SAOw.Fragment).from(childNode)).inlineTextContent;
                if (text.trim()) currentTextContent.push(text);
            }
        } else if ((0, $cfdebf15105e07e3$export$585a35852641b101)(childNode)) {
            // Unsupported block node (table, etc.) - flush current codeBlock, add block, continue
            flushCurrentCodeBlock();
            splits.push(childNode);
        } else if ((0, $cfdebf15105e07e3$export$4420be1ece169b6)(childNode.type)) {
            const isTaskList = childNode.type.name === 'taskList';
            const listItemType = isTaskList ? childNode.type.schema.nodes.taskItem : childNode.type.schema.nodes.listItem;
            const listItems = (0, $8m4tT.findChildrenByType)(childNode, listItemType);
            listItems.forEach((listItem)=>{
                const content = isTaskList ? (0, $5SAOw.Fragment).from(listItem.node) : listItem.node.content;
                const inlineContent = (0, $1d8ffa42a72c82ca$export$1dd25037fa7d05ac)(content);
                if (inlineContent.inlineTextContent.trim()) currentTextContent.push(inlineContent.inlineTextContent);
                if (inlineContent.invalidContent.length > 0) invalidContent.push(...inlineContent.invalidContent);
            });
        } else {
            // Other unsupported content - try to extract text if possible
            const text = childNode.textContent;
            if (text && text.trim()) currentTextContent.push(text);
        }
    });
    // Flush any remaining text content as a codeBlock
    flushCurrentCodeBlock();
    return [
        ...splits,
        ...invalidContent
    ];
};
/**
 * Split content around unsupported block nodes, creating separate containers
 * for content before and after each unsupported block
 */ const $177665f91cdbd860$var$splitContentAroundUnsupportedBlocks = (sourceNode, isContentSupported, targetNodeType, targetAttrs, schema)=>{
    const splits = [];
    const children = sourceNode.content.content;
    let currentContainerContent = [];
    // Handle expand title - add as first paragraph if source is expand with title
    if (sourceNode.type.name === 'expand' && sourceNode.attrs?.title) {
        const titleParagraph = schema.nodes.paragraph.create({}, schema.text(sourceNode.attrs.title));
        currentContainerContent.push(titleParagraph);
    }
    const flushCurrentContainer = ()=>{
        if (currentContainerContent.length > 0) {
            const marks = (0, $cfdebf15105e07e3$export$bd208b4527240d24)(sourceNode, targetNodeType);
            const containerNode = targetNodeType.create(targetAttrs, (0, $5SAOw.Fragment).fromArray(currentContainerContent), marks);
            splits.push(containerNode);
            currentContainerContent = [];
        }
    };
    children.forEach((childNode)=>{
        if (isContentSupported(childNode)) // Supported content - add to current container
        currentContainerContent.push(childNode);
        else if (childNode.type.name === targetNodeType.name) // Same type of container merge contents
        childNode.content.forEach((child)=>{
            currentContainerContent.push(child);
        });
        else if (childNode.isBlock) {
            // Unsupported block node - flush current container, add block, continue
            flushCurrentContainer();
            splits.push(childNode);
        } else {
            // Unsupported inline content - convert to paragraph and add to container
            const inlineContent = (0, $cfdebf15105e07e3$export$62a82724755d4945)(childNode, schema);
            if (inlineContent.length > 0) {
                const paragraph = schema.nodes.paragraph.create({}, (0, $5SAOw.Fragment).fromArray(inlineContent));
                currentContainerContent.push(paragraph);
            }
        }
    });
    // Flush any remaining container content
    flushCurrentContainer();
    return splits;
};












var $aXG5V = parcelRequire("aXG5V");









const $6f12bb99ce774886$export$6df506163cc077dc = (context)=>{
    const { tr: tr, targetNodeType: targetNodeType, targetAttrs: targetAttrs, sourceNode: sourceNode, sourcePos: sourcePos } = context;
    const { selection: selection } = tr;
    const schema = selection.$from.doc.type.schema;
    const targetNodes = [];
    // find all list items inside the list node
    const listItems = (0, $8m4tT.findChildrenByType)(sourceNode, schema.nodes.listItem);
    let textContent = [];
    const flushTextContent = ()=>{
        if (targetNodeType !== schema.nodes.codeBlock) return;
        if (textContent.length > 0) {
            const inlineText = textContent.join('\n');
            targetNodes.push(schema.nodes.codeBlock.createChecked({}, inlineText !== '' ? schema.text(inlineText) : null));
            textContent = [];
        }
    };
    listItems.forEach((listItem)=>{
        // Convert paragraphs to headings if target is heading
        const content = listItem.node.content.content;
        content.forEach((node)=>{
            const isValid = (0, $cfdebf15105e07e3$export$8e11e21255e483b1)(targetNodeType)(node);
            if ((0, $cfdebf15105e07e3$export$a7d7d2b9ba4d4dbb)(node)) // Skip nested lists as it will return listItems that we will deal with separately
            return;
            // Deal with the case where targetNode and node are both codeBlocks, then append text content
            if (targetNodeType === schema.nodes.codeBlock && node.type === schema.nodes.codeBlock) {
                const inlineContent = node.textContent;
                textContent = [
                    ...textContent,
                    inlineContent
                ];
                return;
            }
            // If the node is not valid for the target container,
            // flush any existing text content if target is codeBlock
            // and extract the node without any conversion
            if (!isValid && !node.isTextblock) {
                flushTextContent();
                targetNodes.push(node);
                return;
            }
            // If the target is codeBlock, accumulate text content
            if (targetNodeType === schema.nodes.codeBlock) {
                const inlineContent = (0, $1d8ffa42a72c82ca$export$1dd25037fa7d05ac)((0, $5SAOw.Fragment).from(node)).inlineTextContent;
                textContent = [
                    ...textContent,
                    inlineContent
                ];
                return;
            }
            // Convert codeblocks to block nodes
            if (node.type === schema.nodes.codeBlock) {
                const textContent = node.textContent.split('\n');
                const attributes = targetNodeType === schema.nodes.heading ? {
                    level: targetAttrs?.level ?? 1
                } : null;
                textContent.forEach((textLine)=>{
                    targetNodes.push(targetNodeType.createChecked(attributes, textLine ? schema.text(textLine) : null));
                });
                return;
            }
            if (targetNodeType === schema.nodes.heading && targetAttrs) {
                const targetHeadingLevel = targetAttrs.level;
                targetNodes.push(schema.nodes.heading.createChecked({
                    level: targetHeadingLevel
                }, node.content));
                return;
            }
            targetNodes.push(node);
        });
    });
    flushTextContent();
    const fragment = (0, $5SAOw.Fragment).fromArray(targetNodes);
    const slice = new (0, $5SAOw.Slice)(fragment, 0, 0);
    const rangeStart = sourcePos !== null ? sourcePos : selection.from;
    tr.replaceRange(rangeStart, rangeStart + sourceNode.nodeSize, slice);
    return tr;
};








const $cc97948e03a32b0f$export$d9cdacbed7444a4a = (context)=>{
    const { tr: tr, targetNodeType: targetNodeType, targetAttrs: targetAttrs, sourceNode: sourceNode, sourcePos: sourcePos } = context;
    const { selection: selection } = tr;
    const schema = selection.$from.doc.type.schema;
    const taskItemsResult = (0, $8m4tT.findChildrenByType)(sourceNode, schema.nodes.taskItem);
    const taskItems = taskItemsResult.map((item)=>item.node);
    const taskItemFragments = taskItems.map((taskItem)=>taskItem.content);
    let targetNodes = [];
    // Convert fragments to headings if target is heading
    if (targetNodeType === schema.nodes.heading && targetAttrs) {
        // convert the fragments to headings
        const targetHeadingLevel = targetAttrs.level;
        targetNodes = taskItemFragments.map((fragment)=>schema.nodes.heading.createChecked({
                level: targetHeadingLevel
            }, fragment.content));
    }
    // Convert fragments to paragraphs if target is paragraphs
    if (targetNodeType === schema.nodes.paragraph) // convert the fragments to paragraphs
    targetNodes = taskItemFragments.map((fragment)=>schema.nodes.paragraph.createChecked({}, fragment.content));
    // Convert fragments to code block if target is code block
    if (targetNodeType === schema.nodes.codeBlock) {
        // convert the fragments to one code block
        const codeBlockContent = taskItemFragments.map((fragment)=>fragment.textBetween(0, fragment.size, '\n')).join('\n');
        targetNodes = [
            schema.nodes.codeBlock.createChecked({}, schema.text(codeBlockContent))
        ];
    }
    // Replace the task list node with the new content in the transaction
    const slice = new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).fromArray(targetNodes), 0, 0);
    const rangeStart = sourcePos !== null ? sourcePos : selection.from;
    tr.replaceRange(rangeStart, rangeStart + sourceNode.nodeSize, slice);
    return tr;
};


const $443a7d9b1b98e038$export$201fb3474673bbf3 = (tr, range, targetNodeType, targetAttrs, nodes)=>{
    try {
        const { taskItem: taskItem } = nodes;
        const listItems = [];
        // Process each block in the range
        tr.doc.nodesBetween(range.start, range.end, (node)=>{
            if (node.isBlock) {
                // For block nodes like paragraphs, directly use their inline content
                const inlineContent = [
                    ...node.content.content
                ];
                if (inlineContent.length > 0) {
                    // Create task item with inline content directly
                    const listItem = taskItem.create(targetAttrs, inlineContent);
                    listItems.push(listItem);
                }
            }
            return false; // Don't traverse into children
        });
        if (listItems.length === 0) return null;
        // Create the new task list
        const newList = targetNodeType.create(targetAttrs, listItems);
        // Replace the range with the new list
        tr.replaceWith(range.start, range.end, newList);
        return tr;
    } catch  {
        return null;
    }
};



const $64a74916bcfa221f$export$ee4213d16d5f3389 = (context)=>{
    const { tr: tr, sourceNode: sourceNode, targetNodeType: targetNodeType, targetAttrs: targetAttrs } = context;
    const { $from: $from, $to: $to } = tr.selection;
    const schema = tr.doc.type.schema;
    const range = $from.blockRange($to);
    if (!range) return null;
    const { nodes: nodes } = tr.doc.type.schema;
    const isTargetTask = (0, $iD5M5.isTaskList)(targetNodeType);
    // Handle task lists differently due to their structure
    if (isTargetTask) return (0, $443a7d9b1b98e038$export$201fb3474673bbf3)(tr, range, targetNodeType, targetAttrs, nodes);
    // filter marks that are not allowed in the target node type
    if (sourceNode.type === schema.nodes.paragraph || sourceNode.type === schema.nodes.heading) {
        const allowedMarks = targetNodeType.allowedMarks(sourceNode.marks);
        tr.setNodeMarkup(range.start, null, null, allowedMarks);
    }
    // For headings, convert to paragraph first since headings cannot be direct children of list items
    if (sourceNode && sourceNode.type.name.startsWith('heading')) tr.setBlockType(range.start, range.end, nodes.paragraph);
    // Get the current range (updated if we converted from heading)
    const currentRange = tr.selection.$from.blockRange(tr.selection.$to) || range;
    // Wrap in the target list type
    const wrapping = (0, $aXG5V.findWrapping)(currentRange, targetNodeType, targetAttrs);
    if (!wrapping) return null;
    tr.wrap(currentRange, wrapping);
    return tr;
};
const $64a74916bcfa221f$export$734171e07083fa = (context)=>{
    const { sourceNode: sourceNode } = context;
    if (sourceNode.type.name === 'taskList') return (0, $cc97948e03a32b0f$export$d9cdacbed7444a4a)(context);
    else return (0, $6f12bb99ce774886$export$6df506163cc077dc)(context);
};
const $64a74916bcfa221f$export$18dae09713eeb305 = (context)=>{
    const { tr: tr, sourceNode: sourceNode, sourcePos: sourcePos, targetNodeType: targetNodeType, targetAttrs: targetAttrs } = context;
    if (sourcePos === null) return null;
    const { schema: schema } = tr.doc.type;
    const { blockquote: blockquote, taskList: taskList, taskItem: taskItem, paragraph: paragraph } = schema.nodes;
    // Special case: Task list -> Blockquote
    // Flattens the task list before wrapping by blockquote
    if (sourceNode.type === taskList && targetNodeType === blockquote) {
        const extractParagraphsFromTaskList = (node)=>{
            const paragraphs = [];
            node.forEach((child)=>{
                if (child.type === taskItem) {
                    if (child.content.size > 0) {
                        const paragraphNode = paragraph.createChecked({}, child.content.content);
                        paragraphs.push(paragraphNode);
                    }
                } else if (child.type === taskList) paragraphs.push(...extractParagraphsFromTaskList(child));
            });
            return paragraphs;
        };
        const liftedParagraphs = extractParagraphsFromTaskList(sourceNode);
        const containerNode = targetNodeType.createAndFill(targetAttrs, (0, $5SAOw.Fragment).from(liftedParagraphs));
        if (!containerNode) return null;
        tr.replaceWith(sourcePos, sourcePos + sourceNode.nodeSize, containerNode);
        return tr;
    }
    // Default case
    const containerNode = targetNodeType.createAndFill(targetAttrs, [
        sourceNode
    ]);
    if (!containerNode) return null;
    tr.replaceWith(sourcePos, sourcePos + sourceNode.nodeSize, containerNode);
    return tr;
};
const $64a74916bcfa221f$export$61ea3525eb3e8269 = (context)=>{
    const { targetNodeType: targetNodeType } = context;
    // Transform list to block type
    if ((0, $cfdebf15105e07e3$export$d408678c021cd7ea)(targetNodeType)) // Lift list items out of the list and convert to target block type
    return $64a74916bcfa221f$export$734171e07083fa(context);
    // Transform list to container type
    if ((0, $cfdebf15105e07e3$export$849115f70b97842c)(targetNodeType)) // Wrap list items into container type, where possible
    return $64a74916bcfa221f$export$18dae09713eeb305(context);
    // Transform between list types
    if ((0, $cfdebf15105e07e3$export$4420be1ece169b6)(targetNodeType)) return (0, $4FFjp.transformBetweenListTypes)(context);
    return null;
};
const $64a74916bcfa221f$export$c3a42a15c11faaab = ()=>{
    // Convert to target block type directly
    return null;
}; // transformBetweenListTypes is now imported from @atlaskit/editor-common/transforms



const $83e242229fd35f72$export$6554acda61c275ad = (context)=>{
    const { targetNodeType: targetNodeType } = context;
    // Handle transformation to list types
    if ((0, $cfdebf15105e07e3$export$4420be1ece169b6)(targetNodeType)) return (0, $64a74916bcfa221f$export$ee4213d16d5f3389)(context);
    // Handle transformation to container types (panel, expand, blockquote)
    if ((0, $cfdebf15105e07e3$export$849115f70b97842c)(targetNodeType)) return (0, $177665f91cdbd860$export$3230cff5cca320fb)(context);
    // Handle block type transformation (paragraph, heading, codeblock)
    if ((0, $cfdebf15105e07e3$export$d408678c021cd7ea)(targetNodeType)) return $83e242229fd35f72$var$transformToBlockNode(context);
    return null;
};
const $83e242229fd35f72$var$transformToBlockNode = (context)=>{
    const { tr: tr, targetNodeType: targetNodeType, targetAttrs: targetAttrs, sourceNode: sourceNode } = context;
    const { selection: selection, doc: doc } = tr;
    const { $from: $from, $to: $to } = selection;
    const schema = doc.type.schema;
    if (targetNodeType === schema.nodes.codeBlock) {
        const textContent = (0, $1d8ffa42a72c82ca$export$e68c0af00a1f1abe)(selection.content().content, schema);
        const node = schema.nodes.codeBlock.createChecked(undefined, textContent);
        return tr.replaceRangeWith(selection.from, selection.to, node);
    }
    // code block acts like a container, we need to unwrap it
    if (sourceNode.type === schema.nodes.codeBlock) return (0, $177665f91cdbd860$export$5a68d77ddd9b434a)(context);
    tr.setBlockType($from.pos, $to.pos, targetNodeType, targetAttrs);
    return tr;
};






function $78bd9f1fc1f25c0b$export$87cb0fc792d31ea8(tr, sourceNode, sourcePos, targetType) {
    const { nodes: nodes } = tr.doc.type.schema;
    const targetNodeInfo = (0, $cfdebf15105e07e3$export$a9e2e03e50da609d)(targetType, nodes);
    if (!targetNodeInfo) return null;
    const { nodeType: targetNodeType, attrs: targetAttrs } = targetNodeInfo;
    // Early return if trying to transform to the same type
    if (sourceNode.type.name === targetNodeType.name) {
        // For headings, also check if the level matches
        if (targetNodeType.name === 'heading') {
            const sourceLevel = sourceNode.attrs?.level;
            const targetLevel = targetAttrs?.level;
            if (sourceLevel === targetLevel) return tr;
        } else return tr;
    }
    // Prepare transformation context
    const transformationContext = {
        tr: tr,
        sourceNode: sourceNode,
        sourcePos: sourcePos,
        targetNodeType: targetNodeType,
        targetAttrs: targetAttrs
    };
    // Route to appropriate transformation strategy based on source node type
    if ((0, $cfdebf15105e07e3$export$40ce0987b0df258c)(targetNodeType)) return (0, $0e112dc22bdfddd5$export$74db2bafd1f977b0)(transformationContext);
    // special case codeblock to listType
    if (sourceNode.type.name === 'codeBlock' && (0, $cfdebf15105e07e3$export$4420be1ece169b6)(targetNodeType)) return (0, $177665f91cdbd860$export$6fff4a20515e068e)(transformationContext);
    if ((0, $cfdebf15105e07e3$export$a6a9bc90de7cbf3d)(sourceNode)) return (0, $0e112dc22bdfddd5$export$b4335274748f4fcd)(transformationContext);
    if ((0, $cfdebf15105e07e3$export$1665e2275a3d717a)(sourceNode)) return (0, $83e242229fd35f72$export$6554acda61c275ad)(transformationContext);
    if ((0, $cfdebf15105e07e3$export$a7d7d2b9ba4d4dbb)(sourceNode)) return (0, $64a74916bcfa221f$export$61ea3525eb3e8269)(transformationContext);
    if ((0, $cfdebf15105e07e3$export$5f94d2e4ba42a5c7)(sourceNode)) return (0, $177665f91cdbd860$export$697cfbabf5d9e1ba)(transformationContext);
    return null;
}



/**
 * Handles formatting when selection is empty by inserting a new target node
 */ const $ad6926d0a485b891$var$formatNodeWhenSelectionEmpty = (tr, targetType, nodePos, schema)=>{
    const { nodes: nodes } = schema;
    const { paragraph: paragraph } = nodes;
    // if not using the ' ' here, the safeInsert from editor-common will fail to insert the heading
    // and the pmSafeInsert introduce an issue that after inserting heading, and click on the handle, selection will go to top of the doc
    // as an workaround, use the spaceTextNode here
    const spaceTextNode = schema.text(' ');
    let targetNode;
    if (targetType.startsWith('heading')) {
        const levelString = targetType.slice(-1);
        const level = parseInt(levelString, 10);
        if (isNaN(level) || level < 1 || level > 6) return null;
        targetNode = nodes.heading.createAndFill({
            level: level
        }, spaceTextNode);
    } else if (targetType === 'paragraph') targetNode = nodes.paragraph.createAndFill({}, spaceTextNode);
    else if (targetType === 'layoutSection') {
        const contentAsParagraph = paragraph.createAndFill({}, spaceTextNode);
        if (contentAsParagraph) targetNode = (0, $0e112dc22bdfddd5$export$24df8f7ba30643b8)(schema, contentAsParagraph);
    } else {
        const targetNodeType = nodes[targetType];
        targetNode = targetNodeType.createAndFill();
    }
    if (!targetNode) return tr;
    tr = (0, $8m4tT.safeInsert)(targetNode, nodePos)(tr) ?? tr;
    return tr;
};
const $ad6926d0a485b891$export$dc89919f3a5ec704 = (tr, targetType, listNode, schema)=>{
    const { nodes: nodes } = schema;
    let headingLevel = 1;
    let finalTargetType = targetType;
    if (targetType.startsWith('heading')) {
        const levelString = targetType.slice(-1);
        const level = parseInt(levelString, 10);
        if (!isNaN(level) && level >= 1 && level <= 6) {
            headingLevel = level;
            finalTargetType = 'heading';
        }
    }
    let replaceNode = null;
    if (finalTargetType === 'layoutSection') {
        const emptyPara = nodes.paragraph.createAndFill();
        if (emptyPara) replaceNode = (0, $0e112dc22bdfddd5$export$24df8f7ba30643b8)(schema, emptyPara);
    } else if (finalTargetType === 'heading') replaceNode = nodes.heading.createAndFill({
        level: headingLevel
    });
    else replaceNode = nodes[finalTargetType].createAndFill();
    if (replaceNode) {
        tr.replaceWith(listNode.pos, listNode.pos + listNode.node.nodeSize, replaceNode);
        tr.setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(listNode.pos)));
    }
    return tr;
};
const $ad6926d0a485b891$export$c7d0412537b63391 = (api)=>(targetType, analyticsAttrs)=>{
        return ({ tr: tr })=>{
            const { selection: selection } = tr;
            const schema = tr.doc.type.schema;
            const { nodes: nodes } = schema;
            // Find the node to format from the current selection
            let nodeToFormat;
            let nodePos = selection.from;
            // when selection is empty, we insert a empty target node
            if (selection.empty) {
                const listNodes = [];
                // need to find if there is any list node in the current selection
                // As when select a empty list, selection is empty, but we want to convert the list instead of inserting a target node
                // findSelectedNodeOfType does not work when selection is empty, so we use nodesBetween
                tr.doc.nodesBetween(selection.from, selection.to, (node, pos)=>{
                    if ((0, $cfdebf15105e07e3$export$4420be1ece169b6)(node.type)) listNodes.push({
                        node: node,
                        pos: pos
                    });
                });
                //	get the first list node as when click on drag handle if there are list node
                //  can only select one list at a time, so we just need to find the first one
                if (listNodes.length > 0) {
                    const firstChild = listNodes[0];
                    const newTr = $ad6926d0a485b891$export$dc89919f3a5ec704(tr, targetType, firstChild, schema);
                    if (newTr) {
                        const sourceTypeName = firstChild.node.type.name;
                        api?.analytics?.actions?.attachAnalyticsEvent({
                            action: (0, $d925B.ACTION).CONVERTED,
                            actionSubject: (0, $d925B.ACTION_SUBJECT).ELEMENT,
                            eventType: (0, $d925B.EVENT_TYPE).TRACK,
                            attributes: {
                                from: sourceTypeName,
                                to: targetType,
                                eventCategory: (0, $cfdebf15105e07e3$export$2cb3a3d130a876b7)(sourceTypeName, targetType),
                                triggeredFrom: analyticsAttrs?.triggeredFrom || (0, $d925B.INPUT_METHOD).MOUSE,
                                inputMethod: analyticsAttrs?.inputMethod || (0, $d925B.INPUT_METHOD).BLOCK_MENU,
                                conversionSource: 'emptyList'
                            }
                        })(newTr);
                    }
                    return newTr;
                } else {
                    const newTr = $ad6926d0a485b891$var$formatNodeWhenSelectionEmpty(tr, targetType, nodePos, schema);
                    const allowedNodes = [
                        nodes.blockquote,
                        nodes.panel,
                        nodes.codeBlock,
                        nodes.layoutSection,
                        nodes.expand
                    ];
                    let sourceTypeName = 'paragraph';
                    let conversionSource;
                    const containerNode = (0, $8m4tT.findParentNodeOfType)(allowedNodes)(selection);
                    const paragraphOrHeading = (0, $8m4tT.findParentNodeOfType)([
                        nodes.heading,
                        nodes.paragraph
                    ])(selection);
                    if (containerNode) {
                        // At the moment this branch is executed for converstions from an empty blockquote
                        sourceTypeName = containerNode.node.type.name;
                        conversionSource = undefined; // could be 'emptyNode' or something else
                    } else if (paragraphOrHeading) {
                        sourceTypeName = paragraphOrHeading.node.type.name;
                        if (sourceTypeName === 'heading') sourceTypeName = `heading${paragraphOrHeading.node.attrs.level}`;
                        conversionSource = 'emptyLine';
                    }
                    if (newTr) api?.analytics?.actions?.attachAnalyticsEvent({
                        action: (0, $d925B.ACTION).CONVERTED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).ELEMENT,
                        eventType: (0, $d925B.EVENT_TYPE).TRACK,
                        attributes: {
                            from: sourceTypeName,
                            to: targetType,
                            eventCategory: (0, $cfdebf15105e07e3$export$2cb3a3d130a876b7)(sourceTypeName, targetType),
                            triggeredFrom: analyticsAttrs?.triggeredFrom || (0, $d925B.INPUT_METHOD).MOUSE,
                            inputMethod: analyticsAttrs?.inputMethod || (0, $d925B.INPUT_METHOD).BLOCK_MENU,
                            conversionSource: conversionSource
                        }
                    })(newTr);
                    return newTr;
                }
            }
            // Try to find the current node from selection
            const selectedNode = (0, $8m4tT.findSelectedNodeOfType)([
                nodes.paragraph,
                nodes.heading,
                nodes.blockquote,
                nodes.panel,
                nodes.expand,
                nodes.codeBlock,
                nodes.bulletList,
                nodes.orderedList,
                nodes.taskList,
                nodes.layoutSection
            ])(selection);
            if (selectedNode) {
                nodeToFormat = selectedNode.node;
                nodePos = selectedNode.pos;
            } else {
                // Try to find parent node (including list parents)
                const parentNode = (0, $8m4tT.findParentNodeOfType)([
                    nodes.blockquote,
                    nodes.panel,
                    nodes.expand,
                    nodes.codeBlock,
                    nodes.listItem,
                    nodes.taskItem,
                    nodes.layoutSection
                ])(selection);
                if (parentNode) {
                    nodeToFormat = parentNode.node;
                    nodePos = parentNode.pos;
                    const paragraphOrHeadingNode = (0, $8m4tT.findParentNodeOfType)([
                        nodes.paragraph,
                        nodes.heading
                    ])(selection);
                    // Special case: if we found a listItem, check if we need the parent list instead
                    if (parentNode.node.type === nodes.listItem || parentNode.node.type === nodes.taskItem) {
                        const listParent = (0, $8m4tT.findParentNodeOfType)([
                            nodes.bulletList,
                            nodes.orderedList,
                            nodes.taskList
                        ])(selection);
                        if (listParent) {
                            // For list transformations, we want the list parent, not the listItem
                            nodeToFormat = listParent.node;
                            nodePos = listParent.pos;
                        }
                    } else if (parentNode.node.type !== nodes.blockquote && paragraphOrHeadingNode) {
                        nodeToFormat = paragraphOrHeadingNode.node;
                        nodePos = paragraphOrHeadingNode.pos;
                    }
                }
            }
            if (!nodeToFormat) {
                nodeToFormat = selection.$from.node();
                nodePos = selection.$from.pos;
            }
            try {
                const newTr = (0, $78bd9f1fc1f25c0b$export$87cb0fc792d31ea8)(tr, nodeToFormat, nodePos, targetType);
                let sourceTypeName = nodeToFormat.type.name;
                if (sourceTypeName === 'heading' && nodeToFormat.attrs?.level) sourceTypeName = `heading${nodeToFormat.attrs.level}`;
                if (newTr && sourceTypeName !== targetType) api?.analytics?.actions?.attachAnalyticsEvent({
                    action: (0, $d925B.ACTION).CONVERTED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).ELEMENT,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                    attributes: {
                        from: sourceTypeName,
                        to: targetType,
                        eventCategory: (0, $cfdebf15105e07e3$export$2cb3a3d130a876b7)(sourceTypeName, targetType),
                        triggeredFrom: analyticsAttrs?.triggeredFrom || (0, $d925B.INPUT_METHOD).MOUSE,
                        inputMethod: analyticsAttrs?.inputMethod || (0, $d925B.INPUT_METHOD).BLOCK_MENU
                    }
                })(newTr);
                return newTr ? (0, $422f5af2e582b6ae$export$508727c68e01dec5)(newTr, nodePos, targetType) : newTr;
            } catch (error) {
                (0, $hWRJP.logException)(error, {
                    location: 'editor-plugin-block-menu'
                });
                // Fire error analytics event
                let sourceTypeName = nodeToFormat.type.name;
                if (sourceTypeName === 'heading' && nodeToFormat.attrs?.level) sourceTypeName = `heading${nodeToFormat.attrs.level}`;
                api?.analytics?.actions?.fireAnalyticsEvent({
                    action: (0, $d925B.ACTION).ERRORED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).ELEMENT,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TRANSFORM,
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        error: error.message,
                        errorStack: error.stack,
                        docSize: tr.doc.nodeSize,
                        from: sourceTypeName,
                        to: targetType,
                        position: tr.selection.from,
                        selection: tr.selection.toJSON(),
                        inputMethod: analyticsAttrs?.inputMethod || (0, $d925B.INPUT_METHOD).BLOCK_MENU,
                        triggeredFrom: analyticsAttrs?.triggeredFrom || (0, $d925B.INPUT_METHOD).MOUSE
                    }
                });
                return null;
            }
        };
    };









var $7XFGZ = parcelRequire("7XFGZ");

const $1a3ec8d57c21b25c$export$721178bb4de8b79 = (selection, menuTriggerBy)=>{
    if (!selection) return false;
    const { $from: $from } = selection;
    const depth = $from.depth;
    // When a file is in card view, selection.$from has a depth of 1, but it is not a nested node, should return false
    if ($from.depth === 1 && selection instanceof (0, $ks2lK.NodeSelection) && selection.node.type.name === 'media' && selection.node.attrs.type === 'file') return false;
    if ($from.depth > 0 && selection instanceof (0, $ks2lK.NodeSelection)) return true;
    // Depth 0-1: Always top-level
    if (depth <= 1) return false;
    // Depth 4+: Always nested
    if (depth > 4) return true;
    // Special case for table selection
    if (selection instanceof (0, $7XFGZ.CellSelection)) return depth > 3;
    // Check parent node type for depth 2-3
    const parentNode = $from.node(depth - 1);
    if (!parentNode) return true;
    const parentType = parentNode.type.name;
    const isTriggeredByBlockquote = menuTriggerBy.includes('blockquote');
    // Special cases where content is still top-level
    if (parentType === 'listItem' && depth === 3 || parentType === 'blockquote' && depth === 2 && isTriggeredByBlockquote || parentType === 'taskList' && depth === 2 || parentType === 'listItem' && depth === 4 && isTriggeredByBlockquote) return false;
    // Everything else at depth 2-3 is nested
    return true;
};



var $l6okE = parcelRequire("l6okE");











var $id9O1 = parcelRequire("id9O1");

var $iYC9s = parcelRequire("iYC9s");

const $7390b563c0364d10$export$da5a91481a5e4aa3 = (selection)=>{
    if (selection instanceof (0, $ks2lK.NodeSelection)) return {
        node: selection.node,
        pos: selection.$from.pos,
        start: 0,
        depth: selection.$from.depth
    };
    if (selection instanceof (0, $7XFGZ.CellSelection)) {
        const tableSelected = (0, $8m4tT.findParentNodeOfType)(selection.$from.doc.type.schema.nodes.table)(selection);
        return tableSelected;
    }
    if (selection instanceof (0, $ks2lK.TextSelection)) {
        const { blockquote: blockquote, bulletList: bulletList, orderedList: orderedList, taskList: taskList, codeBlock: codeBlock, paragraph: paragraph, heading: heading } = selection.$from.doc.type.schema.nodes;
        const quoteSelected = (0, $8m4tT.findParentNodeOfType)([
            blockquote
        ])(selection);
        if (quoteSelected) return quoteSelected;
        const codeBlockSelected = (0, $8m4tT.findParentNodeOfType)([
            codeBlock
        ])(selection);
        if (codeBlockSelected) return codeBlockSelected;
        const listSelected = (0, $8m4tT.findParentNodeOfType)([
            bulletList,
            taskList,
            orderedList
        ])(selection);
        if (listSelected) return listSelected;
        const paragraphOrHeading = (0, $8m4tT.findParentNodeOfType)([
            paragraph,
            heading
        ])(selection);
        if (paragraphOrHeading) return paragraphOrHeading;
    }
    return undefined;
};
const $7390b563c0364d10$export$4126f65c98e68a18 = (nodeTypeName, isNested)=>{
    if (nodeTypeName === 'expand' && isNested) return 'nestedExpand';
    return nodeTypeName;
};
const $7390b563c0364d10$export$cf7b5a42a57ba7c7 = (selection, schema)=>{
    const { nodes: nodes } = schema;
    const nodesNeedToExpandRange = [
        nodes.listItem,
        nodes.taskItem
    ];
    // when adding nodes.tableRow, tableHeader, tableCell in nodesNeedToExpandRang,
    // expandToBlockRange does not return expected table start position, sometimes even freeze editor
    // so handle table in the below logic
    if ((0, $iYC9s.isTableSelected)(selection)) {
        const table = (0, $id9O1.findTable)(selection);
        if (table) {
            const $from = selection.$from.doc.resolve(table.pos);
            const $to = selection.$from.doc.resolve(table.pos + table.node.nodeSize - 1);
            return {
                $from: $from,
                $to: $to
            };
        }
    }
    return (0, $l6okE.expandToBlockRange)(selection.$from, selection.$to, (node)=>{
        if (nodesNeedToExpandRange.includes(node.type)) return false;
        return true;
    });
};
const $7390b563c0364d10$export$f1003c1e9d4b008c = (node, schema)=>{
    const lists = [
        schema.nodes.taskList,
        schema.nodes.bulletList,
        schema.nodes.orderedList
    ];
    return lists.some((list)=>list === node.type);
};


const $df4a41e2cce509a9$export$2d058988e0d92b68 = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName } = context;
    // TODO: EDITOR-2920 - Implement flattening logic.
    // This is a simplified preliminary approach. We might want to use prosemirror-markdown functions.
    const codeBlockContent = nodes.map((node)=>node.content.textBetween(0, node.content.size, '\n')).join('\n');
    const outputNode = schema.nodes[targetNodeTypeName].createAndFill({}, schema.text(codeBlockContent));
    if (!outputNode) return nodes;
    return [
        outputNode
    ];
};





const $497980ba5eea782e$var$targets = (targetNodeTypeName, schema)=>{
    let targetListType;
    let targetItemType;
    switch(targetNodeTypeName){
        case 'bulletList':
            targetListType = schema.nodes.bulletList;
            targetItemType = schema.nodes.listItem;
            break;
        case 'orderedList':
            targetListType = schema.nodes.orderedList;
            targetItemType = schema.nodes.listItem;
            break;
        case 'taskList':
            targetListType = schema.nodes.taskList;
            targetItemType = schema.nodes.taskItem;
            break;
        default:
    }
    return {
        targetListType: targetListType,
        targetItemType: targetItemType
    };
};
const $497980ba5eea782e$export$6d5588752dacfe72 = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName } = context;
    const paragraphType = schema.nodes.paragraph;
    return nodes.map((node)=>{
        if (node.type !== schema.nodes.decisionList) return node;
        const { targetListType: targetListType, targetItemType: targetItemType } = $497980ba5eea782e$var$targets(targetNodeTypeName, schema);
        if (!targetListType || !targetItemType) return node;
        const newItems = [];
        node.forEach((decisionItem)=>{
            const itemContent = [];
            decisionItem.forEach((child)=>{
                itemContent.push(child);
            });
            const newItem = targetItemType === schema.nodes.listItem ? targetItemType.create({}, paragraphType.create({}, itemContent)) : targetItemType.create({}, itemContent);
            if (newItem) newItems.push(newItem);
        });
        const newList = targetListType.create({}, (0, $5SAOw.Fragment).from(newItems));
        return newList || node;
    });
};





const $e0710536896e19ad$var$extractNestedLists = (node, listTypes, itemTypes, schema)=>{
    const items = [];
    const paragraph = schema.nodes.paragraph;
    const extract = (currentNode)=>{
        currentNode.forEach((child)=>{
            if (itemTypes.some((type)=>child.type === type)) {
                const contentWithoutNestedLists = [];
                const nestedLists = [];
                child.forEach((grandChild)=>{
                    if (listTypes.some((type)=>grandChild.type === type)) nestedLists.push(grandChild);
                    else if (grandChild.isText) contentWithoutNestedLists.push(paragraph.createAndFill({}, grandChild));
                    else contentWithoutNestedLists.push(grandChild);
                });
                items.push(child.copy((0, $5SAOw.Fragment).from(contentWithoutNestedLists)));
                nestedLists.forEach((nestedList)=>{
                    extract(nestedList);
                });
            } else if (listTypes.some((type)=>child.type === type)) extract(child);
        });
    };
    extract(node);
    return items;
};
const $e0710536896e19ad$export$74774d2fcc242aef = (nodes, context)=>{
    const listTypes = [
        context.schema.nodes.bulletList,
        context.schema.nodes.orderedList,
        context.schema.nodes.taskList
    ];
    return nodes.map((node)=>{
        if (listTypes.some((type)=>node.type === type)) return node.copy((0, $5SAOw.Fragment).from($e0710536896e19ad$var$extractNestedLists(node, listTypes, [
            context.schema.nodes.listItem,
            context.schema.nodes.taskItem
        ], context.schema)));
        return node;
    });
};






const $98ca89eb980554b2$export$e95e25b492330619 = (nodes, context)=>{
    const { schema: schema } = context;
    const paragraphType = schema.nodes.paragraph;
    return nodes.map((node)=>{
        if (!(0, $7390b563c0364d10$export$f1003c1e9d4b008c)(node, schema)) return node;
        const decisionItems = [];
        node.forEach((item)=>{
            const itemContent = [];
            item.forEach((child)=>{
                if (child.type === paragraphType) // paragraph may contain hard breaks etc.
                child.content.forEach((inline)=>{
                    itemContent.push(inline);
                });
                else itemContent.push(child);
            // TODO: EDITOR-3887 - Skip mediaSingle, codeBlock, and nested lists
            });
            const decisionItem = schema.nodes.decisionItem.create({}, (0, $5SAOw.Fragment).from(itemContent));
            if (decisionItem) decisionItems.push(decisionItem);
        });
        const decisionList = schema.nodes.decisionList.create({}, (0, $5SAOw.Fragment).from(decisionItems));
        return decisionList || node;
    });
};






/**
 * Converts FROM taskList structure TO bulletList/orderedList structure.
 */ const $17275d1d29ee8e3b$var$convertFromTaskListStructure = (node, targetListType, targetItemType)=>{
    const schema = node.type.schema;
    const targetListNodeType = schema.nodes[targetListType];
    const convertedItems = [];
    node.content.forEach((child)=>{
        if ((0, $7390b563c0364d10$export$f1003c1e9d4b008c)(child, schema)) // This is a nested list - it should become a child of the previous item
        {
            if (convertedItems.length > 0) {
                const previousItem = convertedItems[convertedItems.length - 1];
                // Convert the nested list and add it to the previous item's content
                const convertedNestedList = $17275d1d29ee8e3b$var$transformList(child, targetListType, targetItemType);
                const newContent = previousItem.content.append((0, $5SAOw.Fragment).from([
                    convertedNestedList
                ]));
                const updatedItem = previousItem.type.create(previousItem.attrs, newContent);
                convertedItems[convertedItems.length - 1] = updatedItem;
            }
        } else {
            const convertedItem = $17275d1d29ee8e3b$var$transformListItem(child, targetItemType, targetListType);
            if (convertedItem) convertedItems.push(convertedItem);
        }
    });
    return targetListNodeType.create(node.attrs, (0, $5SAOw.Fragment).from(convertedItems));
};
/**
 * Converts FROM bulletList/orderedList structure TO taskList structure.
 */ const $17275d1d29ee8e3b$var$convertToTaskListStructure = (node, targetListType, targetItemType)=>{
    const schema = node.type.schema;
    const targetListNodeType = schema.nodes[targetListType];
    const transformedContent = [];
    node.content.forEach((itemNode)=>{
        const transformedItem = $17275d1d29ee8e3b$var$transformListItem(itemNode, targetItemType, targetListType, true);
        if (transformedItem) transformedContent.push(transformedItem);
        itemNode.content.forEach((child)=>{
            if ((0, $7390b563c0364d10$export$f1003c1e9d4b008c)(child, schema)) {
                const transformedNestedList = $17275d1d29ee8e3b$var$transformList(child, targetListType, targetItemType);
                transformedContent.push(transformedNestedList);
            }
        });
    });
    return targetListNodeType.create(node.attrs, (0, $5SAOw.Fragment).from(transformedContent));
};
/**
 * Converts a single list item (listItem or taskItem) to the target item type.
 * Handles content transformation based on the target type's requirements.
 * @param itemNode - The list item node to convert
 * @param targetItemType - The target item type (listItem or taskItem)
 * @param targetListType - The target list type (bulletList, orderedList, or taskList)
 * @param excludeNestedLists - When true, nested lists are excluded from the item's content
 *                             (used when converting to taskList where nested lists become siblings)
 */ const $17275d1d29ee8e3b$var$transformListItem = (itemNode, targetItemType, targetListType, excludeNestedLists = false)=>{
    const schema = itemNode.type.schema;
    const targetItemNodeType = schema.nodes[targetItemType];
    const isTargetTaskItem = targetItemType === 'taskItem';
    const isSourceTaskItem = itemNode.type.name === 'taskItem';
    const paragraphType = schema.nodes.paragraph;
    if (!targetItemNodeType) return null;
    if (isTargetTaskItem) {
        const inlineContent = [];
        itemNode.content.forEach((child)=>{
            if (child.type === paragraphType) child.content.forEach((inline)=>{
                inlineContent.push(inline);
            });
            if (child.isText) inlineContent.push(child);
        // TODO: EDITOR-3887 - Skip mediaSingle, codeBlock, and nested lists
        // Nested lists will be extracted and placed as siblings in the taskList
        });
        return targetItemNodeType.create({}, (0, $5SAOw.Fragment).from(inlineContent));
    } else {
        const newContent = [];
        if (isSourceTaskItem) newContent.push(paragraphType.create(null, itemNode.content));
        else itemNode.content.forEach((child)=>{
            if ((0, $7390b563c0364d10$export$f1003c1e9d4b008c)(child, schema)) {
                if (excludeNestedLists) // Skip nested lists - they will be handled separately as siblings
                return;
                newContent.push($17275d1d29ee8e3b$var$transformList(child, targetListType, targetItemType));
            } else newContent.push(child);
        });
        if (newContent.length === 0) newContent.push(paragraphType.create());
        return targetItemNodeType.create({}, (0, $5SAOw.Fragment).from(newContent));
    }
};
/**
 * Recursively converts nested lists to the target list type.
 * This function handles the conversion of both the list container and its items,
 * including any nested lists within those items.
 *
 * Important: taskList has a different nesting structure than bulletList/orderedList:
 * - taskList: nested taskLists are SIBLINGS of taskItems in the parent taskList
 * - bulletList/orderedList: nested lists are CHILDREN of listItems
 */ const $17275d1d29ee8e3b$var$transformList = (node, targetListType, targetItemType)=>{
    const schema = node.type.schema;
    const targetListNodeType = schema.nodes[targetListType];
    const targetItemNodeType = schema.nodes[targetItemType];
    const taskListType = schema.nodes.taskList;
    if (!targetListNodeType || !targetItemNodeType) return node;
    const isSourceTaskList = node.type === taskListType;
    const isTargetTaskList = targetListType === 'taskList';
    if (isSourceTaskList && !isTargetTaskList) return $17275d1d29ee8e3b$var$convertFromTaskListStructure(node, targetListType, targetItemType);
    else if (!isSourceTaskList && isTargetTaskList) return $17275d1d29ee8e3b$var$convertToTaskListStructure(node, targetListType, targetItemType);
    else {
        const transformedItems = [];
        node.content.forEach((childNode)=>{
            const transformedItem = (0, $7390b563c0364d10$export$f1003c1e9d4b008c)(childNode, schema) ? $17275d1d29ee8e3b$var$transformList(childNode, targetListType, targetItemType) : $17275d1d29ee8e3b$var$transformListItem(childNode, targetItemType, targetListType);
            if (transformedItem) transformedItems.push(transformedItem);
        });
        return targetListNodeType.create(node.attrs, (0, $5SAOw.Fragment).from(transformedItems));
    }
};
const $17275d1d29ee8e3b$export$46abc3e1699028ef = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName } = context;
    return nodes.map((node)=>{
        if ((0, $7390b563c0364d10$export$f1003c1e9d4b008c)(node, schema)) {
            const targetItemType = targetNodeTypeName === 'taskList' ? 'taskItem' : 'listItem';
            return $17275d1d29ee8e3b$var$transformList(node, targetNodeTypeName, targetItemType);
        }
        return node;
    });
};


const $949dd22633bf0d42$export$54edaa1aeed2418a = (nodes)=>{
    const outputNodes = [];
    nodes.forEach((node)=>{
        const isLayoutSection = node.type.name === 'layoutSection';
        if (isLayoutSection) node.children.forEach((column)=>{
            const isLayoutColumn = column.type.name === 'layoutColumn';
            if (isLayoutColumn) outputNodes.push(...column.children);
        });
    });
    if (outputNodes.length === 0) return nodes;
    return outputNodes;
};


const $460a160a245d4ae0$export$503819a1224039d8 = (nodes, context)=>{
    const listTypes = [
        context.schema.nodes.bulletList,
        context.schema.nodes.orderedList,
        context.schema.nodes.taskList
    ];
    return nodes.flatMap((node)=>{
        if (listTypes.some((type)=>node.type === type)) {
            const listItems = [];
            node.forEach((listItem)=>{
                listItems.push(...listItem.children);
            });
            return listItems;
        }
        return node;
    });
};





const $3457acfafb6ab5a5$export$46b8389d01fc568c = {
    blockquote: 'container',
    blockCard: 'atomic',
    bodiedExtension: 'atomic',
    bulletList: 'list',
    codeBlock: 'container',
    decisionList: 'list',
    embedCard: 'atomic',
    expand: 'container',
    extension: 'atomic',
    heading: 'text',
    layoutSection: 'container',
    media: 'atomic',
    mediaGroup: 'atomic',
    mediaSingle: 'atomic',
    multiBodiedExtension: 'atomic',
    orderedList: 'list',
    panel: 'container',
    paragraph: 'text',
    nestedExpand: 'container',
    taskList: 'list',
    table: 'atomic'
};
const $3457acfafb6ab5a5$export$8b255fd4814375b4 = (value)=>value in $3457acfafb6ab5a5$export$46b8389d01fc568c;
const $3457acfafb6ab5a5$export$708f29fc6944bd7f = (value)=>value && $3457acfafb6ab5a5$export$8b255fd4814375b4(value) ? value : null;


/**
 * Determines if a node is a text node (heading or paragraph).
 * Text nodes can have their content converted to paragraphs when they can't be wrapped directly.
 */ const $ac86911088b27f4f$var$isTextNode = (node)=>{
    const category = (0, $3457acfafb6ab5a5$export$46b8389d01fc568c)[node.type.name];
    return category === 'text';
};
/**
 * Converts a text node (heading, paragraph) to a paragraph preserving its inline content.
 * This is used when a text node can't be wrapped directly in the target container
 * (e.g., heading can't go in blockquote, so it becomes a paragraph).
 */ const $ac86911088b27f4f$var$convertTextNodeToParagraph = (node, schema)=>{
    // If it's already a paragraph, return as-is
    if (node.type.name === 'paragraph') return node;
    // Convert heading (or other text node) to paragraph with same inline content
    return schema.nodes.paragraph.createAndFill({}, node.content) ?? null;
};
/**
 * Determines if a node can be wrapped in the target container type.
 * Uses the schema's validContent to check if the target container can hold this node.
 *
 * Note: What can be wrapped depends on the target container type - for example:
 * - Tables and media CAN go inside expand nodes
 * - Tables CANNOT go inside panels or blockquotes
 */ const $ac86911088b27f4f$var$canWrapInTarget = (node, targetNodeType, targetNodeTypeName)=>{
    // Same-type containers should break out as separate containers
    if (node.type.name === targetNodeTypeName) return false;
    // Use the schema to determine if this node can be contained in the target
    try {
        return targetNodeType.validContent((0, $5SAOw.Fragment).from(node));
    } catch  {
        return false;
    }
};
/**
 * Converts a nestedExpand to a regular expand node.
 * NestedExpands can only exist inside expands, so when breaking out they must be converted.
 */ const $ac86911088b27f4f$var$convertNestedExpandToExpand = (node, schema)=>{
    const expandType = schema.nodes.expand;
    if (!expandType) return null;
    return expandType.createAndFill({
        title: node.attrs?.title || ''
    }, node.content);
};
const $ac86911088b27f4f$export$46a3aa15af7139ee = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName } = context;
    const targetNodeType = schema.nodes[targetNodeTypeName];
    if (!targetNodeType) return nodes;
    const result = [];
    let currentContainerContent = [];
    const flushCurrentContainer = ()=>{
        if (currentContainerContent.length > 0) {
            const containerNode = targetNodeType.createAndFill({}, (0, $5SAOw.Fragment).fromArray(currentContainerContent));
            if (containerNode) result.push(containerNode);
            currentContainerContent = [];
        }
    };
    nodes.forEach((node)=>{
        if ($ac86911088b27f4f$var$canWrapInTarget(node, targetNodeType, targetNodeTypeName)) // Node can be wrapped - add to current container content
        currentContainerContent.push(node);
        else if (node.type.name === targetNodeTypeName) {
            // Same-type container - breaks out as a separate container (preserved as-is)
            // This handles: "If there's a panel in the expand, it breaks out into a separate panel"
            flushCurrentContainer();
            result.push(node);
        } else if (node.type.name === 'nestedExpand') {
            // NestedExpand can't be wrapped and can't exist outside an expand
            // Convert to regular expand and break out
            flushCurrentContainer();
            const expandNode = $ac86911088b27f4f$var$convertNestedExpandToExpand(node, schema);
            if (expandNode) result.push(expandNode);
        } else if ($ac86911088b27f4f$var$isTextNode(node)) {
            // Text node (heading, paragraph) that can't be wrapped - convert to paragraph
            // Example: heading can't go in blockquote, so convert to paragraph with same content
            const paragraph = $ac86911088b27f4f$var$convertTextNodeToParagraph(node, schema);
            if (paragraph) currentContainerContent.push(paragraph);
        } else {
            // All other nodes that cannot be wrapped (lists, containers, tables, media, macros) - break out
            // This includes list nodes like taskList that can't be placed in certain containers
            flushCurrentContainer();
            result.push(node);
        }
    });
    // Flush any remaining content into a container
    flushCurrentContainer();
    return result.length > 0 ? result : nodes;
};


const $f643aa8fb0efa426$export$8e19711e1223dcf8 = (nodes, context)=>{
    return nodes;
};



const $b9d9b9b2d2d3d1fc$export$7583c29c75ec1903 = (nodes)=>{
    const outputNodes = [];
    nodes.forEach((node)=>{
        // we may want to just skip the original instead of using it
        if (node.children.length === 0) outputNodes.push(node);
        else outputNodes.push(...node.children);
    });
    return outputNodes;
};


const $580687a8ac618fc8$export$c0de2fe9771a255e = (nodes, context)=>{
    const { schema: schema } = context;
    const outputNodes = [];
    const { expand: expand, nestedExpand: nestedExpand } = schema.nodes;
    nodes.forEach((node)=>{
        const isExpand = node.type.name === expand.name || node.type.name === nestedExpand.name;
        if (isExpand) {
            const title = node.attrs?.title;
            // Create a paragraph from the title if it exists
            if (title) {
                const titleParagraph = schema.nodes.paragraph.createAndFill({}, schema.text(title));
                if (titleParagraph) outputNodes.push(titleParagraph);
            }
            // Add the children
            outputNodes.push(...node.children);
        } else (0, $b9d9b9b2d2d3d1fc$export$7583c29c75ec1903)([
            node
        ], context);
    });
    return outputNodes;
};






const $ff2dd039e3c81e6b$export$2d31615728b0cee2 = (nodes, context)=>{
    const { schema: schema } = context;
    const { layoutSection: layoutSection, layoutColumn: layoutColumn } = schema.nodes || {};
    const columnOne = layoutColumn.createAndFill({}, (0, $5SAOw.Fragment).fromArray(nodes));
    const columnTwo = layoutColumn.createAndFill();
    if (!columnOne || !columnTwo) return nodes;
    const layout = layoutSection.createAndFill({}, (0, $5SAOw.Fragment).fromArray([
        columnOne,
        columnTwo
    ]));
    if (!layout) return nodes;
    return [
        layout
    ];
};


const $62bf5c0c83bed565$export$4465c5391021ef03 = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName } = context;
    const outputNode = schema.nodes[targetNodeTypeName].createAndFill({}, nodes);
    if (outputNode) return [
        outputNode
    ];
    return nodes;
};


// Exampled step for overrides:
// - open Block menu on a paragraph, click 'Panel' in the Turn into'
// - expected to put paragraph into a panel
const $12e9a5c38e8518a2$var$wrapIntoPanelStep = (nodes, context)=>{
    const newNode = context.schema.nodes.panel.createAndFill({}, nodes);
    return newNode ? [
        newNode
    ] : [];
};
// Transform steps for combinations of node categories (block/container/list/text)
const $12e9a5c38e8518a2$var$TRANSFORM_STEPS = {
    atomic: {
        atomic: undefined,
        container: [
            (0, $62bf5c0c83bed565$export$4465c5391021ef03)
        ],
        list: undefined,
        text: undefined
    },
    container: {
        atomic: undefined,
        container: [
            (0, $b9d9b9b2d2d3d1fc$export$7583c29c75ec1903),
            (0, $62bf5c0c83bed565$export$4465c5391021ef03)
        ],
        list: undefined,
        text: [
            (0, $b9d9b9b2d2d3d1fc$export$7583c29c75ec1903)
        ]
    },
    list: {
        atomic: undefined,
        container: [
            (0, $62bf5c0c83bed565$export$4465c5391021ef03)
        ],
        list: [
            (0, $17275d1d29ee8e3b$export$46abc3e1699028ef)
        ],
        text: [
            (0, $e0710536896e19ad$export$74774d2fcc242aef),
            (0, $460a160a245d4ae0$export$503819a1224039d8)
        ]
    },
    text: {
        atomic: undefined,
        container: [
            (0, $f643aa8fb0efa426$export$8e19711e1223dcf8)
        ],
        list: [
            (0, $f643aa8fb0efa426$export$8e19711e1223dcf8)
        ],
        text: [
            (0, $f643aa8fb0efa426$export$8e19711e1223dcf8)
        ]
    }
};
// Transform steps for specific pairs of node types that cannot be processed
// using generic rules/steps from TRANSFORM_STEPS.
const $12e9a5c38e8518a2$var$TRANSFORM_STEPS_OVERRIDE = {
    paragraph: {
        panel: [
            $12e9a5c38e8518a2$var$wrapIntoPanelStep
        ]
    },
    panel: {
        layoutSection: [
            (0, $b9d9b9b2d2d3d1fc$export$7583c29c75ec1903),
            (0, $ff2dd039e3c81e6b$export$2d31615728b0cee2)
        ],
        codeBlock: [
            (0, $b9d9b9b2d2d3d1fc$export$7583c29c75ec1903),
            (0, $df4a41e2cce509a9$export$2d058988e0d92b68),
            (0, $62bf5c0c83bed565$export$4465c5391021ef03)
        ],
        blockquote: [
            (0, $b9d9b9b2d2d3d1fc$export$7583c29c75ec1903),
            (0, $ac86911088b27f4f$export$46a3aa15af7139ee)
        ]
    },
    expand: {
        panel: [
            (0, $580687a8ac618fc8$export$c0de2fe9771a255e),
            (0, $ac86911088b27f4f$export$46a3aa15af7139ee)
        ],
        blockquote: [
            (0, $580687a8ac618fc8$export$c0de2fe9771a255e),
            (0, $ac86911088b27f4f$export$46a3aa15af7139ee)
        ],
        layoutSection: [
            (0, $580687a8ac618fc8$export$c0de2fe9771a255e),
            (0, $ff2dd039e3c81e6b$export$2d31615728b0cee2)
        ],
        paragraph: [
            (0, $580687a8ac618fc8$export$c0de2fe9771a255e)
        ],
        codeBlock: [
            (0, $580687a8ac618fc8$export$c0de2fe9771a255e),
            (0, $df4a41e2cce509a9$export$2d058988e0d92b68),
            (0, $62bf5c0c83bed565$export$4465c5391021ef03)
        ]
    },
    nestedExpand: {
        panel: [
            (0, $580687a8ac618fc8$export$c0de2fe9771a255e),
            (0, $ac86911088b27f4f$export$46a3aa15af7139ee)
        ],
        blockquote: [
            (0, $580687a8ac618fc8$export$c0de2fe9771a255e),
            (0, $ac86911088b27f4f$export$46a3aa15af7139ee)
        ],
        paragraph: [
            (0, $580687a8ac618fc8$export$c0de2fe9771a255e)
        ],
        codeBlock: [
            (0, $580687a8ac618fc8$export$c0de2fe9771a255e),
            (0, $df4a41e2cce509a9$export$2d058988e0d92b68),
            (0, $62bf5c0c83bed565$export$4465c5391021ef03)
        ]
    },
    blockquote: {
        expand: [
            (0, $62bf5c0c83bed565$export$4465c5391021ef03)
        ],
        nestedExpand: [
            (0, $62bf5c0c83bed565$export$4465c5391021ef03)
        ],
        layoutSection: [
            (0, $ff2dd039e3c81e6b$export$2d31615728b0cee2)
        ],
        codeBlock: [
            (0, $b9d9b9b2d2d3d1fc$export$7583c29c75ec1903),
            (0, $df4a41e2cce509a9$export$2d058988e0d92b68),
            (0, $62bf5c0c83bed565$export$4465c5391021ef03)
        ]
    },
    layoutSection: {
        blockquote: [
            (0, $949dd22633bf0d42$export$54edaa1aeed2418a),
            (0, $62bf5c0c83bed565$export$4465c5391021ef03)
        ],
        expand: [
            (0, $949dd22633bf0d42$export$54edaa1aeed2418a),
            (0, $62bf5c0c83bed565$export$4465c5391021ef03)
        ],
        panel: [
            (0, $949dd22633bf0d42$export$54edaa1aeed2418a),
            (0, $62bf5c0c83bed565$export$4465c5391021ef03)
        ],
        codeBlock: [
            (0, $949dd22633bf0d42$export$54edaa1aeed2418a),
            (0, $df4a41e2cce509a9$export$2d058988e0d92b68),
            (0, $62bf5c0c83bed565$export$4465c5391021ef03)
        ],
        paragraph: [
            (0, $949dd22633bf0d42$export$54edaa1aeed2418a)
        ]
    },
    codeBlock: {
        blockquote: [
            (0, $62bf5c0c83bed565$export$4465c5391021ef03)
        ],
        expand: [
            (0, $62bf5c0c83bed565$export$4465c5391021ef03)
        ],
        nestedExpand: [
            (0, $62bf5c0c83bed565$export$4465c5391021ef03)
        ],
        layoutSection: [
            (0, $ff2dd039e3c81e6b$export$2d31615728b0cee2)
        ],
        panel: [
            (0, $62bf5c0c83bed565$export$4465c5391021ef03)
        ]
    },
    bulletList: {
        // Text transformations currently not in scope > options will be disabled > stubbing in case
        codeBlock: [
            (0, $f643aa8fb0efa426$export$8e19711e1223dcf8)
        ],
        layoutSection: [
            (0, $ff2dd039e3c81e6b$export$2d31615728b0cee2)
        ],
        decisionList: [
            (0, $e0710536896e19ad$export$74774d2fcc242aef),
            (0, $98ca89eb980554b2$export$e95e25b492330619)
        ]
    },
    orderedList: {
        // Text transformations currently not in scope > options will be disabled > stubbing in case
        codeBlock: [
            (0, $f643aa8fb0efa426$export$8e19711e1223dcf8)
        ],
        layoutSection: [
            (0, $ff2dd039e3c81e6b$export$2d31615728b0cee2)
        ],
        decisionList: [
            (0, $e0710536896e19ad$export$74774d2fcc242aef),
            (0, $98ca89eb980554b2$export$e95e25b492330619)
        ]
    },
    taskList: {
        // Text transformations currently not in scope > options will be disabled > stubbing in case
        blockquote: [
            (0, $f643aa8fb0efa426$export$8e19711e1223dcf8)
        ],
        codeBlock: [
            (0, $f643aa8fb0efa426$export$8e19711e1223dcf8)
        ],
        layoutSection: [
            (0, $ff2dd039e3c81e6b$export$2d31615728b0cee2)
        ],
        decisionList: [
            (0, $e0710536896e19ad$export$74774d2fcc242aef),
            (0, $98ca89eb980554b2$export$e95e25b492330619)
        ]
    },
    table: {
        expand: [
            (0, $62bf5c0c83bed565$export$4465c5391021ef03)
        ],
        layoutSection: [
            (0, $ff2dd039e3c81e6b$export$2d31615728b0cee2)
        ]
    },
    decisionList: {
        bulletList: [
            (0, $497980ba5eea782e$export$6d5588752dacfe72)
        ],
        orderedList: [
            (0, $497980ba5eea782e$export$6d5588752dacfe72)
        ],
        taskList: [
            (0, $497980ba5eea782e$export$6d5588752dacfe72)
        ]
    }
};
const $12e9a5c38e8518a2$var$getTransformStepsForNodeTypes = (selectedNodeTypeName, targetNodeTypeName)=>{
    const fromCategory = (0, $3457acfafb6ab5a5$export$46b8389d01fc568c)[selectedNodeTypeName];
    const toCategory = (0, $3457acfafb6ab5a5$export$46b8389d01fc568c)[targetNodeTypeName];
    const steps = $12e9a5c38e8518a2$var$TRANSFORM_STEPS_OVERRIDE[selectedNodeTypeName]?.[targetNodeTypeName] ?? $12e9a5c38e8518a2$var$TRANSFORM_STEPS[fromCategory][toCategory];
    return steps;
};
const $12e9a5c38e8518a2$export$96c2b318246b1dee = ({ sourceNode: sourceNode, targetNodeType: targetNodeType, schema: schema, isNested: isNested })=>{
    const nodesToReplace = [
        sourceNode
    ];
    const selectedNodeTypeName = (0, $3457acfafb6ab5a5$export$708f29fc6944bd7f)(sourceNode.type.name);
    const initialTargetNodeTypeName = (0, $3457acfafb6ab5a5$export$708f29fc6944bd7f)(targetNodeType.name);
    const targetNodeTypeName = (0, $7390b563c0364d10$export$4126f65c98e68a18)(initialTargetNodeTypeName, isNested);
    if (!selectedNodeTypeName || !targetNodeTypeName) // We may decide to return an empty array or undefined here
    return;
    const steps = $12e9a5c38e8518a2$var$getTransformStepsForNodeTypes(selectedNodeTypeName, targetNodeTypeName);
    const context = {
        fromNode: sourceNode,
        targetNodeTypeName: targetNodeTypeName,
        schema: schema
    };
    if (!steps || steps.length === 0) return;
    return steps.reduce((nodes, step)=>{
        return step(nodes, context);
    }, nodesToReplace);
};




const $da9345aeebc9b4ee$export$eb9a5497877a817a = (api)=>// eslint-disable-next-line no-unused-vars
    (targetType, analyticsAttrs)=>{
        return ({ tr: tr })=>{
            const preservedSelection = api?.blockControls?.sharedState.currentState()?.preservedSelection;
            if (!preservedSelection) return tr;
            const { $from: $from, $to: $to } = (0, $7390b563c0364d10$export$cf7b5a42a57ba7c7)(preservedSelection, tr.doc.type.schema);
            const isNested = (0, $1a3ec8d57c21b25c$export$721178bb4de8b79)(preservedSelection, '');
            const selectedParent = $from.parent;
            let fragment = (0, $5SAOw.Fragment).empty;
            const isList = (0, $cfdebf15105e07e3$export$a7d7d2b9ba4d4dbb)(selectedParent);
            const slice = tr.doc.slice(isList ? $from.pos - 1 : $from.pos, isList ? $to.pos + 1 : $to.pos);
            slice.content.forEach((node)=>{
                const outputNode = (0, $12e9a5c38e8518a2$export$96c2b318246b1dee)({
                    sourceNode: node,
                    targetNodeType: targetType,
                    schema: tr.doc.type.schema,
                    isNested: isNested
                });
                if (outputNode) fragment = fragment.append((0, $5SAOw.Fragment).fromArray(outputNode));
            });
            // TODO: ED-12345 - selection is broken post transaction, to fix.
            tr.replaceWith(isList ? $from.pos - 1 : $from.pos, $to.pos, fragment);
            return tr;
        };
    };








const $a4d09cb8508da670$export$8750eaa816e9a19a = new (0, $ks2lK.PluginKey)('blockMenuPlugin');
const $a4d09cb8508da670$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $a4d09cb8508da670$export$8750eaa816e9a19a,
        state: {
            init () {
                return {
                    showFlag: false
                };
            },
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($a4d09cb8508da670$export$8750eaa816e9a19a);
                return {
                    showFlag: meta?.showFlag ?? currentPluginState.showFlag
                };
            }
        }
    });
};


/* block-menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $7fmpI = parcelRequire("7fmpI");








var $Yqd3z = parcelRequire("Yqd3z");


var $jwWgu = parcelRequire("jwWgu");


var $efG2U = parcelRequire("efG2U");





var $2GVu1 = parcelRequire("2GVu1");

var $6UWPx = parcelRequire("6UWPx");

var $87Gms = parcelRequire("87Gms");


var $dh538 = parcelRequire("dh538");


var $dTb09 = parcelRequire("dTb09");





var $iu6m9 = parcelRequire("iu6m9");







const $31f7b2f877a3c7aa$var$BlockMenuContext = /*#__PURE__*/ (0, $42omo.createContext)({
    onDropdownOpenChanged: ()=>{},
    moveFocusTo: ()=>{},
    moveDownRef: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef(),
    moveUpRef: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef()
});
const $31f7b2f877a3c7aa$export$348c130ef35bd15f = ()=>{
    const context = (0, $42omo.useContext)($31f7b2f877a3c7aa$var$BlockMenuContext);
    if (!context) throw new Error('useBlockMenu must be used within BlockMenuProvider');
    return context;
};
const $31f7b2f877a3c7aa$export$b01e53fc0770b652 = ({ children: children, api: api })=>{
    const moveUpRef = (0, $42omo.useRef)(null);
    const moveDownRef = (0, $42omo.useRef)(null);
    const onDropdownOpenChanged = (0, $42omo.useCallback)((isOpen)=>{
        if (!isOpen) // On Dropdown closed, return focus to editor
        setTimeout(()=>requestAnimationFrame(()=>{
                api?.core.actions.focus({
                    scrollIntoView: false
                });
            }), 1);
    }, [
        api
    ]);
    const moveFocusTo = (0, $42omo.useCallback)((direction)=>{
        if (direction === 'moveUp') moveUpRef.current?.focus();
        else if (direction === 'moveDown') moveDownRef.current?.focus();
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)($31f7b2f877a3c7aa$var$BlockMenuContext.Provider, {
        value: {
            onDropdownOpenChanged: onDropdownOpenChanged,
            moveFocusTo: moveFocusTo,
            moveDownRef: moveDownRef,
            moveUpRef: moveUpRef
        },
        children: children
    });
};









var $9Z3I5 = parcelRequire("9Z3I5");

var $5v8Ta = parcelRequire("5v8Ta");

const $3393a4c6e6e7adb4$var$NoOp = ()=>null;
const $3393a4c6e6e7adb4$var$isNonNestedMenuSection = (component)=>{
    return component.type === 'block-menu-section' && !('parent' in component);
};
const $3393a4c6e6e7adb4$var$isMenuItem = (component)=>{
    return component.type === 'block-menu-item';
};
const $3393a4c6e6e7adb4$var$isNestedMenu = (component)=>{
    return component.type === 'block-menu-nested';
};
const $3393a4c6e6e7adb4$var$isNestedMenuSection = (component)=>{
    return 'parent' in component && component.parent !== undefined && component.parent.type === 'block-menu-nested';
};
const $3393a4c6e6e7adb4$var$getSortedChildren = (components, parentKey)=>components.filter((component)=>'parent' in component && component.parent !== undefined && component.parent.key === parentKey).sort((a, b)=>(a.parent.rank || 0) - (b.parent.rank || 0));
const $3393a4c6e6e7adb4$var$getSortedNestedSections = (components, parentKey)=>{
    const nestedMenuSections = components.filter($3393a4c6e6e7adb4$var$isNestedMenuSection);
    const nestedMenuSectionsWithParent = nestedMenuSections.filter((section)=>section.parent !== undefined);
    return $3393a4c6e6e7adb4$var$getSortedChildren(nestedMenuSectionsWithParent, parentKey);
};
const $3393a4c6e6e7adb4$var$getSortedNonNestedSections = (components)=>{
    return components.filter($3393a4c6e6e7adb4$var$isNonNestedMenuSection).sort((a, b)=>(a.rank || 0) - (b.rank || 0));
};
const $3393a4c6e6e7adb4$export$31e93a060be203b5 = ({ components: components, fallbacks: fallbacks })=>{
    const menuSections = $3393a4c6e6e7adb4$var$getSortedNonNestedSections(components);
    const menuItems = components.filter($3393a4c6e6e7adb4$var$isMenuItem);
    const nestedMenus = components.filter($3393a4c6e6e7adb4$var$isNestedMenu);
    const renderMenu = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
            children: menuSections.map((section)=>{
                // Get all items for the current section, including nested menus, and sort them by rank
                const currentSectionItemsSorted = $3393a4c6e6e7adb4$var$getSortedChildren([
                    ...menuItems,
                    ...nestedMenus
                ], section.key);
                if (currentSectionItemsSorted.length === 0) return null;
                // iterate over the current section items, if it is nested menu, get their children, sort them
                // if they are menu items, just render as they are sorted above
                const getChildrenWithNestedItems = (items)=>{
                    return items.map((item)=>{
                        if ($3393a4c6e6e7adb4$var$isNestedMenu(item)) {
                            const sortedNestedSections = $3393a4c6e6e7adb4$var$getSortedNestedSections(components, item.key);
                            const sections = sortedNestedSections.map((section)=>{
                                const sortedNestedMenuItems = $3393a4c6e6e7adb4$var$getSortedChildren(menuItems, section.key);
                                if (sortedNestedMenuItems.length === 0) return null;
                                const NestedSection = section.component || fallbacks.section || $3393a4c6e6e7adb4$var$NoOp;
                                return /*#__PURE__*/ (0, $l998X.jsx)(NestedSection, {
                                    children: sortedNestedMenuItems.map((nestedItem)=>{
                                        const NestedMenuItemComponent = nestedItem.component || fallbacks.item || $3393a4c6e6e7adb4$var$NoOp;
                                        return /*#__PURE__*/ (0, $l998X.jsx)(NestedMenuItemComponent, {}, nestedItem.key);
                                    })
                                }, section.key);
                            });
                            const NestedMenuComponent = item.component || fallbacks.nestedMenu || $3393a4c6e6e7adb4$var$NoOp;
                            return /*#__PURE__*/ (0, $l998X.jsx)(NestedMenuComponent, {
                                children: sections
                            }, item.key);
                        } else {
                            const ItemComponent = item.component || fallbacks.item || $3393a4c6e6e7adb4$var$NoOp;
                            return /*#__PURE__*/ (0, $l998X.jsx)(ItemComponent, {}, item.key);
                        }
                    });
                };
                const children = getChildrenWithNestedItems(currentSectionItemsSorted);
                const SectionComponent = section.component || fallbacks.section || $3393a4c6e6e7adb4$var$NoOp;
                return /*#__PURE__*/ (0, $l998X.jsx)(SectionComponent, {
                    children: children
                }, section.key);
            })
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9Z3I5.ArrowKeyNavigationProvider), {
        type: (0, $5v8Ta.ArrowKeyNavigationType).MENU,
        children: renderMenu()
    });
};


const $ad0695004c479369$var$styles = {
    base: "_2rko12b0 _bfhk1bhr _16qs130s",
    emptyMenuSectionStyles: "_1cc0glyw _1k2yglyw"
};
const $ad0695004c479369$var$DEFAULT_MENU_WIDTH = 230;
const $ad0695004c479369$var$DRAG_HANDLE_OFFSET_PADDING = 5;
const $ad0695004c479369$var$FALLBACK_MENU_HEIGHT = 300;
const $ad0695004c479369$var$PopupWithListeners = (0, $efG2U.default)((0, $jwWgu.default));
const $ad0695004c479369$var$useConditionalBlockMenuEffect = (0, $dTb09.conditionalHooksFactory)(()=>(0, $dh538.fg)('platform_editor_toolbar_aifc_user_intent_fix'), ({ api: api, isMenuOpen: isMenuOpen, menuTriggerBy: menuTriggerBy, selectedByShortcutOrDragHandle: selectedByShortcutOrDragHandle, hasFocus: hasFocus, openedViaKeyboard: openedViaKeyboard, prevIsMenuOpenRef: prevIsMenuOpenRef })=>{
    /**
   * NOTE: do not add `currentUserIntent` to dependency array as it causes unnecessary re-renders and messes with the user intent state
   */ (0, $42omo.useEffect)(()=>{
        if (!isMenuOpen || !menuTriggerBy || !selectedByShortcutOrDragHandle || !hasFocus) return;
         // Fire analytics event when block menu opens (only on first transition from closed to open)
        if (!prevIsMenuOpenRef.current && isMenuOpen) api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).OPENED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BLOCK_MENU,
            eventType: (0, $d925B.EVENT_TYPE).UI,
            attributes: {
                inputMethod: openedViaKeyboard ? (0, $d925B.INPUT_METHOD).KEYBOARD : (0, $d925B.INPUT_METHOD).MOUSE
            }
        });
         // Update the previous state
        prevIsMenuOpenRef.current = isMenuOpen;
        api?.core.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('blockMenuOpen'));
    }, [
        api,
        isMenuOpen,
        menuTriggerBy,
        selectedByShortcutOrDragHandle,
        hasFocus,
        openedViaKeyboard,
        prevIsMenuOpenRef
    ]);
}, ({ api: api, isMenuOpen: isMenuOpen, menuTriggerBy: menuTriggerBy, selectedByShortcutOrDragHandle: selectedByShortcutOrDragHandle, hasFocus: hasFocus, currentUserIntent: currentUserIntent, openedViaKeyboard: openedViaKeyboard, prevIsMenuOpenRef: prevIsMenuOpenRef })=>{
    (0, $42omo.useEffect)(()=>{
        if (!isMenuOpen || !menuTriggerBy || !selectedByShortcutOrDragHandle || !hasFocus || [
            'resizing',
            'dragging'
        ].includes(currentUserIntent || '')) return;
         // Fire analytics event when block menu opens (only on first transition from closed to open)
        if (!prevIsMenuOpenRef.current && isMenuOpen) api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).OPENED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BLOCK_MENU,
            eventType: (0, $d925B.EVENT_TYPE).UI,
            attributes: {
                inputMethod: openedViaKeyboard ? (0, $d925B.INPUT_METHOD).KEYBOARD : (0, $d925B.INPUT_METHOD).MOUSE
            }
        });
         // Update the previous state
        prevIsMenuOpenRef.current = isMenuOpen;
        api?.core.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('blockMenuOpen'));
    }, [
        api,
        isMenuOpen,
        menuTriggerBy,
        selectedByShortcutOrDragHandle,
        hasFocus,
        currentUserIntent,
        openedViaKeyboard,
        prevIsMenuOpenRef
    ]);
});
const $ad0695004c479369$var$BlockMenuContent = ({ api: api, setRef: setRef })=>{
    const blockMenuComponents = api?.blockMenu?.actions.getBlockMenuComponents();
    const setOutsideClickTargetRef = (0, $42omo.useContext)((0, $efG2U.OutsideClickTargetRefContext));
    const ref = (el)=>{
        setOutsideClickTargetRef(el);
        setRef?.(el);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "editor-block-menu",
        ref: ref,
        xcss: (0, $1Whri.cx)($ad0695004c479369$var$styles.base, (0, $iu6m9.editorExperiment)('platform_synced_block', true) && $ad0695004c479369$var$styles.emptyMenuSectionStyles),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3393a4c6e6e7adb4$export$31e93a060be203b5), {
            components: blockMenuComponents || [],
            fallbacks: {
                nestedMenu: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $87Gms.ToolbarNestedDropdownMenu), {
                        elemBefore: undefined,
                        elemAfter: undefined,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6UWPx.ToolbarDropdownItemSection), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
                                children: "Block Menu Item"
                            })
                        })
                    }),
                section: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6UWPx.ToolbarDropdownItemSection), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
                            children: "Block Menu Item"
                        })
                    }),
                // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
                item: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
                        children: "Block Menu Item"
                    })
            }
        })
    });
};
const $ad0695004c479369$var$BlockMenu = ({ editorView: editorView, api: api, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const { menuTriggerBy: menuTriggerBy, isSelectedViaDragHandle: isSelectedViaDragHandle, isMenuOpen: isMenuOpen, currentUserIntent: currentUserIntent, openedViaKeyboard: openedViaKeyboard } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'blockControls',
        'userIntent'
    ], (states)=>({
            menuTriggerBy: states.blockControlsState?.menuTriggerBy,
            isSelectedViaDragHandle: states.blockControlsState?.isSelectedViaDragHandle,
            isMenuOpen: states.blockControlsState?.isMenuOpen,
            currentUserIntent: states.userIntentState?.currentUserIntent,
            openedViaKeyboard: states.blockControlsState?.blockMenuOptions?.openedViaKeyboard
        }));
    const { onDropdownOpenChanged: onDropdownOpenChanged } = (0, $31f7b2f877a3c7aa$export$348c130ef35bd15f)();
    const targetHandleRef = editorView?.dom?.querySelector((0, $Yqd3z.DRAG_HANDLE_SELECTOR));
    const prevIsMenuOpenRef = (0, $42omo.useRef)(false);
    const popupRef = (0, $42omo.useRef)(undefined);
    const [menuHeight, setMenuHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(0);
    const targetHandleHeightOffset = -(targetHandleRef?.clientHeight || 0);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useLayoutEffect(()=>{
        if (!isMenuOpen) return;
        setMenuHeight(popupRef.current?.clientHeight || $ad0695004c479369$var$FALLBACK_MENU_HEIGHT);
    }, [
        isMenuOpen
    ]);
    const hasFocus = (editorView?.hasFocus() || document.activeElement === targetHandleRef || popupRef.current && (popupRef.current.contains(document.activeElement) || popupRef.current === document.activeElement)) ?? false;
    const selectedByShortcutOrDragHandle = !!isSelectedViaDragHandle || !!openedViaKeyboard; // Use conditional hook based on feature flag
    $ad0695004c479369$var$useConditionalBlockMenuEffect({
        api: api,
        isMenuOpen: isMenuOpen,
        menuTriggerBy: menuTriggerBy,
        selectedByShortcutOrDragHandle: selectedByShortcutOrDragHandle,
        hasFocus: hasFocus,
        currentUserIntent: (0, $dh538.fg)('platform_editor_toolbar_aifc_user_intent_fix') ? undefined : currentUserIntent,
        openedViaKeyboard: openedViaKeyboard,
        prevIsMenuOpenRef: prevIsMenuOpenRef
    });
    if (!isMenuOpen) return null;
    const handleBackspaceDeleteKeydown = (event)=>{
        // Pevents delete/backspace keypress being handled by editor, avoids double deletions
        event?.preventDefault();
        event?.stopPropagation();
        api?.core.actions.execute(({ tr: tr })=>{
            (0, $l6okE.deleteSelectedRange)(tr, api?.blockControls?.sharedState.currentState()?.preservedSelection);
            api?.blockControls?.commands.toggleBlockMenu({
                closeMenu: true
            })({
                tr: tr
            });
            if (editorView && !editorView.hasFocus()) // if focus is outside editor, e.g. in block menu popup, then refocus editor after delete
            editorView.focus();
            return tr;
        });
    };
    const closeMenu = ()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            api?.blockControls?.commands.toggleBlockMenu({
                closeMenu: true
            })({
                tr: tr
            });
            onDropdownOpenChanged(false);
            api?.userIntent?.commands.setCurrentUserIntent(currentUserIntent === 'blockMenuOpen' ? 'default' : currentUserIntent || 'default')({
                tr: tr
            });
            return tr;
        });
    };
    if (!menuTriggerBy || !selectedByShortcutOrDragHandle || !hasFocus || [
        'resizing',
        'dragging'
    ].includes(currentUserIntent || '')) {
        closeMenu();
        return null;
    }
    const setRef = (el)=>{
        if (el) popupRef.current = el;
    };
    if (targetHandleRef instanceof HTMLElement) return /*#__PURE__*/ (0, $l998X.jsx)((0, $7fmpI.ErrorBoundary), {
        component: (0, $d925B.ACTION_SUBJECT).BLOCK_MENU,
        dispatchAnalyticsEvent: api?.analytics?.actions.fireAnalyticsEvent,
        fallbackComponent: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($ad0695004c479369$var$PopupWithListeners, {
            alignX: 'right',
            alignY: 'start',
            handleClickOutside: closeMenu,
            handleEscapeKeydown: closeMenu,
            handleBackspaceDeleteKeydown: handleBackspaceDeleteKeydown,
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            target: targetHandleRef,
            zIndex: (0, $aFUXX.akEditorFloatingOverlapPanelZIndex),
            fitWidth: $ad0695004c479369$var$DEFAULT_MENU_WIDTH,
            fitHeight: menuHeight,
            preventOverflow: true,
            stick: true,
            offset: [
                (0, $Yqd3z.DRAG_HANDLE_WIDTH) + $ad0695004c479369$var$DRAG_HANDLE_OFFSET_PADDING,
                targetHandleHeightOffset
            ],
            focusTrap: openedViaKeyboard ? // Only enable focus trap when opened via keyboard to make sure the focus is on the first focusable menu item
            {
                initialFocus: undefined
            } : undefined,
            children: /*#__PURE__*/ (0, $l998X.jsx)($ad0695004c479369$var$BlockMenuContent, {
                api: api,
                setRef: setRef
            })
        })
    });
    else return null;
};
var $ad0695004c479369$export$2e2bcd8739ae039 = (0, $gmMgo.default)($ad0695004c479369$var$BlockMenu);





parcelRequire("42omo");


var $btNLq = parcelRequire("btNLq");

var $gEb6G = parcelRequire("gEb6G");






















var $eKkkY = parcelRequire("eKkkY");





var $1bY7o = parcelRequire("1bY7o");




var $99ad5f2b881e8e26$export$5881677fb314e6d9 = /*#__PURE__*/ function(FLAG_ID) {
    FLAG_ID["LINK_COPIED_TO_CLIPBOARD"] = "link-copied-to-clipboard";
    return FLAG_ID;
}({});




const $5d918711fbc10783$export$3049469618923b43 = 'Editor Block Menu';
const $5d918711fbc10783$export$659b32b68ac9a52b = {
    COPY_LINK_TO_BLOCK: 'copyLinkToBlock',
    MOVE_UP: 'moveUp',
    MOVE_DOWN: 'moveDown',
    DELETE: 'delete',
    FORMAT_MENU: 'formatMenu',
    COPY_CONTENT: 'copyContent'
};



var $cQJcI = parcelRequire("cQJcI");


var $cMZNY = parcelRequire("cMZNY");





const $2319389d4c17c6d0$export$9030f1f7cf11a203 = async ({ getLinkPath: getLinkPath, blockLinkHashPrefix: blockLinkHashPrefix = (0, $cQJcI.DEFAULT_BLOCK_LINK_HASH_PREFIX), selection: selection, schema: schema })=>{
    const blockRange = (0, $7390b563c0364d10$export$cf7b5a42a57ba7c7)(selection, schema);
    if (!blockRange) return false;
    // get the link to the first node in the selection
    const node = blockRange.$from.nodeAfter;
    if (!node || !node.attrs || !node.attrs.localId) return false;
    const path = getLinkPath?.() || location.pathname;
    try {
        const url = new URL(location.origin + path);
        url.hash = (0, $cQJcI.createBlockLinkHashValue)(node.attrs.localId, blockLinkHashPrefix);
        const href = url.toString();
        await (0, $cMZNY.copyToClipboard)(href);
    } catch (error) {
        (0, $hWRJP.logException)(error, {
            location: 'editor-plugin-block-menu'
        });
        return false;
    }
    return true;
};



const $ff0afd1293edb1db$var$CopyLinkDropdownItemContent = ({ api: api, config: config })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { onDropdownOpenChanged: onDropdownOpenChanged } = (0, $31f7b2f877a3c7aa$export$348c130ef35bd15f)();
    const { getLinkPath: getLinkPath, blockLinkHashPrefix: blockLinkHashPrefix } = config || {};
    const { preservedSelection: preservedSelection, defaultSelection: defaultSelection, menuTriggerBy: menuTriggerBy, schema: schema } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'blockControls',
        'selection',
        'core'
    ], ({ blockControlsState: blockControlsState, selectionState: selectionState, coreState: coreState })=>{
        return {
            menuTriggerBy: blockControlsState?.menuTriggerBy,
            preservedSelection: blockControlsState?.preservedSelection,
            defaultSelection: selectionState?.selection,
            schema: coreState?.schema
        };
    });
    const selection = preservedSelection || defaultSelection;
    const handleClick = (0, $42omo.useCallback)(()=>{
        if (!selection || !schema) return;
        api?.core.actions.execute(({ tr: tr })=>{
            const payload = {
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).BLOCK_MENU_ITEM,
                attributes: {
                    menuItemName: (0, $5d918711fbc10783$export$659b32b68ac9a52b).COPY_LINK_TO_BLOCK
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            };
            api?.analytics?.actions?.attachAnalyticsEvent(payload)(tr);
            api?.blockControls?.commands?.toggleBlockMenu({
                closeMenu: true
            })({
                tr: tr
            });
            return tr;
        });
        onDropdownOpenChanged(false);
        (0, $2319389d4c17c6d0$export$9030f1f7cf11a203)({
            getLinkPath: getLinkPath,
            blockLinkHashPrefix: blockLinkHashPrefix,
            selection: selection,
            schema: schema
        }).then((success)=>{
            if (success) api?.core.actions.execute(({ tr: tr })=>{
                tr.setMeta((0, $a4d09cb8508da670$export$8750eaa816e9a19a), {
                    showFlag: (0, $99ad5f2b881e8e26$export$5881677fb314e6d9).LINK_COPIED_TO_CLIPBOARD
                });
                return tr;
            });
        });
    }, [
        api,
        blockLinkHashPrefix,
        getLinkPath,
        onDropdownOpenChanged,
        schema,
        selection
    ]);
    // Hide copy link when `platform_editor_adf_with_localid` feature flag is off or when the node is nested or on empty line
    if (!(0, $dh538.fg)('platform_editor_adf_with_localid') || !!menuTriggerBy && (0, $1a3ec8d57c21b25c$export$721178bb4de8b79)(selection, menuTriggerBy) || selection?.empty) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: ""
        }),
        children: formatMessage((0, $eKkkY.messages).copyLinkToBlock)
    });
};
const $ff0afd1293edb1db$export$86b0dd217bb75f55 = (0, $gmMgo.default)($ff0afd1293edb1db$var$CopyLinkDropdownItemContent);

















const $5b94a729c73f5936$var$TRANSFORM_MENU_ENABLED_FOR_ALL_TOP_LEVEL_NODES = true;
const $5b94a729c73f5936$var$getIsFormatMenuHidden = (selection, schema)=>{
    const nodes = schema.nodes;
    if (!nodes) return false;
    if ($5b94a729c73f5936$var$TRANSFORM_MENU_ENABLED_FOR_ALL_TOP_LEVEL_NODES) {
        const disabledOnNodes = [
            nodes.syncBlock,
            nodes.bodiedSyncBlock,
            nodes.rule
        ];
        const disabledNode = (0, $8m4tT.findSelectedNodeOfType)(disabledOnNodes)(selection);
        return !!disabledNode;
    }
    if (selection.empty || selection.content().size === 0) // if empty selection, show format menu
    return false;
    else {
        let content;
        const allowedNodes = [
            nodes.paragraph,
            nodes.heading,
            nodes.blockquote,
            nodes.panel,
            nodes.codeBlock,
            nodes.bulletList,
            nodes.orderedList,
            nodes.taskList,
            nodes.layoutSection,
            nodes.expand
        ];
        const selectedNode = (0, $8m4tT.findSelectedNodeOfType)(allowedNodes)(selection);
        if (selectedNode) content = selectedNode.node;
        else {
            const listTypeOrBlockQuoteNode = (0, $8m4tT.findParentNodeOfType)([
                nodes.paragraph,
                nodes.heading,
                nodes.blockquote,
                nodes.listItem,
                nodes.taskItem
            ])(selection);
            if (listTypeOrBlockQuoteNode) content = listTypeOrBlockQuoteNode.node;
        }
        return !content;
    }
};
const $5b94a729c73f5936$export$b9b8afbbcc99cd12 = (api)=>{
    const selection = api?.selection?.sharedState?.currentState()?.selection;
    const schema = api?.core.sharedState.currentState()?.schema;
    const menuTriggerBy = api?.blockControls?.sharedState.currentState()?.menuTriggerBy;
    if (!selection || !schema || !menuTriggerBy) return false;
    return $5b94a729c73f5936$var$getIsFormatMenuHidden(selection, schema);
};


const $4d9b02b8c5c74719$export$ec4637f07afe304 = ({ api: api, children: children })=>{
    const isFormatMenuHidden = (0, $42omo.useCallback)(()=>{
        return (0, $5b94a729c73f5936$export$b9b8afbbcc99cd12)(api);
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6UWPx.ToolbarDropdownItemSection), {
        hasSeparator: (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? true : !isFormatMenuHidden(),
        children: children
    });
};


























var $gKvd9 = parcelRequire("gKvd9");


var $6f0Oj = parcelRequire("6f0Oj");


var $5dK2X = parcelRequire("5dK2X");


const $0c5779d6800c9c7a$var$DeleteDropdownItemContent = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const nodeTypes = Object.values(api?.core.sharedState.currentState()?.schema?.nodes || {});
    const onClick = ()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            const payload = {
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).BLOCK_MENU_ITEM,
                attributes: {
                    menuItemName: (0, $5d918711fbc10783$export$659b32b68ac9a52b).DELETE
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            };
            api?.analytics?.actions?.attachAnalyticsEvent(payload)(tr);
            (0, $l6okE.deleteSelectedRange)(tr, api?.blockControls?.sharedState.currentState()?.preservedSelection);
            api?.blockControls?.commands?.toggleBlockMenu({
                closeMenu: true
            })({
                tr: tr
            });
            return tr;
        });
        api?.core.actions.focus();
    };
    const onShowHoverDecoration = (0, $42omo.useCallback)(()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            api?.decorations?.commands?.hoverDecoration?.({
                nodeType: nodeTypes,
                add: true
            })({
                tr: tr
            });
            return tr;
        });
    }, [
        api,
        nodeTypes
    ]);
    const onRemoveHoverDecoration = (0, $42omo.useCallback)(()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            api?.decorations?.commands?.removeDecoration?.()({
                tr: tr
            });
            return tr;
        });
    }, [
        api
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            // clean up hover decoration when unmounting
            onRemoveHoverDecoration();
        };
    }, [
        onRemoveHoverDecoration
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.Box), {
        onMouseEnter: onShowHoverDecoration,
        onMouseLeave: onRemoveHoverDecoration,
        onFocus: onShowHoverDecoration,
        onBlur: onRemoveHoverDecoration,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
            elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                color: "var(--ds-icon-danger, #C9372C)",
                label: ""
            }),
            onClick: onClick,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                as: "span",
                color: "color.text.danger",
                children: formatMessage((0, $eKkkY.messages).deleteBlock)
            })
        })
    });
};
const $0c5779d6800c9c7a$export$920a93f5040e5764 = (0, $gmMgo.default)($0c5779d6800c9c7a$var$DeleteDropdownItemContent);





parcelRequire("42omo");




const $84eae03724467f12$export$b65e02347f5cba52 = ({ api: api, children: children })=>{
    const selection = api?.selection?.sharedState?.currentState()?.selection;
    const isEmptyLineSelected = !!selection?.empty;
    if (isEmptyLineSelected) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6UWPx.ToolbarDropdownItemSection), {
        hasSeparator: true,
        children: children
    });
};





















var $4BqOc = parcelRequire("4BqOc");


var $6R5uz = parcelRequire("6R5uz");


const $e9bf4034488d72e7$export$d1e6269624c4d543 = ({ api: api, children: children })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            const payload = {
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).BLOCK_MENU_ITEM,
                attributes: {
                    menuItemName: (0, $5d918711fbc10783$export$659b32b68ac9a52b).FORMAT_MENU
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            };
            api?.analytics?.actions?.attachAnalyticsEvent(payload)(tr);
            return tr;
        });
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $87Gms.ToolbarNestedDropdownMenu), {
        text: formatMessage((0, $eKkkY.messages).turnInto),
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))), {
            label: ""
        }),
        elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
            label: ""
        }),
        enableMaxHeight: true,
        onClick: handleClick,
        dropdownTestId: "editor-nested-turn-into-menu",
        shouldFitContainer: true,
        children: children
    });
};












const $336e1db65e55f27d$export$c21c1480ef33ab5 = ({ children: children, api: api })=>{
    const isFormatMenuHidden = (0, $42omo.useCallback)(()=>{
        return (0, $5b94a729c73f5936$export$b9b8afbbcc99cd12)(api);
    }, [
        api
    ]);
    if (isFormatMenuHidden()) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6UWPx.ToolbarDropdownItemSection), {
        children: children
    });
};























var $ah4M9 = parcelRequire("ah4M9");





var $22Iw9 = parcelRequire("22Iw9");



const $7678dfa5c1fb1bfd$var$MoveDownDropdownItemContent = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { moveFocusTo: moveFocusTo, moveDownRef: moveDownRef } = (0, $31f7b2f877a3c7aa$export$348c130ef35bd15f)();
    const { canMoveDown: canMoveDown } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], ({ blockControlsState: blockControlsState })=>{
        return {
            canMoveDown: blockControlsState?.blockMenuOptions?.canMoveDown
        };
    });
    (0, $42omo.useEffect)(()=>{
        const moveDownElement = moveDownRef.current;
        if (!moveDownElement) return;
        if (!canMoveDown && moveDownElement === document.activeElement) moveFocusTo('moveUp');
    }, [
        canMoveDown,
        moveFocusTo,
        moveDownRef
    ]);
    const handleClick = ()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            const payload = {
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).BLOCK_MENU_ITEM,
                attributes: {
                    menuItemName: (0, $5d918711fbc10783$export$659b32b68ac9a52b).MOVE_DOWN
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            };
            api?.analytics?.actions?.attachAnalyticsEvent(payload)(tr);
            api?.blockControls?.commands?.moveNodeWithBlockMenu((0, $ah4M9.DIRECTION).DOWN)({
                tr: tr
            });
            return tr;
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        triggerRef: moveDownRef,
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($22Iw9))), {
            label: ""
        }),
        isDisabled: !canMoveDown,
        children: formatMessage((0, $eKkkY.messages).moveDownBlock)
    });
};
const $7678dfa5c1fb1bfd$export$bae9e9a61a4ab27d = (0, $gmMgo.default)($7678dfa5c1fb1bfd$var$MoveDownDropdownItemContent);





























var $euUgw = parcelRequire("euUgw");



const $376aff21acaeee17$var$MoveUpDropdownItemContent = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { moveFocusTo: moveFocusTo, moveUpRef: moveUpRef } = (0, $31f7b2f877a3c7aa$export$348c130ef35bd15f)();
    const { canMoveUp: canMoveUp } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], ({ blockControlsState: blockControlsState })=>{
        return {
            canMoveUp: blockControlsState?.blockMenuOptions?.canMoveUp
        };
    });
    (0, $42omo.useEffect)(()=>{
        const moveUpElement = moveUpRef.current;
        if (!moveUpElement) return;
        if (!canMoveUp && moveUpElement === document.activeElement) moveFocusTo('moveDown');
    }, [
        canMoveUp,
        moveFocusTo,
        moveUpRef
    ]);
    const handleClick = ()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            const payload = {
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).BLOCK_MENU_ITEM,
                attributes: {
                    menuItemName: (0, $5d918711fbc10783$export$659b32b68ac9a52b).MOVE_UP
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            };
            api?.analytics?.actions?.attachAnalyticsEvent(payload)(tr);
            api?.blockControls?.commands?.moveNodeWithBlockMenu((0, $ah4M9.DIRECTION).UP)({
                tr: tr
            });
            return tr;
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        triggerRef: moveUpRef,
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euUgw))), {
            label: ""
        }),
        isDisabled: !canMoveUp,
        children: formatMessage((0, $eKkkY.messages).moveUpBlock)
    });
};
const $376aff21acaeee17$export$bed5c407f49c1363 = (0, $gmMgo.default)($376aff21acaeee17$var$MoveUpDropdownItemContent);















/**
 * Suggested transformations mapping for each block type.
 * Based on the Block Menu Compatibility Matrix:
 * https://hello.atlassian.net/wiki/spaces/egcuc/pages/5868774224/Block+Menu+Compatibility+Matrix#Suggested-for-each-block-type
 *
 * This mapping defines which transform items should appear in the TRANSFORM_SUGGESTED_MENU_SECTION
 * for each block type, ranked by priority (lower rank = higher priority).
 *
 * Structure:
 * {
 *   [sourceNodeType]: {
 *     [targetMenuItemKey]: rank
 *   }
 * }
 */ 


const $2596d2da245fab4f$export$3dc4cfed1502c18 = {
    PARAGRAPH: 'paragraph',
    EXPAND: 'expand',
    BLOCKQUOTE: 'blockquote',
    LAYOUT_SECTION: 'layoutSection',
    PANEL: 'panel',
    CODE_BLOCK: 'codeBlock',
    DECISION: 'decisionList',
    BULLET_LIST: 'bulletList',
    ORDERED_LIST: 'orderedList',
    HEADING: 'heading',
    TASK_LIST: 'taskList',
    MEDIA_SINGLE: 'mediaSingle',
    EXTENSION: 'extension',
    BODIED_EXTENSION: 'bodiedExtension',
    BLOCK_CARD: 'blockCard',
    EMBED_CARD: 'embedCard',
    TABLE: 'table'
};
const $2596d2da245fab4f$export$651a8624ef7a76eb = {
    [$2596d2da245fab4f$export$3dc4cfed1502c18.PARAGRAPH]: {
        [(0, $btNLq.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 100,
        [(0, $btNLq.TRANSFORM_HEADINGS_H2_MENU_ITEM).key]: 200,
        [(0, $btNLq.TRANSFORM_HEADINGS_H3_MENU_ITEM).key]: 300
    },
    [$2596d2da245fab4f$export$3dc4cfed1502c18.EXPAND]: {
        [(0, $btNLq.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 100,
        [(0, $btNLq.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]: 200,
        [(0, $btNLq.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 300
    },
    [$2596d2da245fab4f$export$3dc4cfed1502c18.BLOCKQUOTE]: {
        [(0, $btNLq.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 100,
        [(0, $btNLq.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 200,
        [(0, $btNLq.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]: 300
    },
    [$2596d2da245fab4f$export$3dc4cfed1502c18.LAYOUT_SECTION]: {
        [(0, $btNLq.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 100,
        [(0, $btNLq.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]: 200,
        [(0, $btNLq.TRANSFORM_HEADINGS_H2_MENU_ITEM).key]: 300
    },
    [$2596d2da245fab4f$export$3dc4cfed1502c18.PANEL]: {
        [(0, $btNLq.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 100,
        [(0, $btNLq.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key]: 200,
        [(0, $btNLq.TRANSFORM_STRUCTURE_CODE_BLOCK_MENU_ITEM).key]: 300
    },
    [$2596d2da245fab4f$export$3dc4cfed1502c18.CODE_BLOCK]: {
        [(0, $btNLq.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]: 100,
        [(0, $btNLq.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]: 200,
        [(0, $btNLq.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 300
    },
    [$2596d2da245fab4f$export$3dc4cfed1502c18.DECISION]: {
        [(0, $btNLq.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 100,
        [(0, $btNLq.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 200,
        [(0, $btNLq.TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM).key]: 300
    },
    [$2596d2da245fab4f$export$3dc4cfed1502c18.BULLET_LIST]: {
        [(0, $btNLq.TRANSFORM_STRUCTURE_NUMBERED_LIST_MENU_ITEM).key]: 100,
        [(0, $btNLq.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key]: 200,
        [(0, $btNLq.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 300
    },
    [$2596d2da245fab4f$export$3dc4cfed1502c18.ORDERED_LIST]: {
        [(0, $btNLq.TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM).key]: 100,
        [(0, $btNLq.TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM).key]: 200,
        [(0, $btNLq.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 300
    },
    [$2596d2da245fab4f$export$3dc4cfed1502c18.HEADING]: {
        [(0, $btNLq.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 100,
        [(0, $btNLq.TRANSFORM_HEADINGS_H2_MENU_ITEM).key]: 200,
        [(0, $btNLq.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 300
    },
    [$2596d2da245fab4f$export$3dc4cfed1502c18.TASK_LIST]: {
        [(0, $btNLq.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 100,
        [(0, $btNLq.TRANSFORM_STRUCTURE_NUMBERED_LIST_MENU_ITEM).key]: 200,
        [(0, $btNLq.TRANSFORM_STRUCTURE_CODE_BLOCK_MENU_ITEM).key]: 300
    },
    [$2596d2da245fab4f$export$3dc4cfed1502c18.MEDIA_SINGLE]: {
        [(0, $btNLq.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 100,
        [(0, $btNLq.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]: 200,
        [(0, $btNLq.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 300
    },
    [$2596d2da245fab4f$export$3dc4cfed1502c18.EXTENSION]: {
        [(0, $btNLq.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 100,
        [(0, $btNLq.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 200,
        [(0, $btNLq.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]: 300
    },
    [$2596d2da245fab4f$export$3dc4cfed1502c18.BODIED_EXTENSION]: {
        [(0, $btNLq.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 100,
        [(0, $btNLq.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 200,
        [(0, $btNLq.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]: 300
    },
    [$2596d2da245fab4f$export$3dc4cfed1502c18.BLOCK_CARD]: {
        [(0, $btNLq.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 100,
        [(0, $btNLq.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 200
    },
    [$2596d2da245fab4f$export$3dc4cfed1502c18.EMBED_CARD]: {
        [(0, $btNLq.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 100,
        [(0, $btNLq.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 200
    },
    [$2596d2da245fab4f$export$3dc4cfed1502c18.TABLE]: {
        [(0, $btNLq.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]: 100,
        [(0, $btNLq.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]: 200
    }
};
const $2596d2da245fab4f$export$af576b484f6dbef1 = (nodeType)=>{
    return $2596d2da245fab4f$export$651a8624ef7a76eb[nodeType];
};
const $2596d2da245fab4f$export$5a70f53de53a8267 = (nodeType)=>{
    const suggestions = $2596d2da245fab4f$export$af576b484f6dbef1(nodeType);
    if (!suggestions) return [];
    return Object.entries(suggestions).sort(([, rankA], [, rankB])=>rankA - rankB).map(([key])=>key);
};


const $b2fa15e7fa568c6e$export$d00e23a0fe2b15f3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ api: api })=>{
    const { preservedSelection: preservedSelection } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], (states)=>({
            preservedSelection: states.blockControlsState?.preservedSelection
        }));
    const blockMenuComponents = api?.blockMenu?.actions.getBlockMenuComponents();
    const menuItemsMap = (0, $42omo.useMemo)(()=>{
        if (!blockMenuComponents) return new Map();
        return new Map(blockMenuComponents.filter((c)=>c.type === 'block-menu-item').map((item)=>[
                item.key,
                item
            ]));
    }, [
        blockMenuComponents
    ]);
    const suggestedItems = (0, $42omo.useMemo)(()=>{
        if (!preservedSelection || menuItemsMap.size === 0) return [];
        const selectedNode = (0, $7390b563c0364d10$export$da5a91481a5e4aa3)(preservedSelection);
        if (!selectedNode) return [];
        const nodeTypeName = selectedNode.node.type.name;
        const sortedKeys = (0, $2596d2da245fab4f$export$5a70f53de53a8267)(nodeTypeName);
        return sortedKeys.map((key)=>menuItemsMap.get(key)).filter((item)=>item !== undefined);
    }, [
        menuItemsMap,
        preservedSelection
    ]);
    if (suggestedItems.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6UWPx.ToolbarDropdownItemSection), {
        title: "Suggested",
        children: suggestedItems.map((item)=>{
            const ItemComponent = item.component;
            return ItemComponent ? /*#__PURE__*/ (0, $l998X.jsx)(ItemComponent, {}, item.key) : null;
        })
    });
});


const $427c8832ff1a89b9$var$getMoveUpMoveDownMenuComponents = (api)=>{
    return [
        {
            type: 'block-menu-item',
            key: (0, $btNLq.POSITION_MOVE_UP_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.POSITION_MENU_SECTION).key,
                rank: (0, $gEb6G.POSITION_MENU_SECTION_RANK)[(0, $btNLq.POSITION_MOVE_UP_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $376aff21acaeee17$export$bed5c407f49c1363), {
                    api: api
                })
        },
        {
            type: 'block-menu-item',
            key: (0, $btNLq.POSITION_MOVE_DOWN_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.POSITION_MENU_SECTION).key,
                rank: (0, $gEb6G.POSITION_MENU_SECTION_RANK)[(0, $btNLq.POSITION_MOVE_DOWN_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $7678dfa5c1fb1bfd$export$bae9e9a61a4ab27d), {
                    api: api
                })
        }
    ];
};
const $427c8832ff1a89b9$var$getTurnIntoMenuComponents = (api)=>{
    return [
        {
            type: 'block-menu-nested',
            key: (0, $btNLq.TRANSFORM_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_MENU_ITEM).key]
            },
            component: ({ children: children } = {
                children: null
            })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $e9bf4034488d72e7$export$d1e6269624c4d543), {
                    api: api,
                    children: children
                });
            }
        },
        {
            type: 'block-menu-section',
            key: (0, $btNLq.TRANSFORM_SUGGESTED_MENU_SECTION).key,
            parent: {
                type: 'block-menu-nested',
                key: (0, $btNLq.TRANSFORM_MENU_ITEM).key,
                rank: (0, $gEb6G.TRANSFORM_MENU_ITEM_RANK)[(0, $btNLq.TRANSFORM_SUGGESTED_MENU_SECTION).key]
            },
            component: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $b2fa15e7fa568c6e$export$d00e23a0fe2b15f3), {
                    api: api
                })
        },
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_SUGGESTED_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_SUGGESTED_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_SUGGESTED_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_SUGGESTED_MENU_ITEM).key]
            }
        },
        {
            type: 'block-menu-section',
            key: (0, $btNLq.TRANSFORM_CREATE_MENU_SECTION).key,
            parent: {
                type: 'block-menu-nested',
                key: (0, $btNLq.TRANSFORM_MENU_ITEM).key,
                rank: (0, $gEb6G.TRANSFORM_MENU_ITEM_RANK)[(0, $btNLq.TRANSFORM_CREATE_MENU_SECTION).key]
            },
            component: ({ children: children } = {
                children: null
            })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $6UWPx.ToolbarDropdownItemSection), {
                    title: "Create",
                    children: children
                });
            }
        },
        {
            type: 'block-menu-section',
            key: (0, $btNLq.TRANSFORM_STRUCTURE_MENU_SECTION).key,
            parent: {
                type: 'block-menu-nested',
                key: (0, $btNLq.TRANSFORM_MENU_ITEM).key,
                rank: (0, $gEb6G.TRANSFORM_MENU_ITEM_RANK)[(0, $btNLq.TRANSFORM_STRUCTURE_MENU_SECTION).key]
            },
            component: ({ children: children } = {
                children: null
            })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $6UWPx.ToolbarDropdownItemSection), {
                    title: "Structure",
                    children: children
                });
            }
        },
        {
            type: 'block-menu-section',
            key: (0, $btNLq.TRANSFORM_HEADINGS_MENU_SECTION).key,
            parent: {
                type: 'block-menu-nested',
                key: (0, $btNLq.TRANSFORM_MENU_ITEM).key,
                rank: (0, $gEb6G.TRANSFORM_MENU_ITEM_RANK)[(0, $btNLq.TRANSFORM_HEADINGS_MENU_SECTION).key]
            },
            component: ({ children: children } = {
                children: null
            })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $6UWPx.ToolbarDropdownItemSection), {
                    title: "Headings",
                    hasSeparator: true,
                    children: children
                });
            }
        },
        {
            type: 'block-menu-section',
            key: (0, $btNLq.TRANSFORM_MENU_SECTION).key,
            rank: (0, $gEb6G.MAIN_BLOCK_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_MENU_SECTION).key],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $336e1db65e55f27d$export$c21c1480ef33ab5), {
                    api: api,
                    children: children
                });
            }
        }
    ];
};
const $427c8832ff1a89b9$export$b1be7b75e24fc24b = ({ api: api, config: config })=>{
    return [
        ...$427c8832ff1a89b9$var$getTurnIntoMenuComponents(api),
        {
            type: 'block-menu-section',
            key: (0, $btNLq.BLOCK_ACTIONS_MENU_SECTION).key,
            rank: (0, $gEb6G.MAIN_BLOCK_MENU_SECTION_RANK)[(0, $btNLq.BLOCK_ACTIONS_MENU_SECTION).key],
            component: ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4d9b02b8c5c74719$export$ec4637f07afe304), {
                    api: api,
                    children: children
                })
        },
        {
            type: 'block-menu-item',
            key: (0, $btNLq.BLOCK_ACTIONS_COPY_LINK_TO_BLOCK_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.BLOCK_ACTIONS_MENU_SECTION).key,
                rank: (0, $gEb6G.BLOCK_ACTIONS_MENU_SECTION_RANK)[(0, $btNLq.BLOCK_ACTIONS_COPY_LINK_TO_BLOCK_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $ff0afd1293edb1db$export$86b0dd217bb75f55), {
                    api: api,
                    config: config
                })
        },
        {
            type: 'block-menu-section',
            key: (0, $btNLq.POSITION_MENU_SECTION).key,
            rank: (0, $gEb6G.MAIN_BLOCK_MENU_SECTION_RANK)[(0, $btNLq.POSITION_MENU_SECTION).key],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $6UWPx.ToolbarDropdownItemSection), {
                    hasSeparator: true,
                    children: children
                });
            }
        },
        ...$427c8832ff1a89b9$var$getMoveUpMoveDownMenuComponents(api),
        {
            type: 'block-menu-section',
            key: (0, $btNLq.DELETE_MENU_SECTION).key,
            rank: (0, $gEb6G.MAIN_BLOCK_MENU_SECTION_RANK)[(0, $btNLq.DELETE_MENU_SECTION).key],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $84eae03724467f12$export$b65e02347f5cba52), {
                    api: api,
                    children: children
                });
            }
        },
        {
            type: 'block-menu-item',
            key: (0, $btNLq.DELETE_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.DELETE_MENU_SECTION).key,
                rank: (0, $gEb6G.DELETE_MENU_SECTION_RANK)[(0, $btNLq.DELETE_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $0c5779d6800c9c7a$export$920a93f5040e5764), {
                    api: api
                })
        }
    ];
};






parcelRequire("42omo");











var $aD1SW = parcelRequire("aD1SW");

var $eCEXz = parcelRequire("eCEXz");

var $6uGcC = parcelRequire("6uGcC");


var $imt6g = parcelRequire("imt6g");



const $fc48f50aecb84875$var$flagMap = {
    [(0, $99ad5f2b881e8e26$export$5881677fb314e6d9).LINK_COPIED_TO_CLIPBOARD]: {
        title: (0, $eKkkY.messages).linkCopiedToClipboard,
        autoDismiss: true
    }
};
const $fc48f50aecb84875$export$48ea269755562084 = ({ api: api })=>{
    const { showFlag: showFlag } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'blockMenu'
    ], (states)=>{
        return {
            showFlag: states.blockMenuState?.showFlag
        };
    });
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (!showFlag) return;
    const { title: title } = $fc48f50aecb84875$var$flagMap[showFlag];
    const onDismissed = ()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $a4d09cb8508da670$export$8750eaa816e9a19a), {
                showFlag: false
            });
            return tr;
        });
        api?.core.actions.focus();
    };
    const FlagComponent = $fc48f50aecb84875$var$flagMap[showFlag].autoDismiss ? (0, $aD1SW.default) : (0, $eCEXz.default);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)(FlagComponent, {
            onDismissed: onDismissed,
            title: formatMessage(title),
            id: showFlag,
            testId: showFlag,
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
                label: "",
                color: "var(--ds-icon-success, #6A9A23)"
            })
        })
    });
};


const $3ffb488333a8774a$export$dfc601443ba8de15 = ({ api: api, config: config })=>{
    const registry = (0, $30f00e6fa1b4cf3f$export$b5eca477c47c935a)();
    registry.register((0, $427c8832ff1a89b9$export$b1be7b75e24fc24b)({
        api: api,
        config: config
    }));
    return {
        name: 'blockMenu',
        pmPlugins () {
            return [
                {
                    name: 'blockMenuPlugin',
                    plugin: (0, $a4d09cb8508da670$export$ae829ec7b2625219)
                }
            ];
        },
        actions: {
            registerBlockMenuComponents: (blockMenuComponents)=>{
                registry.register(blockMenuComponents);
            },
            getBlockMenuComponents: ()=>{
                return registry.components;
            }
        },
        commands: {
            formatNode: (targetType, analyticsAttrs)=>{
                return (0, $ad6926d0a485b891$export$c7d0412537b63391)(api)(targetType, analyticsAttrs);
            },
            transformNode: (targetType, analyticsAttrs)=>{
                return (0, $da9345aeebc9b4ee$export$eb9a5497877a817a)(api)(targetType, analyticsAttrs);
            }
        },
        getSharedState (editorState) {
            if (!editorState) return {
                currentSelectedNodeName: undefined,
                showFlag: false
            };
            // Get the menuTriggerBy from blockControls plugin if available
            const currentSelectedNodeName = api?.blockControls?.sharedState.currentState()?.menuTriggerBy;
            // Get the showFlag from plugin state
            const pluginState = (0, $a4d09cb8508da670$export$8750eaa816e9a19a).getState(editorState);
            const showFlag = pluginState?.showFlag ?? false;
            return {
                currentSelectedNodeName: currentSelectedNodeName,
                showFlag: showFlag
            };
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $31f7b2f877a3c7aa$export$b01e53fc0770b652), {
                api: api,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ad0695004c479369$export$2e2bcd8739ae039), {
                        editorView: editorView,
                        api: api,
                        mountTo: popupsMountPoint,
                        boundariesElement: popupsBoundariesElement,
                        scrollableElement: popupsScrollableElement
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $fc48f50aecb84875$export$48ea269755562084), {
                        api: api
                    })
                ]
            });
        }
    };
};



var $khxQ7 = parcelRequire("khxQ7");


var $hSJYu = parcelRequire("hSJYu");


var $cwPVT = parcelRequire("cwPVT");


var $duFi2 = parcelRequire("duFi2");


var $agrUc = parcelRequire("agrUc");


var $kXH7i = parcelRequire("kXH7i");


var $acwPl = parcelRequire("acwPl");


var $01uqX = parcelRequire("01uqX");


var $7rj2U = parcelRequire("7rj2U");


var $jgFdO = parcelRequire("jgFdO");


var $5AZDw = parcelRequire("5AZDw");


var $gyXPd = parcelRequire("gyXPd");


var $5y9PZ = parcelRequire("5y9PZ");


var $2yr9J = parcelRequire("2yr9J");


var $kbe7k = parcelRequire("kbe7k");


var $1nZXu = parcelRequire("1nZXu");


var $kIhx9 = parcelRequire("kIhx9");


var $bS1lJ = parcelRequire("bS1lJ");


var $2nH2Y = parcelRequire("2nH2Y");


var $4iQt6 = parcelRequire("4iQt6");


var $4KTOl = parcelRequire("4KTOl");


var $lgjGE = parcelRequire("lgjGE");


var $3mcWz = parcelRequire("3mcWz");



















var $2eY6H = parcelRequire("2eY6H");

class $b03ef52bfaf548e0$export$7ee2d944cdf187e1 extends (0, $2eY6H.Step) {
    invert(doc) {
        return new $b03ef52bfaf548e0$export$7ee2d944cdf187e1({
            inverted: true,
            from: this.from,
            to: this.to,
            mark: this.mark
        });
    }
    apply(doc) {
        return (0, $aXG5V.StepResult).ok(doc);
    }
    merge() {
        return null;
    }
    map(mapping) {
        const mappedFrom = mapping.mapResult(this.from, 1);
        const mappedTo = mapping.mapResult(this.to, 1);
        if (mappedFrom.deleted || mappedTo.deleted) return null;
        return new $b03ef52bfaf548e0$export$7ee2d944cdf187e1({
            inverted: this.inverted,
            from: mappedFrom.pos,
            to: mappedTo.pos
        });
    }
    getMap() {
        return new (0, $aXG5V.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $aXG5V.ReplaceStep)(0, 0, (0, $5SAOw.Slice).empty);
    }
    static from(step) {
        const { mark: mark, from: from, to: to } = step;
        return new $b03ef52bfaf548e0$export$7ee2d944cdf187e1({
            mark: mark,
            from: from,
            to: to
        });
    }
    constructor({ inverted: inverted, from: from, to: to, mark: mark }){
        super();
        this.inverted = void 0;
        this.from = void 0;
        this.to = void 0;
        this.mark = void 0;
        this.inverted = Boolean(inverted);
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
}
class $b03ef52bfaf548e0$export$2a0a7f94dceaed30 extends (0, $2eY6H.Step) {
    invert(doc) {
        return new $b03ef52bfaf548e0$export$2a0a7f94dceaed30({
            inverted: true,
            pos: this.pos,
            mark: this.mark
        });
    }
    apply(doc) {
        return (0, $aXG5V.StepResult).ok(doc);
    }
    merge() {
        return null;
    }
    map(mapping) {
        const mappedPos = mapping.mapResult(this.pos, 1);
        if (mappedPos.deleted) return null;
        return new $b03ef52bfaf548e0$export$2a0a7f94dceaed30({
            inverted: this.inverted,
            pos: mappedPos.pos
        });
    }
    getMap() {
        return new (0, $aXG5V.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $aXG5V.ReplaceStep)(0, 0, (0, $5SAOw.Slice).empty);
    }
    static from(step) {
        const { mark: mark, pos: pos } = step;
        return new $b03ef52bfaf548e0$export$2a0a7f94dceaed30({
            mark: mark,
            pos: pos
        });
    }
    constructor({ inverted: inverted, pos: pos, mark: mark }){
        super();
        this.inverted = void 0;
        this.pos = void 0;
        this.mark = void 0;
        this.inverted = Boolean(inverted);
        this.pos = pos;
        this.mark = mark;
    }
}


const $50cbf7161ff57c52$var$createFilterStepsPlugin = (api)=>()=>new (0, $1S4f7.SafePlugin)({
            filterTransaction: (tr)=>{
                const mode = api?.editorViewMode?.sharedState.currentState()?.mode;
                if (mode !== 'view') return true;
                if (tr.getMeta('isRemote') || tr.getMeta('allowViewModeTransaction') && (0, $dh538.fg)('platform_editor_allow_viewmode_transaction')) return true;
                const viewModeSteps = tr.steps.reduce((acc, s)=>{
                    if (s instanceof (0, $b03ef52bfaf548e0$export$2a0a7f94dceaed30) || s instanceof (0, $b03ef52bfaf548e0$export$7ee2d944cdf187e1)) acc.push(s);
                    return acc;
                }, []);
                if (viewModeSteps.length === 0 || !api) {
                    // Editor should not allow local edits in view mode (except for comments) which are handled
                    // via ViewModeSteps. If we have no ViewModeSteps, we should block the transaction.
                    if ((0, $dh538.fg)('platform_editor_ai_generic_prep_for_aifc')) {
                        if (tr.docChanged && // Check if the transaction contains any steps that modify the document (view mode steps do not)
                        tr.steps.filter((s)=>s instanceof (0, $aXG5V.ReplaceAroundStep) || s instanceof (0, $aXG5V.ReplaceStep) || s instanceof (0, $aXG5V.AddMarkStep) || s instanceof (0, $aXG5V.AddNodeMarkStep) || s instanceof (0, $aXG5V.RemoveMarkStep) || s instanceof (0, $aXG5V.RemoveNodeMarkStep)).length) return false;
                        return true;
                    }
                    return true;
                }
                viewModeSteps.forEach((step)=>{
                    if (step.inverted || !step.mark) return;
                    if (step.mark.type.name === 'annotation') {
                        if (step instanceof (0, $b03ef52bfaf548e0$export$2a0a7f94dceaed30)) api.collabEdit?.actions.addInlineCommentNodeMark({
                            mark: step.mark,
                            pos: step.pos
                        });
                        else if (step instanceof (0, $b03ef52bfaf548e0$export$7ee2d944cdf187e1)) api.collabEdit?.actions.addInlineCommentMark({
                            mark: step.mark,
                            from: step.from,
                            to: step.to
                        });
                    }
                });
                // Ignored via go/ees007
                // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                // TODO: Follow-up and improve annotation logic so we can filter out transactions here
                return true;
            }
        });
const $50cbf7161ff57c52$var$createReplaceDocumentTransactionPlugin = (api)=>()=>new (0, $1S4f7.SafePlugin)({
            // Shouldn't need explicit types but sometimes TS can't infer them so 🤷
            appendTransaction: (transactions, _oldState, newState)=>{
                if (!api) return;
                const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                if (!isViewMode) return;
                const remoteReplaceDocumentTransaction = transactions.find((tr)=>api.collabEdit?.actions?.isRemoteReplaceDocumentTransaction(tr));
                if (!remoteReplaceDocumentTransaction || !remoteReplaceDocumentTransaction.selectionSet) return;
                const doc = newState.doc;
                const nextTr = newState.tr;
                const emptySelection = new (0, $ks2lK.TextSelection)(doc.resolve(0));
                nextTr.setSelection(emptySelection);
                return nextTr;
            }
        });
const $50cbf7161ff57c52$export$d510e4d48c393847 = ({ api: api })=>({
        name: 'editorViewModeEffects',
        actions: {
            allowViewModeTransaction: (tr)=>{
                tr.setMeta('allowViewModeTransaction', true);
                return tr;
            },
            applyViewModeStepAt: (tr)=>{
                const marksSteps = tr.steps.reduce((acc, s)=>{
                    // Ignored via go/ees007
                    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                    // TODO: We probably want to check the RemoveMarkStep flow too.
                    if (s instanceof (0, $aXG5V.AddMarkStep) || s instanceof (0, $aXG5V.AddNodeMarkStep)) acc.push(s);
                    return acc;
                }, []);
                if (marksSteps.length === 0) return false;
                marksSteps.reverse().map((s)=>s instanceof (0, $aXG5V.AddNodeMarkStep) ? tr.step((0, $b03ef52bfaf548e0$export$2a0a7f94dceaed30).from(s)) : tr.step((0, $b03ef52bfaf548e0$export$7ee2d944cdf187e1).from(s)));
                return true;
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'editorViewModeEffectsFilterSteps',
                    plugin: $50cbf7161ff57c52$var$createFilterStepsPlugin(api)
                },
                {
                    name: 'editorViewModeEffectsReplaceDocumentTransaction',
                    plugin: $50cbf7161ff57c52$var$createReplaceDocumentTransactionPlugin(api)
                }
            ];
        }
    });



var $hcboS = parcelRequire("hcboS");


var $8ABVP = parcelRequire("8ABVP");


var $fTvEN = parcelRequire("fTvEN");


var $eyggb = parcelRequire("eyggb");


var $l7rln = parcelRequire("l7rln");


var $dtCIm = parcelRequire("dtCIm");


var $7sK9h = parcelRequire("7sK9h");


var $jS0a0 = parcelRequire("jS0a0");


var $6q6xk = parcelRequire("6q6xk");


var $fYKTL = parcelRequire("fYKTL");


var $fCLXZ = parcelRequire("fCLXZ");


var $flknw = parcelRequire("flknw");


var $cu2RD = parcelRequire("cu2RD");


var $HYzBP = parcelRequire("HYzBP");


var $gATpw = parcelRequire("gATpw");


var $aUwPP = parcelRequire("aUwPP");


var $cVhn8 = parcelRequire("cVhn8");


var $6AqNX = parcelRequire("6AqNX");


var $05jmd = parcelRequire("05jmd");








var $fFa3V = parcelRequire("fFa3V");





var $c067q = parcelRequire("c067q");


var $6qdjm = parcelRequire("6qdjm");


var $auNCB = parcelRequire("auNCB");


var $aeAfU = parcelRequire("aeAfU");










const $bd6b8d63fb0cd3e9$export$4d696a2f56515a41 = new (0, $ks2lK.PluginKey)('limitedModePlugin');
const $bd6b8d63fb0cd3e9$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $bd6b8d63fb0cd3e9$export$4d696a2f56515a41,
        view: (_view)=>{
            return {};
        },
        state: {
            init (config, editorState) {
                // @ts-expect-error - true is not allowed as a default value
                if ((0, $aeAfU.expVal)('cc_editor_limited_mode_include_lcm', 'isEnabled', true)) {
                    // calculates the size of the doc, where when there are legacy content macros, the content
                    // is stored in the attrs.
                    // This is essentiall doc.nod
                    let customDocSize = editorState.doc.nodeSize;
                    editorState.doc.descendants((node)=>{
                        if (node.attrs?.extensionKey === 'legacy-content') customDocSize += node.attrs?.parameters?.adf?.length ?? 0;
                    });
                    return {
                        documentSizeBreachesThreshold: customDocSize > (0, $aeAfU.expVal)('cc_editor_limited_mode', 'nodeSize', 100)
                    };
                } else {
                    if (editorState.doc.nodeSize > (0, $aeAfU.expVal)('cc_editor_limited_mode', 'nodeSize', 100)) return {
                        documentSizeBreachesThreshold: true
                    };
                    return {
                        documentSizeBreachesThreshold: false
                    };
                }
            },
            apply: (tr, currentPluginState)=>{
                // Don't check the document size if we're already in limited mode.
                // We ALWAYS want to re-check the document size if we're replacing the document (e.g. live-to-live page navigation).
                if (currentPluginState.documentSizeBreachesThreshold && !tr.getMeta('replaceDocument')) return currentPluginState;
                // @ts-expect-error - true is not allowed as a default value
                if ((0, $aeAfU.expVal)('cc_editor_limited_mode_include_lcm', 'isEnabled', true)) {
                    // calculates the size of the doc, where when there are legacy content macros, the content
                    // is stored in the attrs.
                    // This is essentiall doc.nod
                    let customDocSize = tr.doc.nodeSize;
                    tr.doc.descendants((node)=>{
                        if (node.attrs?.extensionKey === 'legacy-content') customDocSize += node.attrs?.parameters?.adf?.length ?? 0;
                    });
                    return {
                        documentSizeBreachesThreshold: customDocSize > (0, $aeAfU.expVal)('cc_editor_limited_mode', 'nodeSize', 100)
                    };
                } else {
                    if (tr.doc.nodeSize > (0, $aeAfU.expVal)('cc_editor_limited_mode', 'nodeSize', 100)) return {
                        ...currentPluginState,
                        documentSizeBreachesThreshold: true
                    };
                    return {
                        ...currentPluginState,
                        documentSizeBreachesThreshold: false
                    };
                }
            }
        }
    });
};


const $c6eda9ff2d183267$export$9f825df6a9c9b35b = ({ config: options = {}, api: api })=>{
    return {
        name: 'limitedMode',
        pmPlugins () {
            return [
                {
                    name: 'limitedModePlugin',
                    plugin: (0, $bd6b8d63fb0cd3e9$export$ae829ec7b2625219)
                }
            ];
        },
        getSharedState (editorState) {
            if (editorState) return {
                get enabled () {
                    return (0, $bd6b8d63fb0cd3e9$export$4d696a2f56515a41).getState(editorState)?.documentSizeBreachesThreshold ?? false;
                },
                limitedModePluginKey: $bd6b8d63fb0cd3e9$export$4d696a2f56515a41
            };
            return {
                enabled: false,
                limitedModePluginKey: $bd6b8d63fb0cd3e9$export$4d696a2f56515a41
            };
        },
        usePluginHook: ({ editorView: editorView })=>{
            const hasEditorBeenFocusedRef = (0, $42omo.useRef)(false);
            const hasShownFlagRef = (0, $42omo.useRef)(false);
            const { formatMessage: formatMessage } = (0, $8C5kA.default)();
            // Reset hasEditorBeenFocusedRef so live-to-live page navigation refreshes the flag. We rely on the page's contentId for this.
            (0, $42omo.useEffect)(()=>{
                hasShownFlagRef.current = false;
            // eslint-disable-next-line react-hooks/exhaustive-deps
            }, [
                options.contentId
            ]);
            const checkAndShowFlag = (0, $42omo.useCallback)((isLimitedModeEnabled)=>{
                // @ts-expect-error - true is not allowed as a default value
                if (!((0, $aeAfU.expVal)('cc_editor_limited_mode', 'flagEnabled', true) === true)) // Disable the flag behavior entirely if the flag is off
                return;
                const learnMoreLink = (0, $aeAfU.expVal)('cc_editor_limited_mode', 'learnMoreLink', '');
                if (isLimitedModeEnabled && hasEditorBeenFocusedRef.current && !hasShownFlagRef.current) {
                    options.showFlag?.({
                        title: formatMessage((0, $c067q.limitedModeMessages).limitedModeTitle),
                        description: learnMoreLink ? formatMessage((0, $c067q.limitedModeMessages).limitedModeDescriptionWithLink, {
                            learnMoreLink: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
                                    target: "_blank",
                                    href: learnMoreLink,
                                    children: chunks
                                })
                        }) : formatMessage((0, $c067q.limitedModeMessages).limitedModeDescriptionWithoutLink),
                        close: 'auto'
                    });
                    hasShownFlagRef.current = true;
                }
            }, [
                formatMessage
            ]);
            // Track if the editor has been focused. On focus, check if the flag should be shown.
            (0, $42omo.useEffect)(()=>{
                const handleFocus = ()=>{
                    hasEditorBeenFocusedRef.current = true;
                    // Get current state when focus happens
                    const isLimitedModeEnabled = api?.limitedMode?.sharedState.currentState()?.enabled ?? false;
                    checkAndShowFlag(isLimitedModeEnabled);
                };
                const unbind = (0, $fFa3V.bind)(editorView.dom, {
                    type: 'focus',
                    listener: handleFocus
                });
                return ()=>{
                    unbind();
                };
            }, [
                editorView,
                checkAndShowFlag
            ]);
            // On change of the limited mode enabled state, check if the flag should be shown.
            (0, $6qdjm.usePluginStateEffect)(api, [
                'limitedMode'
            ], ({ limitedModeState: limitedModeState })=>{
                const isLimitedModeEnabled = limitedModeState?.enabled ?? false;
                checkAndShowFlag(isLimitedModeEnabled);
            });
        }
    };
};



var $5HHoF = parcelRequire("5HHoF");


var $lQotL = parcelRequire("lQotL");


var $80JwR = parcelRequire("80JwR");


var $cWFvG = parcelRequire("cWFvG");


var $2U68K = parcelRequire("2U68K");


var $5u7tz = parcelRequire("5u7tz");


var $dH9DB = parcelRequire("dH9DB");


var $kcvNv = parcelRequire("kcvNv");


var $b3BjA = parcelRequire("b3BjA");


var $36iDo = parcelRequire("36iDo");


var $59fTa = parcelRequire("59fTa");


var $kYgUn = parcelRequire("kYgUn");


var $8HLyI = parcelRequire("8HLyI");


var $itirX = parcelRequire("itirX");


var $e6sdP = parcelRequire("e6sdP");


var $5DsxN = parcelRequire("5DsxN");


var $1GAIu = parcelRequire("1GAIu");


var $bULcr = parcelRequire("bULcr");


var $4NiQW = parcelRequire("4NiQW");


var $5Qu3R = parcelRequire("5Qu3R");


var $7nKrc = parcelRequire("7nKrc");


var $84Iqc = parcelRequire("84Iqc");


var $c8680 = parcelRequire("c8680");


var $6borH = parcelRequire("6borH");


var $efDik = parcelRequire("efDik");


var $eeGWn = parcelRequire("eeGWn");


var $jaskt = parcelRequire("jaskt");


var $i2zv0 = parcelRequire("i2zv0");


var $5mDFx = parcelRequire("5mDFx");


var $3JBsx = parcelRequire("3JBsx");


var $1KHo7 = parcelRequire("1KHo7");


var $aB4bz = parcelRequire("aB4bz");


var $fMaLE = parcelRequire("fMaLE");


var $bz4KD = parcelRequire("bz4KD");


var $kw2eg = parcelRequire("kw2eg");


var $vxKdN = parcelRequire("vxKdN");


var $3O0YV = parcelRequire("3O0YV");


var $hEicH = parcelRequire("hEicH");


var $fI6T7 = parcelRequire("fI6T7");





var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");





var $4DEL1 = parcelRequire("4DEL1");


var $1ewUw = parcelRequire("1ewUw");


var $7OCNe = parcelRequire("7OCNe");


var $dF1N1 = parcelRequire("dF1N1");


var $dx8CK = parcelRequire("dx8CK");

function $03a647a335c52f20$export$13aeab2a71badd1e({ options: options }) {
    // Options not declared here as they are all nested inside hooks, starting with `useEditorPluginAIDefinitionsConfig`.
    return options;
}


function $0e54a671895f12da$export$a2b90416e38bfd44({ options: options }) {
    // Options not declared here as they are all nested inside hooks, starting with `useEditorPluginAIOptions`.
    return options;
}


function $57bfcdb96b39b33a$export$3dd05c02043bb4e8({ options: options }) {
    // Options not declared here as they are all nested inside hooks, starting with `useEditorPluginAIProactiveConfig`.
    return options;
}


function $b499f1aa43aeb0ae$export$bfd53895e8497571({}) {
    return {};
}


function $8ed9740f118d687b$export$b3e029fd31f94f55({ options: options, providers: providers }) {
    if (!providers.inlineCommentAnnotationProvider) return undefined;
    return {
        inlineComment: providers.inlineCommentAnnotationProvider,
        createCommentExperience: options.createCommentExperience,
        selectCommentExperience: {
            selectAnnotation: {
                complete: (annotationId)=>{
                    options.selectCommentExperience?.selectAnnotation.complete({
                        pageClass: 'editor',
                        annotationId: annotationId,
                        entryPoint: 'annotation-change'
                    });
                }
            }
        },
        viewInlineCommentTraceUFOPress: options.viewInlineCommentTraceUFOPress,
        annotationManager: options.annotationManager
    };
}


function $ad7357a8ed7dfd42$export$eeaea850bc5c5797({ options: options }) {
    return {
        // Avatars are moved to Confluence codebase for Edit in Context
        // When Edit in Context is enabled primaryToolbarComponents is undefined
        // For more details please check
        // https://hello.atlassian.net/wiki/spaces/PCG/pages/2851572180/Editor+toolbar+for+live+pages+and+edit+in+context+projects
        collabEdit: options.collabEdit,
        // originally depends on !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        showAvatarGroup: false
    };
}





function $78a1544f00d30a05$export$a23b3fa66082f163({ options: options }) {
    const removeScrollGutter = !(0, $dh538.fg)('confluence_frontend_content_wrapper') && options.__livePage && (0, $dh538.fg)('confluence_frontend_comments_panel_v2');
    return {
        allowInlineCursorTarget: true,
        allowScrollGutter: removeScrollGutter ? undefined : {
            getScrollElement: ()=>document.querySelector('.fabric-editor-popup-scroll-parent')
        }
    };
}


function $849252e5cfbe6f75$export$817c0e398e6ff750({}) {
    return {
        includeBlockQuoteAsTextstyleOption: true,
        lastNodeMustBeParagraph: false,
        isUndoRedoButtonsEnabled: true,
        allowBlockType: undefined
    };
}


function $18709874e4301e98$export$3be6b735d5cbc3e6({ options: options }) {
    return {
        allowBreakoutButton: options.editorAppearance === 'full-page',
        appearance: options.editorAppearance
    };
}



var $eTj7Y = parcelRequire("eTj7Y");

// SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $f8013e4ced731918$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $f8013e4ced731918$export$514131654bb897e2({ options: options, providers: providers }) {
    return {
        // From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `CARD_OPTIONS =`
        allowDatasource: true,
        // END SECTION
        // SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
        provider: providers.cardProvider,
        resolveBeforeMacros: $f8013e4ced731918$var$SMART_LINKS_BEFORE_MACROS,
        allowBlockCards: true,
        allowEmbeds: true,
        // END SECTION
        onClickCallback: options.onClickCallback,
        fullWidthMode: options.editorAppearance === 'full-width',
        linkPicker: options.linkPicker,
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        lpLinkPicker: true,
        // END SECTION
        editorAppearance: options.editorAppearance,
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage,
        isPageSSRed: Boolean((0, $eTj7Y.isSSR)() || window.__SSR_RENDERED__),
        CompetitorPrompt: options.CompetitorPrompt
    };
}


function $c70218b234c6d78f$export$3f0ff0bcf72f4d98({ options: options }) {
    return {
        appearance: options.editorAppearance
    };
}





function $54a86813db4d4780$export$6e32a592ec823802({}) {
    return {
        allowCodeFolding: (0, $1oCLl.expValEquals)('platform_editor_code_block_fold_gutter', 'isEnabled', true)
    };
}


function $de05ec98c0250c98$export$74cc43e84bb9c20({}) {
    return {
        allowCopyToClipboard: true,
        useLongPressSelection: false,
        allowCompositionInputOverride: false
    };
}



var $NPJKR = parcelRequire("NPJKR");




function $e2f5d02097d0844c$export$c1ebe19806bc53b1({ options: options, providers: providers }) {
    return {
        // Core options
        provider: providers.collabEditProvider,
        userId: options.collabEdit?.userId,
        useNativePlugin: options.collabEdit?.useNativePlugin,
        sanitizePrivateContent: true,
        hideTelecursorOnLoad: options.__livePage || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true),
        // Invite to edit related options
        inviteToEditHandler: options.collabEdit?.inviteToEditHandler,
        isInviteToEditButtonSelected: options.collabEdit?.isInviteToEditButtonSelected,
        inviteToEditComponent: options.collabEdit?.inviteToEditComponent,
        // Analytics options
        EXPERIMENTAL_allowInternalErrorAnalytics: options.collabEdit?.EXPERIMENTAL_allowInternalErrorAnalytics ?? (0, $NPJKR.shouldForceTracking)()
    };
}


function $815cf72c0fd01db1$export$2c26eb5ff90afcfd({ providers: providers }) {
    return {
        contextIdentifierProvider: providers.contextIdentifierProvider
    };
}





function $d7dae729776ab102$export$48a60d81b6bb28e3({ options: options }) {
    if (!options) return undefined;
    return(// SECTION: From confluence/next/packages/editor-presets/src/full-page/useFullPageEditorPreset.ts
    // If object-sidebar is not enabled, then we don't need to pass the contextPanelOptions
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $dh538.fg)('confluence_frontend_content_wrapper') && (0, $dh538.fg)('platform_editor_ai_object_sidebar_injection') ? {
        objectSideBar: options.objectSideBar
    } : undefined);
}


function $0239ddf6db5a0e53$export$f18d68682e981a91({ providers: providers }) {
    return {
        autoformattingProvider: providers.autoformattingProvider
    };
}


function $0105ad9f4c3353d7$export$5598bb2314a53fa8({}) {
    return {
        weekStartDay: undefined
    };
}


function $22bbbcb7ca748783$export$de47eee62065048e({ options: options }) {
    return {
        initialDisabledState: options?.disabled
    };
}


function $f342e2c893778f00$export$36a79e2b5698697a({ options: options }) {
    return {
        mode: options.viewMode
    };
}


function $0ec938d111941985$export$7adcaf18ca5c72c4({ providers: providers }) {
    return {
        emojiProvider: providers.emojiProvider,
        emojiNodeDataProvider: providers.emojiNodeDataProvider
    };
}



var $axAnW = parcelRequire("axAnW");

var $kkQZq = parcelRequire("kkQZq");

var $iPfZG = parcelRequire("iPfZG");

var $hwWwS = parcelRequire("hwWwS");

function $d63a2b43135c498f$export$128eafe7f843e327({ options: options }) {
    return {
        epComponents: {
            EngagementSpotlight: $iPfZG.EngagementSpotlight,
            EngagementInlineDialog: $kkQZq.default,
            Coordination: $axAnW.default
        },
        epHooks: {
            useCoordination: $hwWwS.useCoordination
        },
        coordinationClient: options.coordinationClient
    };
}


function $759d2e4ef0d8b24b$export$ed53f0c49fce09d6({ options: options }) {
    return {
        allowInsertion: true,
        useLongPressSelection: false,
        appearance: options.editorAppearance,
        allowInteractiveExpand: true,
        __livePage: options.__livePage
    };
}


function $2a51a0f7e6ad908c$export$c18b9102cd0790c9({ options: options }) {
    return {
        breakoutEnabled: options.editorAppearance === 'full-page',
        extensionHandlers: options.extensionHandlers,
        useLongPressSelection: false,
        appearance: options.editorAppearance,
        __rendererExtensionOptions: options.__rendererExtensionOptions,
        getExtensionHeight: options.getExtensionHeight
    };
}





function $13d21f4408f33e88$export$3bff061e5229a7({}) {
    /**
	 * @private
	 * @deprecated Don't add any new feature flags here!
	 *             If you need a new feature flag, use:
	 *             - {@link editorExperiment} for new experiments.
	 *             - {@link fg} for new feature gates.
	 */ return {
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        /**
		 * This feature flag has completed rollout in Confluence and is to be cleaned up from LD
		 * but cannot yet be cleaned up from editor component as pending rollout in other products first
		 */ lpLinkPicker: true,
        tableDragAndDrop: true,
        tableWithFixedColumnWidthsOption: true,
        // END SECTION
        // SECTION: From confluence/next/packages/full-page-editor/src/hooks/useEditorFullPageExperiments.ts
        tableSelector: (0, $iu6m9.editorExperiment)('platform_editor_tables_table_selector', true),
        macroInteractionUpdates: true,
        moreElementsInQuickInsertView: true,
        // END SECTION
        // SECTION: From confluence/next/packages/editor-presets/src/utils/createFeatureFlagsFromProps.ts
        catchAllTracking: false,
        showAvatarGroupAsPlugin: false,
        errorBoundaryDocStructure: false,
        synchronyErrorDocStructure: false,
        enableViewUpdateSubscription: false,
        collabAvatarScroll: false,
        twoLineEditorToolbar: false,
        disableSpellcheckByBrowser: undefined
    };
}


function $3434917e042efc57$export$d9e183f0607e1b5d({}) {
    return {
        // originally depends on !!featureFlags.showAvatarGroupAsPlugin === false && !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        twoLineEditorToolbar: false
    };
}


function $f0763edceecb76c2$export$c66d0d1462a05bd({}) {
    return {
        shouldCalcBreakoutGridLines: true
    };
}





function $eab9055a4a41e7c7$export$2a67100cd9c61f05({ options: options }) {
    if ((0, $iu6m9.editorExperiment)('platform_editor_ai_quickstart_command', true)) return options;
    return false;
}


function $ba2e03c1e9271b78$export$ab9ae3984d5aef33({ options: options }) {
    return {
        editorAppearance: options.editorAppearance,
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        lpLinkPicker: true,
        // END SECTION
        linkPicker: options.linkPicker,
        onClickCallback: options.onClickCallback,
        platform: 'web'
    };
}





function $6e8873e0128315d2$export$1e11b615e9dc119e({ options: options }) {
    return {
        allowTables: true,
        allowExpand: true,
        horizontalRuleEnabled: true,
        tableSelectorSupported: (0, $iu6m9.editorExperiment)('platform_editor_tables_table_selector', true),
        nativeStatusSupported: true,
        showElementBrowserLink: true,
        appearance: options.editorAppearance,
        toolbarButtons: options.toolbarButtons
    };
}


function $0c59805b4172bf23$export$33fb6c6592b2cd5f({ options: options }) {
    return {
        allowBreakout: true,
        UNSAFE_addSidebarLayouts: true,
        useLongPressSelection: false,
        UNSAFE_allowSingleColumnLayout: undefined,
        editorAppearance: options.editorAppearance
    };
}


function $a233792833dda4ec$export$d384a797e800fdbe({ options: options }) {
    return {
        showFlag: options.showFlag,
        contentId: options.contentId
    };
}





function $1bb1e0cb9a7988e8$export$feaee25faac0c640({ options: options }) {
    return {
        // SECTION: From confluence/next/packages/loom-editor-utils/src/hooks/useLoomPluginOptions.tsx
        renderButton: options.renderButton,
        shouldShowToolbarButton: (0, $dh538.fg)('confluence_frontend_content_wrapper') ? false : undefined
    };
}





const $5e5a949da08ce418$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    invalidAltText: {
        id: "editor-presets-confluence.media.alt-text.invalid",
        defaultMessage: "We aren\u2019t able to accept every possible character in Alt text. All Unicode letters and numbers are OK, but these are the only acceptable symbols: , ' . - _ ( )."
    }
});


function $1412367cad2aa59d$export$484123ae56f6fbd9({ intl: intl, options: options, providers: providers }) {
    return {
        // SECTION: From confluence/next/packages/editor-features/src/utils/mediaOptions.ts
        provider: providers.mediaProvider,
        syncProvider: providers.syncMediaProvider,
        allowMediaSingle: true,
        allowResizing: true,
        allowResizingInTables: true,
        allowLinking: true,
        allowAltTextOnImages: true,
        allowCaptions: true,
        allowMediaInlineImages: true,
        allowPixelResizing: true,
        altTextValidator: (text)=>{
            // @ts-ignore - TS1501 Typescript 5.9.2 upgrade
            const storageSupports = RegExp("^([\\p{L}\\p{N},'\\.\\s\\-_\\(\\)]|&amp;[0-9]{2};)*$", "u");
            if (!storageSupports.test(text)) return [
                intl.formatMessage((0, $5e5a949da08ce418$export$a7357cdd1f0b0168).invalidAltText)
            ];
            return [];
        },
        // END SECTION
        // SECTION: From confluence/next/packages/fabric-media-support/src/mediaFeatureFlags.ts
        featureFlags: {
            mediaInline: true
        },
        // END SECTION
        // SECTION: From confluence/next/packages/editor-presets/src/full-page/createFullPageEditorPreset.ts
        allowLazyLoading: true,
        allowBreakoutSnapPoints: true,
        allowAdvancedToolBarOptions: true,
        // originally value was Boolean(options.annotationProviders),
        allowCommentsOnMedia: true,
        allowDropzoneDropLine: true,
        allowMediaSingleEditable: true,
        allowRemoteDimensionsFetch: true,
        allowMarkingUploadsAsIncomplete: false,
        allowImagePreview: true,
        fullWidthEnabled: options.editorAppearance === 'full-width',
        editorAppearance: options.editorAppearance,
        isCopyPasteEnabled: true,
        alignLeftOnInsert: false,
        // END SECTION
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx
        waitForMediaUpload: true
    };
}


function $4c9dc0bddcbec186$export$e15342409979aa19({ options: options, providers: providers }) {
    return {
        sanitizePrivateContent: true,
        insertDisplayName: true,
        allowZeroWidthSpaceAfter: true,
        profilecardProvider: providers.profilecardProvider,
        handleMentionsChanged: options.handleMentionsChanged,
        mentionProvider: providers.mentionProvider
    };
}


function $85c17a3a2c6c7b85$export$4677177d82484aef({ options: options }) {
    return options;
}


function $fc9f968714fe9c5d$export$c18e432f323b002e({}) {
    return {
        useLongPressSelection: false,
        allowCustomPanel: true,
        allowCustomPanelEdit: true
    };
}


// SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $49e9bc2589f6c0e6$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $49e9bc2589f6c0e6$export$6b1ad42d09c74964({ providers: providers }) {
    return {
        cardOptions: {
            provider: providers.cardProvider,
            // SECTION: From confluence/next/packages/editor-features/src/utils/smartCardOptions.ts
            allowBlockCards: true,
            allowDatasource: true,
            allowEmbeds: true,
            resolveBeforeMacros: $49e9bc2589f6c0e6$var$SMART_LINKS_BEFORE_MACROS
        },
        sanitizePrivateContent: true,
        isFullPage: true
    };
}



var $iJQnc = parcelRequire("iJQnc");

var $aoDcQ = parcelRequire("aoDcQ");










const $3e5e5c18746b8d36$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    easyMentionsPlaceholder: {
        id: "editor-presets-confluence.placeholder.easy-mentions-placeholder",
        defaultMessage: "Type / for all elements or @ to mention someone."
    },
    aiPlaceholder: {
        id: "editor-presets-confluence.placeholder.ai-placeholder",
        defaultMessage: "Type /ai for Atlassian Intelligence, / to add elements, or @ to mention someone (we'll let them know)."
    },
    defaultPlaceholder: {
        id: "editor-presets-confluence.placeholder.default-placeholder",
        defaultMessage: "Type / to insert elements"
    },
    editorEmptyDocumentPlaceholderAI: {
        id: "editor-presets-confluence.placeholder.default-placeholder-ai",
        defaultMessage: "Use {key}+' to ask AI, or type / to insert elements"
    },
    editorEmptyDocumentSpaceShortcutPlaceholder: {
        id: "editor-presets-confluence.placeholder.space-shortcut-placeholder",
        defaultMessage: "Press space to Ask Rovo or / to insert elements"
    },
    editorEmptyDocumentSpaceShortcutPlaceholderADFPrefix: {
        id: "editor-presets-confluence.placeholder.space-shortcut-adf-prefix",
        defaultMessage: "Press"
    },
    editorEmptyDocumentSpaceShortcutPlaceholderADFSpaceShortcut: {
        id: "editor-presets-confluence.placeholder.space-shortcut-adf-space-key",
        defaultMessage: "space"
    },
    editorEmptyDocumentSpaceShortcutPlaceholderADFMiddle: {
        id: "editor-presets-confluence.placeholder.space-shortcut-adf-middle",
        defaultMessage: "to Ask Rovo or"
    },
    editorEmptyDocumentSpaceShortcutPlaceholderADFSlashShortcut: {
        id: "editor-presets-confluence.placeholder.space-shortcut-adf-slash-key",
        defaultMessage: "/"
    },
    editorEmptyDocumentSpaceShortcutPlaceholderADFSuffix: {
        id: "editor-presets-confluence.placeholder.space-shortcut-adf-suffix",
        defaultMessage: "to insert elements"
    }
});


const $01e23cb99d262862$var$createSpaceShortcutPlaceholderADF = ({ formatMessage: formatMessage })=>({
        version: 1,
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: [
                    (0, $aoDcQ.text)(formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).editorEmptyDocumentSpaceShortcutPlaceholderADFPrefix)),
                    (0, $aoDcQ.text)(' '),
                    (0, $iJQnc.code)(formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).editorEmptyDocumentSpaceShortcutPlaceholderADFSpaceShortcut)),
                    (0, $aoDcQ.text)(' '),
                    (0, $aoDcQ.text)(formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).editorEmptyDocumentSpaceShortcutPlaceholderADFMiddle)),
                    (0, $aoDcQ.text)(' '),
                    (0, $iJQnc.code)(formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).editorEmptyDocumentSpaceShortcutPlaceholderADFSlashShortcut)),
                    (0, $aoDcQ.text)(' '),
                    (0, $aoDcQ.text)(formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).editorEmptyDocumentSpaceShortcutPlaceholderADFSuffix))
                ]
            }
        ]
    });
function $01e23cb99d262862$export$c6841f879d4c8aef({ intl: intl, options: options }) {
    const shouldShowSpaceShortcut = options.isAIEnabled && (0, $dh538.fg)('platform_editor_ai_aifc_streaming');
    const placeholder = (()=>{
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `const placeholderText = `
        if (options.viewMode === 'view') return undefined;
        // END SECTION
        if (shouldShowSpaceShortcut && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) // We disable the placeholder here becuase we want to use the new ADF placeholder, see below.
        return undefined;
        // SECTION: From confluence/next/packages/full-page-editor/src/FullPageEditorComponent.tsx `_getPlaceholderText()`
        if (shouldShowSpaceShortcut && !(0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) return intl.formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).editorEmptyDocumentSpaceShortcutPlaceholder);
        if (!options.isAIEnabled && (0, $iu6m9.editorExperiment)('platform_editor_ai_quickstart_command', true)) return intl.formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).editorEmptyDocumentPlaceholderAI);
        if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return intl.formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).defaultPlaceholder);
        if (!options.isAIEnabled) return intl.formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).aiPlaceholder);
        return intl.formatMessage((0, $3e5e5c18746b8d36$export$a7357cdd1f0b0168).easyMentionsPlaceholder);
    // END SECTION
    })();
    const placeholderADF = (()=>{
        if (options.viewMode === 'view') return undefined;
        if (shouldShowSpaceShortcut && (0, $dh538.fg)('platform_editor_ai_aifc_space_shortcut')) return $01e23cb99d262862$var$createSpaceShortcutPlaceholderADF(intl);
        return undefined;
    })();
    return {
        placeholder: placeholder,
        placeholderADF: placeholderADF,
        withEmptyParagraph: (0, $dh538.fg)('platform_editor_ai_aifc_streaming')
    };
}


function $adb03a718cdd3145$export$8b53e6ddc7cf96b4({}) {
    return {};
}


function $66d5390e1d65d1af$export$44901d053a58e418({ options: options }) {
    return {
        contextualFormattingEnabled: options.contextualFormattingEnabled
    };
}


function $9c8df38044d63cd4$export$26cff1f2fe9f781b({ options: options }) {
    return {
        enableElementBrowser: true,
        elementBrowserHelpUrl: '',
        disableDefaultItems: false,
        headless: false,
        emptyStateHandler: options?.emptyStateHandler,
        prioritySortingFn: typeof options.quickInsert === 'object' ? options.quickInsert.prioritySortingFn : undefined,
        onInsert: typeof options.quickInsert === 'object' ? options.quickInsert.onInsert : undefined
    };
}


function $ed5f509dae6ecf5b$export$13a2743c2a93c688({ options: options }) {
    return {
        api: options.referentialityContext.api ?? undefined,
        // A spread operator of the options.referentialityContext.options was previously used here, now they're all explicitly listed out to make the code more readable.
        appearance: options.referentialityContext.options.appearance,
        extensionHandlers: options.referentialityContext.options.extensionHandlers,
        externalObservers: options.referentialityContext.options.externalObservers,
        nodeNameCallback: options.referentialityContext.options.nodeNameCallback,
        nodeFocusCallback: options.referentialityContext.options.nodeFocusCallback,
        editorAnalyticsAPI: options.referentialityContext.options.editorAnalyticsAPI,
        editorView: options.referentialityContext.options.editorView,
        featureFlags: options.referentialityContext.options.featureFlags,
        __livePage: options.referentialityContext.options.__livePage,
        __rendererExtensionOptions: options.referentialityContext.options.__rendererExtensionOptions,
        getExtensionHeight: options.referentialityContext.options.getExtensionHeight
    };
}


function $70edb4b454693530$export$222c5aa4c9fb0805({ options: options }) {
    return options;
}





function $45e8d9f61045475c$export$197b78e13e8987d2({ options: options }) {
    // SECTION: From confluence/next/packages/editor-presets/src/full-page/createFullPageEditorPreset.ts `.add(['selectionMarkerPlugin', ...])`
    return {
        hideCursorOnInit: options.__livePage || (0, $1oCLl.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)
    };
// END SECTION
}


function $d84bbda11ad6763d$export$ddc2936355c1da67({ options: options }) {
    return {
        useLongPressSelection: false,
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage
    };
}


function $9a57111cbcc407d6$export$bc6dcb3c2a6112e1({ options: options, providers: providers }) {
    return {
        preferenceToolbarAboveSelection: false,
        contextualFormattingEnabled: options.contextualFormattingEnabled,
        userPreferencesProvider: providers.userPreferencesProvider
    };
}


function $f5ca45a4f682676c$export$5c1f265f89d46b24({ options: options }) {
    if (!options?.originalDoc || !options?.steps) return undefined;
    return {
        originalDoc: options.originalDoc,
        steps: options.steps,
        colourScheme: options.colourScheme
    };
}


function $c7ddbb7665d2a7d0$export$9d286ea8d36eb908({}) {
    return {
        menuDisabled: false,
        allowZeroWidthSpaceAfter: true
    };
}


function $8660f8880f9cea3b$export$3612ff8a6b94af71({}) {
    return undefined;
}


function $227eaab840448c35$export$b4fe80869e994c19({ options: options }) {
    if (!options) return undefined;
    const { syncedBlockRenderer: syncedBlockRenderer, syncBlockDataProvider: syncBlockDataProvider } = options;
    return {
        syncedBlockRenderer: syncedBlockRenderer,
        syncBlockDataProvider: syncBlockDataProvider
    };
}





function $2f3fcd3de4e4a210$export$9868b594778cf535({ options: options }) {
    return {
        // value from next/packages/editor-features/src/hooks/useTableOptions.ts
        tableOptions: {
            allowTableResizing: true,
            allowTableAlignment: true,
            allowBackgroundColor: true,
            allowColumnResizing: true,
            allowColumnSorting: true,
            allowDistributeColumns: true,
            allowHeaderColumn: true,
            allowHeaderRow: true,
            allowMergeCells: true,
            allowNumberColumn: true,
            allowNestedTables: true,
            allowControls: true,
            stickyHeaders: true,
            allowAddColumnWithCustomStep: false
        },
        // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
        dragAndDropEnabled: true,
        // END SECTION
        isTableScalingEnabled: true,
        allowContextualMenu: true,
        fullWidthEnabled: options.editorAppearance === 'full-width',
        maxWidthEnabled: options.editorAppearance === 'max',
        wasFullWidthEnabled: options.prevEditorAppearance && options.prevEditorAppearance === 'full-width',
        getEditorFeatureFlags: ()=>({
                // SECTION: From confluence/next/packages/editor-features/src/hooks/useEditorFeatureFlags.ts
                tableWithFixedColumnWidthsOption: true,
                // END SECTION
                // SECTION: From confluence/next/packages/full-page-editor/src/hooks/useEditorFullPageExperiments.ts
                tableSelector: (0, $iu6m9.editorExperiment)('platform_editor_tables_table_selector', true)
            }),
        isCommentEditor: false,
        isChromelessEditor: false
    };
}


function $87c3c57462c09942$export$1d23e03c42bfc1ac({ options: options, providers: providers }) {
    return {
        allowNestedTasks: true,
        consumeTabs: true,
        useLongPressSelection: false,
        taskDecisionProvider: providers.taskDecisionProvider,
        hasEditPermission: options.hasEditPermission,
        requestToEditContent: options.requestToEditContent,
        hasRequestedEditPermission: options.hasRequestedEditPermission,
        allowBlockTaskItem: true
    };
}


function $9a9dacee247babb9$export$a4eedeb4455295f2({}) {
    return true;
}


function $cd23e889f6860a3b$export$cb883a3a9320698e({}) {
    return {
        responsiveToolbarMenu: true
    };
}


function $8ebcccb01b69e781$export$bd221c449644c740({}) {
    return {
        showIndentationButtons: true,
        allowHeadingAndParagraphIndentation: true
    };
}


function $969f212772f8d82f$export$2d206ce8fa0c3d37({ options: options }) {
    return {
        contextualFormattingEnabled: options.contextualFormattingEnabled
    };
}





function $9da95701694c2ca2$export$f8fa1184f7aaa2b3({ options: options }) {
    return {
        ButtonWrapper: options?.ButtonWrapper,
        showOnToolbar: (0, $dh538.fg)('platform_editor_toolbar_aifc_undo_redo_confluence')
    };
}


function $663aa679fccecaaa$export$612ea2d32c3e4c96({}) {
    return {
        isMobile: false
    };
}


function $e2c7c4acf3e187dc$export$abdb0d09187eec69({ providers: providers }) {
    return {
        userPreferencesProvider: providers.userPreferencesProviderNext,
        initialUserPreferences: undefined
    };
}


function $2b80134f192952c5$export$9f1bd789d5e1fd40(props) {
    const { intl: intl, providers: providers, enabledOptionalPlugins: enabledOptionalPlugins } = props;
    // We remove all `never` properties from the FullPagePresetProps.pluginOptions,
    // we need to return them back.
    const pluginOptions = props.pluginOptions;
    return new (0, $bupcf.EditorPresetBuilder)().maybeAdd([
        (0, $c6eda9ff2d183267$export$9f825df6a9c9b35b),
        (0, $a233792833dda4ec$export$d384a797e800fdbe)({
            options: pluginOptions.limitedMode
        })
    ], (0, $1oCLl.expValEquals)('cc_editor_limited_mode', 'isEnabled', true)).add([
        (0, $l7rln.featureFlagsPlugin),
        (0, $13d21f4408f33e88$export$3bff061e5229a7)({
            options: pluginOptions.featureFlags
        })
    ]).add([
        (0, $jmHSv.analyticsPlugin),
        (0, $b499f1aa43aeb0ae$export$bfd53895e8497571)({
            options: pluginOptions.analytics
        })
    ]).add((0, $55skd.betterTypeHistoryPlugin)).add([
        (0, $36iDo.pastePlugin),
        (0, $49e9bc2589f6c0e6$export$6b1ad42d09c74964)({
            options: pluginOptions.paste,
            providers: providers
        })
    ]).add((0, $acwPl.default)).add((0, $jS0a0.focusPlugin)).add((0, $gyXPd.compositionPlugin)).add([
        (0, $kbe7k.contextIdentifierPlugin),
        (0, $815cf72c0fd01db1$export$2c26eb5ff90afcfd)({
            options: pluginOptions.contextIdentifier,
            providers: providers
        })
    ]).add([
        (0, $fi7Vj.default),
        (0, $78a1544f00d30a05$export$a23b3fa66082f163)({
            options: pluginOptions.base
        })
    ]).maybeAdd([
        (0, $hEicH.userPreferencesPlugin),
        (0, $e2c7c4acf3e187dc$export$abdb0d09187eec69)({
            providers: providers
        })
    ], enabledOptionalPlugins.userPreferences).add((0, $4KTOl.decorationsPlugin)).add([
        (0, $fMaLE.typeAheadPlugin),
        (0, $663aa679fccecaaa$export$612ea2d32c3e4c96)({
            options: pluginOptions.typeAhead
        })
    ]).add((0, $HYzBP.default)).add([
        (0, $itirX.primaryToolbarPlugin),
        (0, $66d5390e1d65d1af$export$44901d053a58e418)({
            options: pluginOptions.primaryToolbar
        })
    ]).maybeAdd([
        (0, $3JBsx.toolbarPlugin),
        (0, $969f212772f8d82f$export$2d206ce8fa0c3d37)({
            options: pluginOptions.toolbar
        })
    ], Boolean(enabledOptionalPlugins.toolbar)).maybeAdd([
        (0, $3ffb488333a8774a$export$dfc601443ba8de15),
        {
            getLinkPath: pluginOptions.blockMenu?.getLinkPath,
            blockLinkHashPrefix: pluginOptions.blockMenu?.blockLinkHashPrefix
        }
    ], (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)).add((0, $kw2eg.undoRedoPlugin)).add([
        (0, $khxQ7.blockTypePlugin),
        (0, $849252e5cfbe6f75$export$817c0e398e6ff750)({
            options: pluginOptions.blockType
        })
    ]).add((0, $kXH7i.clearMarksOnEmptyDocPlugin)).add([
        (0, $7nKrc.selectionToolbarPlugin),
        (0, $9a57111cbcc407d6$export$bc6dcb3c2a6112e1)({
            options: pluginOptions.selectionToolbar,
            providers: providers
        })
    ]).add([
        (0, $gATpw.hyperlinkPlugin),
        (0, $ba2e03c1e9271b78$export$ab9ae3984d5aef33)({
            options: pluginOptions.hyperlink
        })
    ]).add([
        (0, $5mDFx.textFormattingPlugin),
        (0, $cd23e889f6860a3b$export$cb883a3a9320698e)({
            options: pluginOptions.textFormatting
        })
    ]).add((0, $fI6T7.widthPlugin)).add([
        (0, $e6sdP.quickInsertPlugin),
        (0, $9c8df38044d63cd4$export$26cff1f2fe9f781b)({
            options: pluginOptions.quickInsert
        })
    ]).add([
        (0, $kYgUn.placeholderPlugin),
        (0, $01e23cb99d262862$export$c6841f879d4c8aef)({
            intl: intl,
            options: pluginOptions.placeholder
        })
    ]).add((0, $vxKdN.unsupportedContentPlugin)).add([
        (0, $lgjGE.editorDisabledPlugin),
        (0, $22bbbcb7ca748783$export$de47eee62065048e)({
            options: pluginOptions.editorDisabled
        })
    ]).add([
        (0, $6borH.submitEditorPlugin),
        (0, $8660f8880f9cea3b$export$3612ff8a6b94af71)({
            options: pluginOptions.submitEditor
        })
    ]).add((0, $kIhx9.copyButtonPlugin)).maybeAdd((0, $7sK9h.floatingToolbarPlugin), enabledOptionalPlugins.floatingToolbar ?? true).maybeAdd((0, $6AqNX.interactionPlugin), Boolean(enabledOptionalPlugins.interaction)).add([
        (0, $bULcr.selectionPlugin),
        (0, $d84bbda11ad6763d$export$ddc2936355c1da67)({
            options: pluginOptions.selection
        })
    ]).add([
        (0, $7rj2U.default),
        (0, $de05ec98c0250c98$export$74cc43e84bb9c20)({
            options: pluginOptions.codeBlock
        })
    ]).add((0, $bz4KD.ufoPlugin)).add((0, $2nH2Y.dataConsumerPlugin)).add((0, $3ihIB.accessibilityUtilsPlugin)).add((0, $2yr9J.contentInsertionPlugin)).add((0, $fPXRH.batchAttributeUpdatesPlugin)).add([
        (0, $cwPVT.breakoutPlugin),
        (0, $18709874e4301e98$export$3be6b735d5cbc3e6)({
            options: pluginOptions.breakout
        })
    ]).add((0, $hr8mu.alignmentPlugin)).add([
        (0, $i2zv0.textColorPlugin),
        (0, $9a9dacee247babb9$export$a4eedeb4455295f2)({
            options: pluginOptions.textColor
        })
    ]).add((0, $5HHoF.listPlugin)).add((0, $5DsxN.rulePlugin)).add([
        (0, $fTvEN.expandPlugin),
        (0, $759d2e4ef0d8b24b$export$ed53f0c49fce09d6)({
            options: pluginOptions.expand
        })
    ]).add((0, $fCLXZ.guidelinePlugin)).add([
        (0, $fYKTL.gridPlugin),
        (0, $f0763edceecb76c2$export$c66d0d1462a05bd)({
            options: pluginOptions.grid
        })
    ]).add([
        (0, $cpn0f.annotationPlugin),
        (0, $8ed9740f118d687b$export$b3e029fd31f94f55)({
            options: pluginOptions.annotation,
            providers: providers
        })
    ]).add([
        (0, $cWFvG.mediaPlugin),
        (0, $1412367cad2aa59d$export$484123ae56f6fbd9)({
            intl: intl,
            options: pluginOptions.media,
            providers: providers
        })
    ]).add((0, $2U68K.mediaInsertPlugin)).add((0, $duFi2.default)).add([
        (0, $5u7tz.mentionsPlugin),
        (0, $4c9dc0bddcbec186$export$e15342409979aa19)({
            options: pluginOptions.mentions,
            providers: providers
        })
    ]).add([
        (0, $hcboS.emojiPlugin),
        (0, $0ec938d111941985$export$7adcaf18ca5c72c4)({
            options: pluginOptions.emoji,
            providers: providers
        })
    ]).add([
        (0, $eeGWn.default),
        (0, $2f3fcd3de4e4a210$export$9868b594778cf535)({
            options: pluginOptions.table
        })
    ]).add([
        (0, $jaskt.tasksAndDecisionsPlugin),
        (0, $87c3c57462c09942$export$1d23e03c42bfc1ac)({
            options: pluginOptions.tasksAndDecisions,
            providers: providers
        })
    ]).add([
        (0, $flknw.helpDialogPlugin),
        (0, $eab9055a4a41e7c7$export$2a67100cd9c61f05)({
            options: {
                imageUploadProviderExists: false,
                aiEnabled: enabledOptionalPlugins.aiExperience
            }
        })
    ]).add([
        (0, $5AZDw.collabEditPlugin),
        (0, $e2f5d02097d0844c$export$c1ebe19806bc53b1)({
            options: pluginOptions.collabEdit,
            providers: providers
        })
    ]).add([
        (0, $b3BjA.default),
        (0, $fc9f968714fe9c5d$export$c18e432f323b002e)({
            options: pluginOptions.panel
        })
    ]).add([
        (0, $1nZXu.contextPanelPlugin),
        (0, $d7dae729776ab102$export$48a60d81b6bb28e3)({
            options: pluginOptions.contextPanel
        })
    ]).add([
        (0, $eyggb.extensionPlugin),
        (0, $2a51a0f7e6ad908c$export$c18b9102cd0790c9)({
            options: pluginOptions.extension
        })
    ]).add([
        (0, $4iQt6.default),
        (0, $0105ad9f4c3353d7$export$5598bb2314a53fa8)({
            options: pluginOptions.date
        })
    ]).add([
        (0, $8HLyI.default),
        (0, $adb03a718cdd3145$export$8b53e6ddc7cf96b4)({
            options: pluginOptions.placeholderText
        })
    ]).add([
        (0, $05jmd.layoutPlugin),
        (0, $0c59805b4172bf23$export$33fb6c6592b2cd5f)({
            options: pluginOptions.layout
        })
    ]).add([
        (0, $agrUc.cardPlugin),
        (0, $f8013e4ced731918$export$514131654bb897e2)({
            options: pluginOptions.card,
            providers: providers
        })
    ]).add([
        (0, $bS1lJ.customAutoformatPlugin),
        (0, $0239ddf6db5a0e53$export$f18d68682e981a91)({
            options: pluginOptions.customAutoformat,
            providers: providers
        })
    ]).add([
        (0, $c8680.statusPlugin),
        (0, $c7ddbb7665d2a7d0$export$9d286ea8d36eb908)({
            options: pluginOptions.status
        })
    ]).maybeAdd([
        (0, $efDik.syncedBlockPlugin),
        (0, $227eaab840448c35$export$b4fe80869e994c19)({
            options: pluginOptions.syncedBlock
        })
    ], !!pluginOptions.syncedBlock && (0, $iu6m9.editorExperiment)('platform_synced_block', true)).add((0, $aUwPP.indentationPlugin)).add((0, $1GAIu.scrollIntoViewPlugin)).add([
        (0, $1KHo7.toolbarListsIndentationPlugin),
        (0, $8ebcccb01b69e781$export$bd221c449644c740)({
            options: pluginOptions.toolbarListsIndentation
        })
    ]).add([
        (0, $cVhn8.insertBlockPlugin),
        (0, $6e8873e0128315d2$export$1e11b615e9dc119e)({
            options: pluginOptions.insertBlock
        })
    ]).add([
        (0, $PJ00O.avatarGroupPlugin),
        (0, $ad7357a8ed7dfd42$export$eeaea850bc5c5797)({
            options: pluginOptions.avatarGroup
        })
    ]).maybeAdd([
        (0, $dtCIm.findReplacePlugin),
        (0, $3434917e042efc57$export$d9e183f0607e1b5d)({
            options: pluginOptions.findReplace
        })
    ], enabledOptionalPlugins.findReplace).add((0, $hSJYu.borderPlugin)).add((0, $6q6xk.fragmentPlugin)).add((0, $59fTa.pasteOptionsToolbarPlugin)).maybeAdd([
        (0, $01uqX.codeBidiWarningPlugin),
        (0, $c70218b234c6d78f$export$3f0ff0bcf72f4d98)({
            options: pluginOptions.codeBidiWarning
        })
    ], !(0, $1oCLl.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true))// below plugins moved from legacy preset
    .maybeAdd([
        (0, $dx8CK.referentialityPlugin),
        enabledOptionalPlugins.referentiality ? (0, $ed5f509dae6ecf5b$export$13a2743c2a93c688)({
            options: pluginOptions.referentiality
        }) : undefined
    ], enabledOptionalPlugins.referentiality).maybeAdd([
        (0, $80JwR.loomPlugin),
        (0, $1bb1e0cb9a7988e8$export$feaee25faac0c640)({
            options: pluginOptions.loom
        })
    ], enabledOptionalPlugins.loom).add([
        (0, $3mcWz.editorViewModePlugin),
        (0, $f342e2c893778f00$export$36a79e2b5698697a)({
            options: pluginOptions.editorViewMode
        })
    ]).add((0, $50cbf7161ff57c52$export$d510e4d48c393847))// aiDefinitionsPlugin depends on editorViewModePlugin
    .maybeAdd([
        (0, $1ewUw.aiDefinitionsPlugin),
        (0, $03a647a335c52f20$export$13aeab2a71badd1e)({
            options: pluginOptions.aiDefinitions
        })
    ], enabledOptionalPlugins.aiDefinitions).maybeAdd([
        (0, $4DEL1.aiPlugin),
        (0, $0e54a671895f12da$export$a2b90416e38bfd44)({
            options: pluginOptions.ai
        })
    ], enabledOptionalPlugins.aiExperience)// aiProactivePlugin depends on aiPlugin
    .maybeAdd([
        (0, $7OCNe.aiProactivePlugin),
        (0, $57bfcdb96b39b33a$export$3dd05c02043bb4e8)({
            options: pluginOptions.aiProactive
        })
    ], enabledOptionalPlugins.aiProactive).add([
        (0, $5Qu3R.selectionMarkerPlugin),
        (0, $45e8d9f61045475c$export$197b78e13e8987d2)({
            options: pluginOptions.selectionMarker
        })
    ]).add((0, $2E0F0.blockControlsPlugin)).add((0, $cu2RD.highlightPlugin)).add([
        (0, $8ABVP.engagementPlatformPlugin),
        (0, $d63a2b43135c498f$export$128eafe7f843e327)({
            options: pluginOptions.engagementPlatform
        })
    ]).maybeAdd((0, $5y9PZ.connectivityPlugin), enabledOptionalPlugins.connectivity).maybeAdd((0, $kcvNv.ncsStepMetricsPlugin), enabledOptionalPlugins.ncsStepMetrics && !(0, $1oCLl.expValEquals)('platform_editor_remove_ncsStepMetrics_plugin', 'isEnabled', true)).maybeAdd([
        (0, $dH9DB.metricsPlugin),
        (0, $85c17a3a2c6c7b85$export$4677177d82484aef)({
            options: pluginOptions.metrics
        })
    ], enabledOptionalPlugins.metrics).maybeAdd([
        (0, $jgFdO.codeBlockAdvancedPlugin),
        (0, $54a86813db4d4780$export$6e32a592ec823802)({
            options: pluginOptions.codeBlockAdvanced
        })
    ], enabledOptionalPlugins.codeBlockAdvanced).maybeAdd([
        (0, $4NiQW.selectionExtensionPlugin),
        (0, $70edb4b454693530$export$222c5aa4c9fb0805)({
            options: pluginOptions.selectionExtension
        })
    ], enabledOptionalPlugins.selectionExtension).add((0, $3O0YV.userIntentPlugin)).maybeAdd([
        (0, $84Iqc.showDiffPlugin),
        (0, $f5ca45a4f682676c$export$5c1f265f89d46b24)({
            options: pluginOptions.showDiff
        })
    ], enabledOptionalPlugins.showDiff).maybeAdd([
        (0, $aB4bz.trackChangesPlugin),
        (0, $9da95701694c2ca2$export$f8fa1184f7aaa2b3)({
            options: pluginOptions.trackChanges
        })
    ], enabledOptionalPlugins.trackChanges).maybeAdd((0, $lQotL.localIdPlugin), enabledOptionalPlugins.localId).maybeAdd((0, $dF1N1.aiStreamingOrchestratorPlugin), (0, $dh538.fg)('platform_editor_ai_aifc_streaming'));
}



var $dMGoR = parcelRequire("dMGoR");


var $bODUD = parcelRequire("bODUD");


var $4EKKB = parcelRequire("4EKKB");


var $3YBks = parcelRequire("3YBks");


var $iHrpD = parcelRequire("iHrpD");


var $6mKj3 = parcelRequire("6mKj3");





var $3jwuS = parcelRequire("3jwuS");


var $ep3mz = parcelRequire("ep3mz");








var $cqCFf = parcelRequire("cqCFf");

const $4eff3da02bf6b0b9$export$ce9fbb23568613c5 = (_view, event)=>{
    /**
   * We have to use the event.target to indentify that we are dealing with the live search extension
   * instead of the current editor selection because
   *   1. We can’t guarantee the selection won’t change while we are in the extension
   *   2. Often times the selection is not the extension despite currently interacting with the extension
   *
   * As a result, we have to rely on the event.target to identify if the current event is meant for the
   * live search extension.
   */ const isLiveSearchExtensionElement = event.target.classList.contains(`${(0, $cqCFf.LIVE_SEARCH_SELECT_CLASSNAME_PREFIX)}__input`) || event.target.className === (0, $cqCFf.LIVE_SEARCH_BUTTON_CLASSNAME);
    return (event.target instanceof HTMLInputElement || event.target instanceof HTMLButtonElement) && isLiveSearchExtensionElement;
};
const $4eff3da02bf6b0b9$export$c9403d1366bd779d = {
    keydown: $4eff3da02bf6b0b9$export$ce9fbb23568613c5,
    keyup: $4eff3da02bf6b0b9$export$ce9fbb23568613c5,
    keypress: $4eff3da02bf6b0b9$export$ce9fbb23568613c5,
    beforeinput: $4eff3da02bf6b0b9$export$ce9fbb23568613c5
};



var $kyKWe = parcelRequire("kyKWe");




const $73f6dfc0acf21779$export$14e5c8eb6f32c76 = (slice)=>{
    const updatedContent = [];
    slice.content.forEach((node)=>{
        if (node.attrs.extensionType === 'com.atlassian.confluence.macro.core' && node.attrs.extensionKey === 'anchor') {
            // Update the value of the macro param used as anchor name (used as html id in UI) to a unique value, UUID.
            const newAttrs = {
                ...node.attrs,
                parameters: {
                    ...node.attrs.parameters,
                    macroParams: {
                        ...node.attrs.parameters.macroParams,
                        '': {
                            value: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
                        }
                    }
                }
            };
            updatedContent.push(node.type.create(newAttrs, node.content, node.marks));
        } else updatedContent.push(node);
    });
    return new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).fromArray(updatedContent), slice.openStart, slice.openEnd);
};


// Duplicate of TEXTFIELD_ID from @atlassian/dynamic-cards-search-page
const $23f33cc0c92651d7$var$COMPANY_HUB_SEARCH_TEXTFIELD_ID = 'ch-search-text-query-input';
const $23f33cc0c92651d7$export$eb1b190bb6345745 = (_view, event)=>{
    /**
	 * We have to use the event.target to indentify that we are dealing with the Company Hub search extension
	 * instead of the current editor selection because
	 *   1. We can’t guarantee the selection won’t change while we are in the extension
	 *   2. Often times the selection is not the extension despite currently interacting with the extension
	 *
	 * As a result, we have to rely on the event.target to identify if the current event is meant for the
	 * Company Hub search extension.
	 */ return event.target instanceof HTMLInputElement && event.target.id === $23f33cc0c92651d7$var$COMPANY_HUB_SEARCH_TEXTFIELD_ID;
};
const $23f33cc0c92651d7$export$47b865254c03e3eb = {
    keydown: $23f33cc0c92651d7$export$eb1b190bb6345745,
    keyup: $23f33cc0c92651d7$export$eb1b190bb6345745,
    keypress: $23f33cc0c92651d7$export$eb1b190bb6345745,
    beforeinput: $23f33cc0c92651d7$export$eb1b190bb6345745
};


const $1a6e0310908ffd24$export$234cb421a967be1c = 'extensionManager';
const $1a6e0310908ffd24$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)($1a6e0310908ffd24$export$234cb421a967be1c);
const $1a6e0310908ffd24$export$ae829ec7b2625219 = ()=>new (0, $1S4f7.SafePlugin)({
        key: $1a6e0310908ffd24$export$18d4026d1ea86bb1,
        state: {
            init: ()=>({}),
            apply (tr, pluginState) {
                const metadata = tr.getMeta($1a6e0310908ffd24$export$18d4026d1ea86bb1);
                if (metadata) return {
                    ...pluginState,
                    ...metadata
                };
                return pluginState;
            }
        },
        props: {
            handleDOMEvents: {
                ...(0, $4eff3da02bf6b0b9$export$c9403d1366bd779d),
                ...(0, $23f33cc0c92651d7$export$47b865254c03e3eb)
            },
            transformPasted: (0, $73f6dfc0acf21779$export$14e5c8eb6f32c76)
        }
    });





















var $1NBp8 = parcelRequire("1NBp8");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");





var $cEgMD = parcelRequire("cEgMD");













const $999bd16bdfd9c01c$var$i18n = (0, $cgtv4.defineMessages)({
    defaultTooltipContent: {
        id: "fabric-extension-manager-plugin.anchor.copy-link-button.tooltip",
        defaultMessage: "Copy link to anchor"
    },
    erroredTooltipContent: {
        id: "fabric-extension-manager-plugin.anchor.copy-link-button.tooltip.disabled",
        defaultMessage: "Edit to create link"
    },
    copySuccessTooltipContent: {
        id: "fabric-extension-manager-plugin.anchor.copy-link-button.tooltip.copied",
        defaultMessage: "Copied!"
    }
});
const $999bd16bdfd9c01c$export$baeb5f600fdaf82a = ()=>({ tr: tr })=>tr.setMeta((0, $1a6e0310908ffd24$export$18d4026d1ea86bb1), {
            showAnchorLinkCopiedTooltip: undefined
        });
const $999bd16bdfd9c01c$export$94a93fd1fcc43123 = ({ node: node, intl: intl, api: api, updateTooltipPosition: updateTooltipPosition })=>{
    const showAnchorLinkCopiedTooltip = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        (0, $1a6e0310908ffd24$export$234cb421a967be1c)
    ], (states)=>states?.extensionManagerState?.showAnchorLinkCopiedTooltip);
    const isValidAnchorName = (0, $a511a7deb986d4c1$export$f57cb5ad5ec9d3a8)(node);
    (0, $42omo.useEffect)(()=>{
        // Reset the state of `showAnchorLinkCopiedTooltip` back to default when the component unmounts
        return ()=>{
            api?.core?.actions?.execute?.($999bd16bdfd9c01c$export$baeb5f600fdaf82a());
        };
    }, [
        api
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        // When the content of a visible tooltip changes, its' position isn't recalculated
        // and the tooltip may become misaligned. Since we change the tooltip content when
        // the link is copied, we need to manually recalculate the tooltip position.
        if (showAnchorLinkCopiedTooltip) updateTooltipPosition?.();
    }, [
        showAnchorLinkCopiedTooltip,
        updateTooltipPosition
    ]);
    if (!isValidAnchorName) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("p", null, intl.formatMessage($999bd16bdfd9c01c$var$i18n.erroredTooltipContent));
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("p", null, !!showAnchorLinkCopiedTooltip ? intl.formatMessage($999bd16bdfd9c01c$var$i18n.copySuccessTooltipContent) : intl.formatMessage($999bd16bdfd9c01c$var$i18n.defaultTooltipContent)));
};


const $a511a7deb986d4c1$var$i18n = (0, $cgtv4.defineMessages)({
    anchorMacroCopyLinkCTALabel: {
        id: "fabric-extension-manager-plugin.anchor.copy-link-button.label",
        defaultMessage: "Copy link"
    }
});
const $a511a7deb986d4c1$export$f57cb5ad5ec9d3a8 = (node)=>{
    const anchorName = node.attrs.parameters.macroParams['']?.value;
    if (!anchorName) return false;
    try {
        decodeURIComponent(anchorName);
        return true;
    } catch (_error) {
        return false;
    }
};
const $a511a7deb986d4c1$var$getPathName = (isLivePage, contentId, spaceKey)=>{
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    if (isCompanyHub && (0, $6mKj3.expVal)('company-hub-edit-heading-anchor-link-create', 'isEnabled', false)) return (0, $1NBp8.COMPANY_HUB).toUrl();
    if (isLivePage) return window.location.pathname;
    return (0, $1NBp8.VIEW_PAGE).toUrl({
        contentId: contentId,
        spaceKey: spaceKey
    });
};
const $a511a7deb986d4c1$export$548d9151b6657224 = (node, fireAnalyticsEvent)=>(state, dispatch)=>{
        const { tr: tr } = state;
        const { isLivePage: isLivePage, contentId: contentId, spaceKey: spaceKey } = (0, $1a6e0310908ffd24$export$18d4026d1ea86bb1).getState(state)?.pageContext ?? {};
        const anchorName = node.attrs.parameters.macroParams['']?.value;
        const pathName = $a511a7deb986d4c1$var$getPathName(isLivePage, contentId, spaceKey);
        const setShowAnchorLinkCopiedTooltip = (showAnchorLinkCopiedTooltip)=>{
            dispatch?.(tr.setMeta((0, $1a6e0310908ffd24$export$18d4026d1ea86bb1), {
                showAnchorLinkCopiedTooltip: showAnchorLinkCopiedTooltip
            }));
        };
        fireAnalyticsEvent?.({
            action: (0, $d925B.ACTION).CLICKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).COPY_LINK_TO_ANCHOR,
            eventType: (0, $d925B.EVENT_TYPE).UI,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB,
                extensionKey: node.attrs?.extensionKey,
                extensionType: node.attrs?.extensionType,
                isLivePage: isLivePage
            }
        });
        if (dispatch) try {
            decodeURIComponent(anchorName);
            (0, $cMZNY.copyToClipboard)(`${window.location.origin}${pathName}#${anchorName}`).then(()=>{
                setShowAnchorLinkCopiedTooltip(true);
            }).catch((error)=>{
                (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
                });
                setShowAnchorLinkCopiedTooltip(false);
            });
        } catch (_error) {
            setShowAnchorLinkCopiedTooltip(false);
        }
        return true;
    };
const $a511a7deb986d4c1$export$3178138fc316e9da = (toolbarItems, intl, node, api)=>{
    const updatedToolbarItems = toolbarItems.slice();
    const indexOfFirstSeperator = toolbarItems.map((item)=>item.type).indexOf('separator');
    const { fireAnalyticsEvent: fireAnalyticsEvent } = api?.analytics?.actions ?? {};
    const newItemsToInsert = [
        {
            id: 'editor.anchor.macro.copy-link',
            type: 'button',
            title: intl.formatMessage($a511a7deb986d4c1$var$i18n.anchorMacroCopyLinkCTALabel),
            tooltipContent: ({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $999bd16bdfd9c01c$export$94a93fd1fcc43123), {
                    node: node,
                    intl: intl,
                    api: api,
                    updateTooltipPosition: update
                }),
            showTitle: true,
            hideTooltipOnClick: false,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
            onClick: $a511a7deb986d4c1$export$548d9151b6657224(node, fireAnalyticsEvent),
            disabled: !$a511a7deb986d4c1$export$f57cb5ad5ec9d3a8(node)
        }
    ];
    /**
   * If there is no separator, 1 group present, add
   * separator before the new items to create a new visual
   */ if (indexOfFirstSeperator === -1) newItemsToInsert.unshift({
        type: 'separator',
        hidden: false
    });
    else if (indexOfFirstSeperator !== 0 && indexOfFirstSeperator !== toolbarItems.length - 1) newItemsToInsert.push({
        type: 'separator',
        hidden: false
    });
    updatedToolbarItems.splice(indexOfFirstSeperator + 1, 0, ...newItemsToInsert);
    return updatedToolbarItems;
};
const $a511a7deb986d4c1$export$1ddc93af5b94ad04 = {
    shouldApplyOverride: (state, config)=>{
        const isCurrentSelectionAnchorMacro = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.attrs.extensionType === 'com.atlassian.confluence.macro.core' && state.selection.node.attrs.extensionKey === 'anchor';
        return isCurrentSelectionAnchorMacro && (Array.isArray(config.nodeType) ? config.nodeType.includes(state.schema.nodes.inlineExtension) : config.nodeType === state.schema.nodes.inlineExtension);
    },
    applyOverride: (config, intl, api)=>{
        if (Array.isArray(config.items)) {
            const toolbarItems = config.items;
            config.items = (node)=>{
                if (node.attrs.extensionType === 'com.atlassian.confluence.macro.core' && node.attrs.extensionKey === 'anchor') return $a511a7deb986d4c1$export$3178138fc316e9da(toolbarItems, intl, node, api);
                return toolbarItems;
            };
        }
    }
};


const $ea140a6e73833f23$export$86ce8f8241c20a3 = (state, intl, _providerFactory, activeConfigs, api)=>{
    if (!activeConfigs?.length) return;
    const overrides = [
        (0, $a511a7deb986d4c1$export$1ddc93af5b94ad04)
    ];
    activeConfigs.forEach((config)=>{
        overrides.forEach(({ shouldApplyOverride: shouldApplyOverride, applyOverride: applyOverride })=>{
            if (shouldApplyOverride(state, config)) applyOverride(config, intl, api);
        });
    });
};


const $b6333eeaeea6365c$export$53933ef6873e4a9f = ({ api: api })=>({
        name: (0, $1a6e0310908ffd24$export$234cb421a967be1c),
        pmPlugins () {
            return [
                {
                    name: (0, $1a6e0310908ffd24$export$234cb421a967be1c),
                    plugin: ()=>(0, $1a6e0310908ffd24$export$ae829ec7b2625219)()
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $1a6e0310908ffd24$export$18d4026d1ea86bb1).getState(editorState);
            return {
                showAnchorLinkCopiedTooltip: pluginState?.showAnchorLinkCopiedTooltip
            };
        },
        usePluginHook ({ editorView: editorView }) {
            const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
            const [{ contentId: contentId, spaceKey: spaceKey }] = (0, $ep3mz.usePageState)();
            (0, $42omo.useEffect)(()=>{
                const { dispatch: dispatch, state: { tr: tr } } = editorView;
                tr.setMeta((0, $1a6e0310908ffd24$export$18d4026d1ea86bb1), {
                    pageContext: {
                        isLivePage: isLivePage,
                        spaceKey: spaceKey,
                        contentId: contentId
                    }
                });
                dispatch(tr);
            }, [
                editorView,
                isLivePage,
                spaceKey,
                contentId
            ]);
        },
        pluginsOptions: {
            floatingToolbar: (...args)=>(0, $ea140a6e73833f23$export$86ce8f8241c20a3)(...args, api)
        }
    });



var $9wGTI = parcelRequire("9wGTI");











var $9NwnH = parcelRequire("9NwnH");








var $ffQ2A = parcelRequire("ffQ2A");





var $4XhNP = parcelRequire("4XhNP");

var $44jjU = parcelRequire("44jjU");


var $h9yJL = parcelRequire("h9yJL");











var $5spQU = parcelRequire("5spQU");








var $lzcvT = parcelRequire("lzcvT");




const $bcc122a52e0f74cf$export$3b87fd119d006909 = new (0, $ks2lK.PluginKey)('editorOfflineStoragePlugin');
const $bcc122a52e0f74cf$export$ae829ec7b2625219 = (stepsDatabase)=>()=>{
        return new (0, $1S4f7.SafePlugin)({
            key: $bcc122a52e0f74cf$export$3b87fd119d006909,
            state: {
                init () {
                    const isEditorFeatureEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-editor-offline-storage') : !(0, $lzcvT.isFedRamp)();
                    return {
                        status: 'pending',
                        disabled: !isEditorFeatureEnabled ? 'disabledEnvironment' : false,
                        inactiveSyncing: false
                    };
                },
                apply: (tr, currentPluginState)=>{
                    const meta = tr.getMeta($bcc122a52e0f74cf$export$3b87fd119d006909);
                    if (meta) return {
                        ...currentPluginState,
                        ...meta
                    };
                    return currentPluginState;
                }
            },
            view: ()=>{
                return {
                    destroy () {
                        return stepsDatabase.closeDB(true);
                    }
                };
            }
        });
    };


class $5c049076093b3a44$export$d15eb9e8bb5d03ea {
    get hasLock() {
        return this._hasLock;
    }
    get lockPurpose() {
        return this._lockPurpose;
    }
    init(dbName) {
        this.dbName = dbName;
    }
    /**
   * Release the lock so it can be used elsewhere
   */ releaseLock() {
        this._releaseLock();
    }
    /**
   * Acquire the lock for the page
   *
   * **Waiting on this function will block until the lock is acquired then released, or the lock request is aborted.**
   * If waitUntilAvailable is set to `true`, the lock request will wait for the lock to become available.
   * If waitUntilAvailable is set to `false`, the lock request will abort if the lock is not available at the time it's requested.
   *
   * @param callback - The callback to run when the lock is acquired or the lock request is aborted
   * @param waitUntilAvailable - When set to true the lock request will wait until the lock is available
   */ async acquireLock(callback, waitUntilAvailable = false, purpose) {
        if (!this.dbName) return Promise.reject(new Error('SynchronisationLock not initialized.'));
        await navigator.locks?.request(this.dbName, {
            ifAvailable: !waitUntilAvailable
        }, async (lock)=>{
            if (lock === null) {
                await callback?.(false);
                return;
            }
            const promise = this.holdLock();
            this._lockPurpose = purpose;
            await callback?.(true);
            return promise;
        });
    }
    /**
   * If the lock is currently taken and therefore we shouldn't send any data
   */ async isLocked() {
        if (!this.dbName) return false;
        const locks = await navigator.locks?.query();
        const relevantLocks = locks?.held ? locks.held.filter((lock)=>lock.name === this.dbName) : [];
        if (relevantLocks && relevantLocks.length > 0) return true;
        else return false;
    }
    constructor(){
        this.dbName = void 0;
        this._hasLock = false;
        this._lockPurpose = void 0;
        this._releaseLock = ()=>{};
        this.holdLock = async ()=>{
            this._hasLock = true;
            let resolve;
            this._releaseLock = ()=>{
                // resolving the promise will release the lock
                resolve({});
                this._hasLock = false;
                this._lockPurpose = undefined;
            };
            return new Promise((res)=>{
                resolve = res;
            });
        };
    }
}





const $1a899df20ad45f18$var$isTrackEvent = (props)=>{
    return props.action === 'OFFLINE_EDITING_SUCCESS_STORE_RECOVERY_VERSION';
};
const $1a899df20ad45f18$export$6bd08bb9f59ca292 = (props)=>{
    const { api: api, action: action, ...otherAttributes } = props;
    if (!api || !api.analytics) return;
    // Get additional context from shared state
    const sharedPluginState = api?.editorOfflineStorage?.sharedState.currentState();
    const { version: version, steps: steps, status: status, disabled: disabled } = sharedPluginState ?? {};
    api.analytics.actions?.fireAnalyticsEvent?.({
        eventType: $1a899df20ad45f18$var$isTrackEvent(props) ? (0, $d925B.EVENT_TYPE).TRACK : (0, $d925B.EVENT_TYPE).OPERATIONAL,
        action: action,
        actionSubject: (0, $d925B.ACTION_SUBJECT).OFFLINE_EDITING,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).OFFLINE_EDITING,
        attributes: {
            version: // Additonal context.
            version,
            stepsCount: steps?.length,
            status: status,
            disabled: disabled,
            // Action specific attributes.
            ...otherAttributes
        }
    });
};
const $1a899df20ad45f18$export$91c32f1b22d29b2d = (error)=>{
    if (!error) return 'Unknown error';
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return String(error);
};
const $1a899df20ad45f18$export$ff269655d7dc6e77 = (errors)=>{
    return errors.map((e)=>$1a899df20ad45f18$export$91c32f1b22d29b2d(e)).join(';');
};


/**
 * Background cleanup logic for expired offline editor databases.
 *
 * This module handles checking all databases from other documents and taking action:
 * - Deletes fully-expired databases
 * - Clears expired data while preserving fresh data
 * - Migrates pre-migration databases by adding timestamps
 */ 
var $17wUi = parcelRequire("17wUi");



var $awSMG = parcelRequire("awSMG");


const $e9c926f713f211d2$var$THIRTY_DAYS_MS = 2592000000;
const $e9c926f713f211d2$var$BACKGROUND_CLEANUP_INTERVAL_MS = 86400000;
const $e9c926f713f211d2$var$LAST_BACKGROUND_CLEANUP_ATTEMPT_KEY = 'editor:offline:last-background-cleanup-attempt';
const $e9c926f713f211d2$var$MAX_DATABASES_PER_CLEANUP = 100; // Cap to prevent performance issues on first load
/**
 * Extract contentId from database name by removing the prefix.
 */ const $e9c926f713f211d2$var$extractContentId = (dbName)=>dbName.replace((0, $awSMG.OFFLINE_STEPS_DATABASE_NAME_PREFIX), '');
function $e9c926f713f211d2$export$365e5e8d6c8a82b3() {
    try {
        if (!(0, $17wUi.confluenceLocalStorageInstance)) return false;
        const lastAttempt = (0, $17wUi.confluenceLocalStorageInstance).getItem($e9c926f713f211d2$var$LAST_BACKGROUND_CLEANUP_ATTEMPT_KEY);
        if (!lastAttempt) return true;
        const timeSinceLastAttempt = Date.now() - parseInt(lastAttempt, 10);
        return timeSinceLastAttempt > $e9c926f713f211d2$var$BACKGROUND_CLEANUP_INTERVAL_MS;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        // Storage access failed - return false to skip cleanup (non-critical)
        return false;
    }
}
function $e9c926f713f211d2$export$df49bbb19630c32d() {
    try {
        if (!(0, $17wUi.confluenceLocalStorageInstance)) return;
        (0, $17wUi.confluenceLocalStorageInstance).setItem($e9c926f713f211d2$var$LAST_BACKGROUND_CLEANUP_ATTEMPT_KEY, Date.now().toString());
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
    // Storage access failed - continue silently (non-critical)
    }
}
/**
 * Delete an entire database.
 */ async function $e9c926f713f211d2$var$deleteDatabase(dbName) {
    return new Promise((resolve, reject)=>{
        const request = indexedDB.deleteDatabase(dbName);
        request.onsuccess = ()=>resolve();
        request.onerror = ()=>reject(request.error);
        request.onblocked = ()=>resolve();
    });
}
/**
 * Add timestamp to pre-migration data to migrate it.
 */ async function $e9c926f713f211d2$var$addTimestampToMigrateData(database, metaData) {
    const writeTransaction = database.transaction([
        (0, $awSMG.OFFLINE_META_STORE_NAME)
    ], 'readwrite');
    const metaStore = writeTransaction.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
    const updatedMetaData = {
        ...metaData || {
            doc: null,
            version: null
        },
        lastUpdated: Date.now()
    };
    metaStore.put(updatedMetaData, 1);
    await new Promise((resolve, reject)=>{
        writeTransaction.oncomplete = ()=>resolve();
        writeTransaction.onerror = ()=>reject(writeTransaction.error);
    });
}
async function $e9c926f713f211d2$export$197ab581d971f15a(dbName) {
    return new Promise((resolve)=>{
        const request = indexedDB.open(dbName, (0, $f0050ff6ee6f7eb3$export$9fd1ded1027f9ea2));
        request.onerror = ()=>{
            // Can't open the database - treat as error case
            resolve({
                dbName: dbName,
                deleted: false,
                reason: 'error',
                errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(request.error)
            });
        };
        request.onsuccess = async (event)=>{
            const database = event.target.result;
            try {
                const readTransaction = database.transaction([
                    (0, $awSMG.OFFLINE_META_STORE_NAME),
                    'steps'
                ], 'readonly');
                const metaStore = readTransaction.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
                const stepsStore = readTransaction.objectStore('steps');
                const metaRequest = metaStore.get(1);
                const metaData = await new Promise((resolve, reject)=>{
                    metaRequest.onsuccess = ()=>resolve(metaRequest.result);
                    metaRequest.onerror = ()=>reject(metaRequest.error);
                });
                const stepsCountRequest = stepsStore.count();
                const stepsCount = await new Promise((resolve, reject)=>{
                    stepsCountRequest.onsuccess = ()=>resolve(stepsCountRequest.result);
                    stepsCountRequest.onerror = ()=>reject(stepsCountRequest.error);
                });
                // Empty database: No meta data AND no steps. Safe to delete.
                if (!metaData && stepsCount === 0) {
                    await $e9c926f713f211d2$var$deleteDatabase(dbName);
                    resolve({
                        dbName: dbName,
                        deleted: true,
                        reason: 'empty'
                    });
                    return;
                }
                // Migration: Missing metadata or missing timestamp. Add timestamp and skip deletion.
                if (!metaData || !metaData.lastUpdated) {
                    await $e9c926f713f211d2$var$addTimestampToMigrateData(database, metaData);
                    resolve({
                        dbName: dbName,
                        deleted: false,
                        reason: 'migrated'
                    });
                    return;
                }
                // At this point, metaData.lastUpdated is guaranteed to exist (migrated above)
                const currentTimestamp = Date.now();
                const databaseAge = currentTimestamp - metaData.lastUpdated;
                const isExpired = databaseAge > $e9c926f713f211d2$var$THIRTY_DAYS_MS;
                // Expired: Delete entire database.
                if (isExpired) {
                    const daysExpired = Math.floor(databaseAge / 86400000);
                    const hasBackup = !!metaData.versionInsertionBackup;
                    await $e9c926f713f211d2$var$deleteDatabase(dbName);
                    resolve({
                        dbName: dbName,
                        deleted: true,
                        reason: 'expired',
                        daysExpired: daysExpired,
                        stepsCount: stepsCount,
                        hasBackup: hasBackup
                    });
                    return;
                }
                // Not expired: Database is active.
                resolve({
                    dbName: dbName,
                    deleted: false,
                    reason: 'active'
                });
            } catch (error) {
                resolve({
                    dbName: dbName,
                    deleted: false,
                    reason: 'error',
                    errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error)
                });
            } finally{
                database.close();
            }
        };
    });
}
async function $e9c926f713f211d2$export$1419703707730bf4(currentDbName, api) {
    try {
        if (!window.indexedDB.databases) return;
        const allDatabases = await window.indexedDB.databases();
        const offlineEditorDatabases = allDatabases.filter((dbInfo)=>dbInfo.name?.startsWith((0, $awSMG.OFFLINE_STEPS_DATABASE_NAME_PREFIX)) && dbInfo.name !== currentDbName);
        if (offlineEditorDatabases.length === 0) return;
        const totalOfflineDatabases = offlineEditorDatabases.length;
        // We randomise the order to ensure all databases eventually get checked. Otherwise, we'd check the first N databases every time.
        // We also cap the number of databases checked per run to prevent performance issues. For power users with large backlogs, cleanup will happen gradually over multiple days.
        const randomisedDatabases = offlineEditorDatabases.sort(()=>Math.random() - 0.5);
        const databasesToCheck = randomisedDatabases.slice(0, $e9c926f713f211d2$var$MAX_DATABASES_PER_CLEANUP);
        for (const dbInfo of databasesToCheck){
            const dbName = dbInfo.name;
            try {
                const result = await $e9c926f713f211d2$export$197ab581d971f15a(dbName);
                // Fire analytics for expired databases
                if (result.reason === 'expired') (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: api,
                    action: 'OFFLINE_EDITING_DATA_EXPIRY_CLEANUP',
                    contentId: $e9c926f713f211d2$var$extractContentId(dbName),
                    cleanupType: 'database_deleted',
                    daysExpired: result.daysExpired ?? 0,
                    stepsCount: result.stepsCount ?? 0,
                    hasBackup: result.hasBackup ?? false,
                    isBackgroundCleanup: true,
                    totalOfflineDatabases: totalOfflineDatabases
                });
                // Fire analytics for database check errors
                if (result.reason === 'error') (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: api,
                    action: 'OFFLINE_EDITING_BACKGROUND_CLEANUP_ERROR',
                    errorMessage: result.errorMessage ?? 'Unknown error',
                    errorSource: 'database_check',
                    contentId: $e9c926f713f211d2$var$extractContentId(dbName),
                    totalOfflineDatabases: totalOfflineDatabases
                });
            } catch (error) {
                (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: api,
                    action: 'OFFLINE_EDITING_BACKGROUND_CLEANUP_ERROR',
                    errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error),
                    errorSource: 'database_check',
                    contentId: $e9c926f713f211d2$var$extractContentId(dbName),
                    totalOfflineDatabases: totalOfflineDatabases
                });
            }
        }
    } catch (error) {
        (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: api,
            action: 'OFFLINE_EDITING_BACKGROUND_CLEANUP_ERROR',
            errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error),
            errorSource: 'cleanup_init'
        });
    }
}





const $f0050ff6ee6f7eb3$export$9fd1ded1027f9ea2 = 2;
const $f0050ff6ee6f7eb3$var$SYNC_LOCK_TIMEOUT_MS = 20000;
const $f0050ff6ee6f7eb3$var$THIRTY_DAYS_MS = 2592000000;
class $f0050ff6ee6f7eb3$export$c7a2e99e9e26da1c {
    // Used to cache the result of the IndexedDB validation.
    onError(_id, error, disabledReason) {
        // Indicate the steps database is not healthy.
        this.api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
                disabled: disabledReason ?? 'stepsDatabaseError'
            }));
        (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: this.api,
            action: (0, $d925B.ACTION).OFFLINE_STORAGE_STEPS_DATABASE_ERROR,
            errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error),
            errorSource: _id,
            errorCause: {
                contentIdPresent: !!this.contentId,
                stepsDatabaseInitAttempted: this.initAttempted,
                // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                isSSR: false,
                isIndexedDBAvailable: this.indexedDBAvailable
            }
        });
    }
    /**
   * The name of the database for the current contentId
   */ get dbName() {
        if (!this.contentId) return undefined;
        return `${0, $awSMG.OFFLINE_STEPS_DATABASE_NAME_PREFIX}${this.contentId}`;
    }
    get hasLock() {
        return this.syncLock.hasLock;
    }
    get lockPurpose() {
        return this.syncLock.lockPurpose;
    }
    isLocked() {
        return this.syncLock.isLocked();
    }
    /**
   * Releases the current sync lock. Returns a promise to check if the lock has been released
   * at this point which can be useful if you want to do other operations (ie. update the DB)
   * based on the lock status and need it to be freed.
   *
   * @returns boolean: The result if the sync is still locked.
   */ async releaseSyncLock() {
        this.syncLock.releaseLock?.();
        return this.syncLock.isLocked();
    }
    /**
   * Attempts to acquire a synchronization lock for the database.
   *
   * @param callback - Optional callback function that is called when the lock is acquired or times out.
   *                  The callback receives a boolean indicating if the lock was granted.
   * @param waitUntilAvailable - If true, waits until the lock becomes available. If false, returns immediately.
   * @param timeoutAfterMS - Optional timeout in milliseconds. If provided and waitUntilAvailable is true,
   *                        the callback will be called with false if the lock isn't acquired within this time.
   *                        When platform_editor_offline_editing_web_ga_fixes is cleaned up, this parameter can be removed.
   * @returns A Promise if waiting for the lock, void if not waiting.
   */ acquireSyncLock(callback, waitUntilAvailable = false, purpose, timeoutAfterMS) {
        const lockPromise = this.syncLock.acquireLock(callback, waitUntilAvailable, purpose).catch((e)=>{
            this.onError('acquireSyncLock()', e);
            // Ensure callback is called with false on error
            return callback?.(false);
        });
        // If we're not waiting for the lock, fire-and-forget
        if (!waitUntilAvailable) return;
        const effectiveTimeout = (0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes') ? $f0050ff6ee6f7eb3$var$SYNC_LOCK_TIMEOUT_MS : timeoutAfterMS;
        // If we have a timeout, race the lock acquisition with a timeout. Redundant check when platform_editor_offline_editing_web_ga_fixes is cleaned up.
        if (effectiveTimeout) {
            const timeoutPromise = new Promise((resolve)=>{
                setTimeout(async ()=>{
                    // Callback invoked with granted = false, failed attempt to acquire lock.
                    await callback?.(false);
                    resolve();
                }, effectiveTimeout);
            });
            return Promise.race([
                lockPromise,
                timeoutPromise
            ]);
        }
        return lockPromise;
    }
    /**
   * Initialize the class for the given contentId.
   * Can be re-initialized with a different contentId, which will close an existing connection.
   * Does not open the database connection.
   * @param contentId The unique page contentId
   * @returns true if initialized successfully, false if indexedDB is not supported.
   */ async init(contentId, api) {
        this.initAttempted = true;
        this.api = api;
        if (window?.indexedDB === undefined) {
            this.onError('init()', new Error('indexedDB is not defined'));
            return false;
        }
        if (this.contentId === contentId && this.dbPromise) return true;
        // This closeDB is redundant, as the DB is immedately reopened after init.
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_db_expiry')) await this.closeDB();
        this.contentId = contentId;
        if (this.dbName) this.syncLock.init(this.dbName);
        return true;
    }
    /**
   * Validates IndexedDB access by attempting a test write.
   * @returns Promise<boolean> - true if validation succeeds, false if it fails
   */ async validateIndexedDBAccess() {
        // Check the cached indexedDBAvailable to avoid validating multiple times.
        if (this.indexedDBAvailable !== undefined) return this.indexedDBAvailable ?? true;
        try {
            if (window?.indexedDB === undefined) throw new Error('indexedDB is not defined');
            const testDbName = 'editor:offline-storage-access-test';
            const testDb = await (0, $ffQ2A.openDB)(testDbName, 1, {
                upgrade (db) {
                    db.createObjectStore('test', {
                        autoIncrement: true
                    });
                }
            });
            // Try a test write
            const tx = testDb.transaction('test', 'readwrite');
            const store = tx.objectStore('test');
            await store.add({
                test: 'test'
            });
            await tx.done;
            // Clean up
            testDb.close();
            window.indexedDB.deleteDatabase(testDbName);
            this.indexedDBAvailable = true;
            return true;
        } catch (error) {
            this.onError('validateIndexedDBAccess()', error, 'indexedDBAccessError');
            this.indexedDBAvailable = false;
            return false;
        }
    }
    /**
   * Gets or creates a database connection for the current contentId.
   * If a connection exists, validates it is still usable before returning.
   * If validation fails or no connection exists, creates and returns a new connection.
   *
   * @throws {Error} When dbName is undefined (not initialized – missing contentId, init not called, or in SSR mode)
   * @returns A promise that resolves to a valid database connection
   */ async openDB() {
        if (this.dbName === undefined) throw new Error('StepsDatabase not initialized. Possibly missing contentId, init hasnt been called or rendering in SSR mode.');
        // If we have a cached connection, we validate it with a quick read transaction.
        // If this transaction fails, we close the connection and create a new one.
        if (this.dbPromise) try {
            const db = await this.dbPromise;
            await db.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readonly').objectStore((0, $awSMG.OFFLINE_META_STORE_NAME)).count();
            // Returning the valid cached database connection.
            return this.dbPromise;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (_error) {
            // Cleanup before creating a new connection.
            await this.closeDB();
        }
        this.dbPromise = (0, $ffQ2A.openDB)(this.dbName, $f0050ff6ee6f7eb3$export$9fd1ded1027f9ea2, {
            upgrade (db) {
                if (!db.objectStoreNames.contains((0, $awSMG.OFFLINE_STEPS_STORE_NAME))) db.createObjectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME), {
                    keyPath: 'id',
                    autoIncrement: true
                });
                if (!db.objectStoreNames.contains((0, $awSMG.OFFLINE_META_STORE_NAME))) db.createObjectStore((0, $awSMG.OFFLINE_META_STORE_NAME), {});
            },
            terminated: ()=>{
                this.dbPromise = undefined;
            }
        });
        return this.dbPromise;
    }
    sanitizeStep(step) {
        if (step instanceof (0, $4XhNP.AnalyticsStep) || step instanceof (0, $44jjU.LinkMetaStep)) return undefined;
        return step.toJSON();
    }
    /**
   * Update the steps, doc and version in the database if the stored steps are different.
   * It does a full clear and replace with the new steps.
   * @param version The collab version for creating unique key/value pairs in the db
   * @param steps The steps to store in the database
   * @returns true if the steps were updated, false if the steps were the same as the stored steps
   */ async updateIfChanged(version, baseDocJSON, steps) {
        try {
            const isLocked = await this.syncLock.isLocked() && !this.hasLock;
            if (isLocked) return false;
            const db = await this.openDB();
            const tx = db.transaction([
                (0, $awSMG.OFFLINE_STEPS_STORE_NAME),
                (0, $awSMG.OFFLINE_META_STORE_NAME)
            ], 'readwrite');
            const stepsStore = (0, $ffQ2A.unwrap)(tx.objectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME)));
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            // We breakout of idb here. The reason is it ensures we have a single promise
            // for `updateSteps` and ensures `fake-indexeddb` works as intended here.
            // This allows us to test as close as possible to real indexeddb
            const updateSteps = async ()=>{
                await new Promise((resolve, reject)=>{
                    const localSteps = steps.map(this.sanitizeStep).filter((step)=>!!step);
                    const request = stepsStore.clear();
                    request.onsuccess = ()=>{
                        // Store serialized steps in the database
                        let index = 0;
                        const addNextStep = ()=>{
                            if (index < localSteps.length) {
                                const serializedStep = localSteps[index];
                                const addRequest = stepsStore.add({
                                    step: serializedStep
                                });
                                addRequest.onsuccess = ()=>{
                                    index++;
                                    addNextStep();
                                };
                                addRequest.onerror = (event)=>{
                                    reject(event.target?.error);
                                };
                            } else resolve(undefined);
                        };
                        addNextStep();
                    };
                    request.onerror = (event)=>{
                        reject(event.target?.error);
                    };
                });
            };
            await Promise.all([
                updateSteps(),
                // Store the doc, version, and lastUpdated timestamp
                docStore.put({
                    doc: baseDocJSON,
                    version: version,
                    lastUpdated: Date.now()
                }, 1)
            ]);
            await tx.done;
            return true;
        } catch (e) {
            this.onError('updateIfChanged()', e);
            throw e;
        }
    }
    /**
   * Update the stored docJSON and version in the database.
   * This can be called by the leader after applying steps to save the post-apply state for followers.
   * Extracts the confirmed document state and collaboration version from the editor view.
   * @param editorView The editor view to extract document state and version from
   * @returns Promise<boolean> - true if updated successfully, throws on error
   */ async updateDocAndVersion(editorView) {
        try {
            const newVersion = (0, $9NwnH.getCollabState)(editorView.state)?.version;
            if (newVersion === undefined) return false;
            const db = await this.openDB();
            const tx = db.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readwrite');
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const transformer = new (0, $h9yJL.JSONTransformer)();
            // We use getDocBeforeUnconfirmedSteps to ensure we get the latest _confirmed_ document, as some
            // ... unconfirmed steps may have come through while clearing the offline steps and updating the docJSON.
            const newDocJSON = transformer.encode((0, $9NwnH.getDocBeforeUnconfirmedSteps)(editorView.state));
            // Update doc, version, and lastUpdated timestamp
            const updatedData = {
                doc: newDocJSON,
                version: newVersion,
                lastUpdated: Date.now()
            };
            await docStore.put(updatedData, 1);
            await tx.done;
            return true;
        } catch (e) {
            this.onError('updateDocAndVersion()', e);
            throw e;
        }
    }
    /**
   * Retrieve the steps, doc and version from the database.
   * Will open a new database connection, if one is not already open.
   * @param pmSchema The current ProseMirror schema
   * @returns The steps stored in the database
   */ async getData(pmSchema) {
        try {
            const db = await this.openDB();
            const tx = db.transaction([
                (0, $awSMG.OFFLINE_STEPS_STORE_NAME),
                (0, $awSMG.OFFLINE_META_STORE_NAME)
            ], 'readonly');
            const stepsStore = tx.objectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME));
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            // Collect all steps
            const collectSteps = async ()=>{
                const steps = await stepsStore.getAll();
                return steps.map((stepJson)=>(0, $2eY6H.Step).fromJSON(pmSchema, stepJson.step));
            };
            const [storedSteps, data] = await Promise.all([
                collectSteps(),
                docStore.get(1)
            ]);
            await tx.done;
            return data === undefined ? {
                steps: storedSteps,
                docJSON: null,
                version: null
            } : {
                steps: storedSteps,
                docJSON: data.doc,
                version: data.version
            };
        } catch (e) {
            this.onError('getData()', e);
            throw e;
        }
    }
    /**
   * Clear all steps, and stored doc from the database
   * Will open a new database connection, if one is not already open.
   */ async clear(all) {
        try {
            const isLocked = await this.syncLock.isLocked() && !this.hasLock;
            if (isLocked) return false;
            const db = await this.openDB();
            const tx = db.transaction([
                (0, $awSMG.OFFLINE_STEPS_STORE_NAME),
                (0, $awSMG.OFFLINE_META_STORE_NAME)
            ], 'readwrite');
            const stepsStore = tx.objectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME));
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            if (all) await Promise.all([
                stepsStore.clear(),
                docStore.clear()
            ]);
            else await stepsStore.clear();
            await tx.done;
            return true;
        } catch (e) {
            this.onError('clear()', e);
            throw e;
        }
    }
    /**
   * Check and clear expired data from the current document's database.
   * Also triggers background cleanup of other databases (throttled to once per 24 hours).
   * This should be called after init() but before attempting to restore steps.
   */ async checkAndClearExpiredData() {
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_db_expiry')) return;
        // Check and clear current document's expired data
        await this.checkCurrentDocumentExpiry();
        // Run background cleanup of other document's offline databases (non-blocking, throttled)
        if ((0, $e9c926f713f211d2$export$365e5e8d6c8a82b3)()) {
            // Mark attempted immediately to prevent race condition if multiple tabs open simultaneously
            (0, $e9c926f713f211d2$export$df49bbb19630c32d)();
            (0, $e9c926f713f211d2$export$1419703707730bf4)(this.dbName, this.api);
        }
    }
    /**
   * Check if the current document's offline data has expired and clear it if needed.
   * Uses instance methods (this.openDB(), this.clear()) rather than deleting the database entirely.
   * This preserves the database structure and connection since the current document may be
   * actively written to (e.g. user goes offline). Background cleanup of other databases
   * can safely delete them entirely as they have no active StepsDatabase instance.
   *
   * Backwards compatibility: If data exists but no lastUpdated, adds timestamp = now (30-day window starts from today).
   * Expiry: If lastUpdated > 30 days, clears all data via clear(true)
   */ async checkCurrentDocumentExpiry() {
        try {
            const db = await this.openDB();
            // Early exit if the object stores don't exist yet.
            // This is expected for users who haven't used offline storage before.
            if (!db.objectStoreNames.contains((0, $awSMG.OFFLINE_META_STORE_NAME)) || !db.objectStoreNames.contains((0, $awSMG.OFFLINE_STEPS_STORE_NAME))) return;
            const tx = db.transaction([
                (0, $awSMG.OFFLINE_STEPS_STORE_NAME),
                (0, $awSMG.OFFLINE_META_STORE_NAME)
            ], 'readwrite');
            const metaStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const stepsStore = tx.objectStore((0, $awSMG.OFFLINE_STEPS_STORE_NAME));
            const [metaData, stepsCount] = await Promise.all([
                metaStore.get(1),
                stepsStore.count()
            ]);
            if (!metaData) {
                await tx.done;
                return;
            }
            const now = Date.now();
            // Backwards compatibility: If data exists but no lastUpdated timestamp, add current timestamp
            // This starts the 30-day window from today for existing data
            if (!metaData.lastUpdated) {
                const updatedData = {
                    ...metaData,
                    lastUpdated: now
                };
                await metaStore.put(updatedData, 1);
                await tx.done;
                return;
            }
            // Check if data has expired (>30 days old) - single timestamp for all data
            if (now - metaData.lastUpdated > $f0050ff6ee6f7eb3$var$THIRTY_DAYS_MS) {
                await tx.done;
                // Gather analytics metadata
                const hasBackup = !!metaData.versionInsertionBackup;
                const daysExpired = Math.floor((now - metaData.lastUpdated) / 86400000);
                if (this.contentId) (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: this.api,
                    action: 'OFFLINE_EDITING_DATA_EXPIRY_CLEANUP',
                    contentId: this.contentId,
                    cleanupType: 'database_cleared',
                    daysExpired: daysExpired,
                    stepsCount: stepsCount,
                    hasBackup: hasBackup
                });
                await this.clear(true);
                return;
            }
            await tx.done;
        } catch (e) {
            this.onError('checkCurrentDocumentExpiry()', e);
        }
    }
    async closeDB(releaseSyncLock = false) {
        try {
            if (this.dbPromise) {
                const db = await this.dbPromise;
                db.close();
                this.dbPromise = undefined;
                if (releaseSyncLock) this.syncLock.releaseLock?.();
            }
        } catch (e) {
            this.onError('closeDB()', e);
            throw e;
        }
    }
    /**
   * Store a version insertion backup for later retry
   * @param adfContent Stringified ADF content that failed to be inserted
   * @returns Promise<boolean> - true if stored successfully
   */ async storeVersionInsertionBackup(adfContent) {
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) return false;
        try {
            const db = await this.openDB();
            const tx = db.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readwrite');
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const existingData = await docStore.get(1);
            // Only store backup if meta store already exists with doc and version
            // If it doesn't exist, there's no document to store a backup for
            if (!existingData || !existingData.doc || existingData.version === undefined) {
                await tx.done;
                return false;
            }
            // Create the backup object (no timestamp - uses shared lastUpdated)
            const versionInsertionBackup = {
                adfContent: adfContent
            };
            // Preserve all existing data and update both versionInsertionBackup and lastUpdated
            const updatedData = {
                ...existingData,
                versionInsertionBackup: versionInsertionBackup,
                lastUpdated: Date.now()
            };
            await docStore.put(updatedData, 1);
            await tx.done;
            return true;
        } catch (e) {
            this.onError('storeVersionInsertionBackup()', e);
            return false;
        }
    }
    /**
   * Get the stored version insertion backup if one exists
   * @returns Promise<VersionInsertionBackup | null>
   */ async getVersionInsertionBackup() {
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) return null;
        try {
            const db = await this.openDB();
            // Early exit if the meta store doesn't exist yet.
            // This is expected for users who haven't used offline storage before.
            if (!db.objectStoreNames.contains((0, $awSMG.OFFLINE_META_STORE_NAME))) return null;
            const tx = db.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readonly');
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const data = await docStore.get(1);
            await tx.done;
            return data?.versionInsertionBackup ?? null;
        } catch (e) {
            this.onError('getVersionInsertionBackup()', e);
            return null;
        }
    }
    /**
   * Clear the stored version insertion backup and update lastUpdated timestamp
   * @returns Promise<boolean> - true if cleared successfully
   */ async clearVersionInsertionBackup() {
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) return false;
        try {
            const db = await this.openDB();
            const tx = db.transaction((0, $awSMG.OFFLINE_META_STORE_NAME), 'readwrite');
            const docStore = tx.objectStore((0, $awSMG.OFFLINE_META_STORE_NAME));
            const existingData = await docStore.get(1);
            // If no data exists or no error field exists, nothing to clear
            if (!existingData || !existingData.versionInsertionBackup) {
                await tx.done;
                return true;
            }
            // Remove the versionInsertionBackup field and update timestamp
            const { versionInsertionBackup: _versionInsertionBackup, ...dataWithoutBackup } = existingData;
            await docStore.put({
                ...dataWithoutBackup,
                lastUpdated: Date.now()
            }, 1);
            await tx.done;
            return true;
        } catch (e) {
            this.onError('clearVersionInsertionBackup()', e);
            return false;
        }
    }
    constructor(){
        this.dbPromise = void 0;
        this.contentId = void 0;
        this.syncLock = new (0, $5c049076093b3a44$export$d15eb9e8bb5d03ea)();
        this.api = void 0;
        this.initAttempted = false;
        this.indexedDBAvailable = void 0;
    }
}












var $ke2AI = parcelRequire("ke2AI");

const $8755c63771d651df$export$43d640f3b62db5ab = (editorView)=>{
    const { state: state } = editorView;
    const newState = state.reconfigure({
        plugins: state.plugins.filter((p)=>{
            return p.spec.key !== (0, $ke2AI.history)().spec.key;
        })
    });
    editorView.updateState(newState);
    const { state: updatedState } = editorView;
    const newerState = updatedState.reconfigure({
        plugins: updatedState.plugins.concat((0, $ke2AI.history)())
    });
    editorView.updateState(newerState);
};



const $c71be5c341006c26$export$e38c76da774a8077 = ({ api: api, editorView: editorView, stepsDatabase: stepsDatabase })=>{
    const isBroadcastChannelSupported = window && 'BroadcastChannel' in window;
    const channelRef = (0, $42omo.useRef)();
    const firstChannelUpdateRef = (0, $42omo.useRef)(false);
    const broadcast = (0, $42omo.useCallback)((messageType = 'resync')=>{
        if (channelRef.current) {
            const message = {
                type: messageType
            };
            channelRef.current.postMessage(message);
        }
    }, []);
    const listener = (0, $42omo.useCallback)(async function(event) {
        const { type: type } = event.data;
        if (type !== 'resync' && type !== 'restore') return;
        const { mode: mode } = api?.connectivity?.sharedState.currentState() ?? {};
        // RESYNC: Only proceed when offline. This happens while syncing tabs when offline.
        // RESTORE: Only proceed when online. We restore on initialisation, when we have a connection.
        if (type === 'resync') {
            if (mode !== 'offline') return;
        } else if (type === 'restore') {
            if (mode !== 'online') return;
        }
        const { steps: steps, docJSON: docJSON, version: cachedVersion } = await stepsDatabase.getData(editorView.state.schema);
        if (!docJSON || cachedVersion === null) return;
        // RESYNC: only proceed when there are steps to sync.
        // RESTORE: only proceed when there are no steps to sync. The docJSON should have the cleared steps already applied.
        if (type === 'resync') {
            if (!steps) return;
        } else if (type === 'restore') {
            if (steps && steps.length > 0) return;
        }
        if (!firstChannelUpdateRef.current) {
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: (0, $d925B.ACTION).OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE
            });
            firstChannelUpdateRef.current = true;
        }
        const historyState = api?.history?.sharedState?.currentState?.();
        const hasHistory = (historyState?.done?.eventCount ?? 0) > 0 || (historyState?.undone?.eventCount ?? 0) > 0;
        if (hasHistory) (0, $8755c63771d651df$export$43d640f3b62db5ab)(editorView);
        const tr = (0, $9NwnH.syncFromAnotherSource)(editorView.state, cachedVersion, docJSON, steps);
        if (hasHistory && api?.history?.commands.updatePluginState) api.history.commands.updatePluginState({
            tr: tr
        });
        editorView.dispatch(tr);
    }, [
        api,
        editorView,
        stepsDatabase
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isBroadcastChannelSupported || !stepsDatabase.dbName) return;
        channelRef.current = new BroadcastChannel(stepsDatabase.dbName);
        channelRef.current.addEventListener('message', listener);
        return ()=>{
            if (channelRef.current) {
                channelRef.current.removeEventListener('message', listener);
                channelRef.current.close();
            }
        };
    }, [
        isBroadcastChannelSupported,
        stepsDatabase.dbName,
        listener
    ]);
    return broadcast;
};












function $85a440c10c4579b2$export$199006561aceceef() {
    return ({ tr: tr })=>{
        tr.setMeta('addToHistory', false);
        tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
            status: 'ready'
        });
        return tr;
    };
}
function $85a440c10c4579b2$export$415f09fb1d3d2a43(steps, api) {
    return ({ tr: tr })=>{
        const failedSteps = [];
        steps.forEach((step)=>{
            try {
                tr.step(step);
            } catch (e) {
                // step failed to apply, ignore it and attempt to apply other steps
                failedSteps.push({
                    step: step,
                    error: e
                });
            }
        });
        if (failedSteps.length > 0) (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: api,
            action: (0, $d925B.ACTION).OFFLINE_STORAGE_FAILED_STEPS,
            errorInfo: (0, $1a899df20ad45f18$export$ff269655d7dc6e77)(failedSteps.map((s)=>s.error)),
            stepsCount: failedSteps.length
        });
        tr.setMeta('addToHistory', false);
        tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
            status: 'ready'
        });
        return tr;
    };
}
function $85a440c10c4579b2$export$14dd948c471b3773() {
    return ({ tr: tr })=>{
        tr.setMeta('addToHistory', false);
        tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
            status: 'tooManyRetries'
        });
        return tr;
    };
}
function $85a440c10c4579b2$export$e62d02f588ae224b(inactiveSyncing) {
    return ({ tr: tr })=>{
        tr.setMeta('addToHistory', false);
        tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
            inactiveSyncing: inactiveSyncing
        });
        return tr;
    };
}






const $9ea4175711f7ca12$var$MAX_APPLY_ATTEMPTS = 3;
const $9ea4175711f7ca12$export$33afc5c2570a827c = (status, granted)=>{
    switch(status){
        case 'init':
            return granted ? 'leader_granted' : 'follower_waiting'; // First tab becomes leader
        case 'follower_waiting':
            return granted ? 'follower_granted' : 'follower_waiting';
        case 'leader_granted':
        case 'follower_granted':
            return status;
    }
};
const $9ea4175711f7ca12$var$recreateOfflineDoc = (jsonDoc, steps, pmSchema)=>{
    try {
        let doc = pmSchema.nodeFromJSON(jsonDoc);
        steps.forEach((step)=>{
            const res = step.apply(doc);
            if (!res.failed && res.doc) doc = res.doc;
        });
        return doc;
    } catch (error) {
        // TODO: Follow-up error handling
        return undefined;
    }
};
async function $9ea4175711f7ca12$export$5328e866ce5f6eff(api, stepsDatabase, pmSchema, options) {
    try {
        const { steps: steps, docJSON: docJSON } = await stepsDatabase.getData(pmSchema);
        if (steps.length > 0) {
            if (docJSON && (0, $9wGTI.fg)('platform_editor_offline_version_sync')) {
                const offlineDoc = $9ea4175711f7ca12$var$recreateOfflineDoc(docJSON, steps, pmSchema);
                if (offlineDoc) options?.createOfflineVersion?.({
                    doc: offlineDoc,
                    steps: steps
                });
            }
            const dispatched = api?.core.actions.execute((0, $85a440c10c4579b2$export$415f09fb1d3d2a43)(steps, api));
            if (!dispatched) return false;
        }
        return true;
    } catch (error) {
        return false;
    }
}
async function $9ea4175711f7ca12$export$272cc1d3c48af723(api, stepsDatabase) {
    api?.core.actions.execute((0, $85a440c10c4579b2$export$199006561aceceef)());
    await stepsDatabase.releaseSyncLock();
    api?.core.actions.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
}
async function $9ea4175711f7ca12$export$8d012bece2dd72ad(api, stepsDatabase, pmSchema, options) {
    let attempts = 0;
    while(attempts < $9ea4175711f7ca12$var$MAX_APPLY_ATTEMPTS){
        const hasSyncSucceeded = await $9ea4175711f7ca12$export$5328e866ce5f6eff(api, stepsDatabase, pmSchema, {
            createOfflineVersion: options?.createOfflineVersion
        });
        if (hasSyncSucceeded) // The leader tab relies on the usePluginHook to release their lock and clear the steps from the DB.
        // We do not set the leader as "syncing", so we do not need to call setInactiveSyncingCommand(false).
        return;
        else {
            // Allow 1 second between attempts.
            await new Promise((resolve)=>setTimeout(resolve, 1000));
            attempts++;
        }
    }
    // If we get here, leader path failed after all attempts.
    await $9ea4175711f7ca12$export$272cc1d3c48af723(api, stepsDatabase);
}
async function $9ea4175711f7ca12$export$2685e1bc42d6db28(api, stepsDatabase) {
    // Wait 2 seconds before allowing the follower to complete, as sometimes it can complete too quickly, making the banner flash briefly.
    await new Promise((resolve)=>setTimeout(resolve, 2000));
    api?.core.actions.execute((0, $85a440c10c4579b2$export$199006561aceceef)());
    await stepsDatabase.releaseSyncLock();
    api?.core.actions.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
}
async function $9ea4175711f7ca12$export$7ac1d860e1e72b3d(api, stepsDatabase, pmSchema) {
    let attempts = 0;
    while(attempts < $9ea4175711f7ca12$var$MAX_APPLY_ATTEMPTS){
        const hasSyncSucceeded = await $9ea4175711f7ca12$export$5328e866ce5f6eff(api, stepsDatabase, pmSchema);
        if (hasSyncSucceeded) {
            await $9ea4175711f7ca12$export$2685e1bc42d6db28(api, stepsDatabase);
            return;
        } else {
            // Allow 1 second between attempts.
            await new Promise((resolve)=>setTimeout(resolve, 1000));
            attempts++;
        }
    }
    // If we get here, follower path failed after all attempts.
    await $9ea4175711f7ca12$export$272cc1d3c48af723(api, stepsDatabase);
}
async function $9ea4175711f7ca12$export$5c6efac8a19ad9f7(api, stepsDatabase, lockCallback) {
    const LOCK_TIMEOUT = 20000; // Wait for the lock, but only up to 20 seconds.
    api?.core.actions.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(true));
    // TODO: Remove the timeoutAfterMS param after cleaning up the platform_editor_offline_editing_web_ga_fixes gate. All sync lock acquisitions have an expiration timer now.
    await stepsDatabase.acquireSyncLock(lockCallback, true, 'restore', LOCK_TIMEOUT);
}
function $9ea4175711f7ca12$export$f0123301da84dec0(api, stepsDatabase, pmSchema, options) {
    let status = 'init';
    let previousStatus = 'init';
    const callback = async (granted)=>{
        previousStatus = status;
        status = $9ea4175711f7ca12$export$33afc5c2570a827c(status, granted);
        // If we're transitioning to the same state, we might be in a loop. For example, if the follower is stuck in a loop of follower_waiting -> follower_waiting.
        if (status === previousStatus) {
            await $9ea4175711f7ca12$export$272cc1d3c48af723(api, stepsDatabase);
            return;
        }
        switch(status){
            case 'leader_granted':
                await $9ea4175711f7ca12$export$8d012bece2dd72ad(api, stepsDatabase, pmSchema, options);
                break;
            case 'follower_waiting':
                await $9ea4175711f7ca12$export$5c6efac8a19ad9f7(api, stepsDatabase, callback);
                break;
            case 'follower_granted':
                await $9ea4175711f7ca12$export$7ac1d860e1e72b3d(api, stepsDatabase, pmSchema);
                break;
        }
    };
    return callback;
}


const $576038989d33c4bf$var$MAX_RETRIES = 2;
const $576038989d33c4bf$var$RETRY_DELAY = 1000;
async function $576038989d33c4bf$export$68ef7af6a41f5e44(stepsDatabase, pmSchema) {
    // If there's an error, the validateIndexedDBAccess will disable the plugin.
    const isIndexedDBAvailable = await stepsDatabase.validateIndexedDBAccess();
    if (!isIndexedDBAvailable) return false;
    const databases = await window.indexedDB.databases();
    const dbExists = Boolean(databases.find((db)=>db.name === stepsDatabase.dbName));
    if (!dbExists) return false;
    // If there are steps, we need to restore them.
    const { steps: steps } = await stepsDatabase.getData(pmSchema);
    if (steps.length > 0) return true;
    return false;
}
async function $576038989d33c4bf$export$d647a8cf160c7fa9(api, stepsDatabase, editorView, pmSchema, retryCount, error) {
    if (retryCount >= $576038989d33c4bf$var$MAX_RETRIES) {
        api?.core.actions.execute((0, $85a440c10c4579b2$export$14dd948c471b3773)());
        (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: api,
            action: (0, $d925B.ACTION).OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR,
            errorMessage: `Exceeded max retries (${$576038989d33c4bf$var$MAX_RETRIES}) with delay of ${$576038989d33c4bf$var$RETRY_DELAY}ms`,
            errorInfo: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(error),
            maxRetries: $576038989d33c4bf$var$MAX_RETRIES,
            retrySource: 'isStepsRestoreRequired'
        });
        return;
    }
    await new Promise((resolve)=>setTimeout(resolve, $576038989d33c4bf$var$RETRY_DELAY));
    $576038989d33c4bf$export$312d5d76abf7691a(api, stepsDatabase, editorView, retryCount + 1)(pmSchema);
}
function $576038989d33c4bf$export$312d5d76abf7691a(api, stepsDatabase, editorView, retryCount = 0, options) {
    return async (pmSchema)=>{
        try {
            const shouldRestore = await $576038989d33c4bf$export$68ef7af6a41f5e44(stepsDatabase, pmSchema);
            if (!shouldRestore) {
                api?.core.actions.execute((0, $85a440c10c4579b2$export$199006561aceceef)());
                return;
            }
        } catch (error) {
            await $576038989d33c4bf$export$d647a8cf160c7fa9(api, stepsDatabase, editorView, pmSchema, retryCount, error);
            return;
        }
        (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
            api: api,
            action: (0, $d925B.ACTION).OFFLINE_STORAGE_RESTORE_STEPS_INITIATED,
            retryCount: retryCount
        });
        const lockCallback = (0, $9ea4175711f7ca12$export$f0123301da84dec0)(api, stepsDatabase, pmSchema, options);
        stepsDatabase.acquireSyncLock(lockCallback, false, 'restore');
    };
}



var $8Yfbq = parcelRequire("8Yfbq");





const $a5de712ae25052da$export$4abb9cd0bdff89ec = async ({ editorView: editorView, stepsDatabase: stepsDatabase, version: version, steps: steps, broadcast: broadcast })=>{
    const baseDocJSON = (0, $9NwnH.getDocBeforeUnconfirmedSteps)(editorView.state).toJSON();
    const hasChanged = await stepsDatabase.updateIfChanged(version, baseDocJSON, steps);
    if (hasChanged) broadcast();
    else editorView.dispatch(editorView.state.tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
        disabled: 'unableToSync'
    }));
};
const $a5de712ae25052da$export$fed59d57957883a7 = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))($a5de712ae25052da$export$4abb9cd0bdff89ec, 200);























const $de973e9ead6dfe2c$var$ENABLE_EDITOR_TIMEOUT = 3000;
const $de973e9ead6dfe2c$export$33afc5c2570a827c = (status, granted)=>{
    switch(status){
        case 'init':
            return granted ? 'granted_initial' : 'waiting_initial';
        case 'waiting_initial':
        case 'waiting_recovery':
            return granted ? 'granted_recovery' : 'waiting_recovery';
        case 'granted_initial':
        case 'granted_recovery':
        default:
            return status;
    }
};
const $de973e9ead6dfe2c$export$b79afd6d47f11781 = (api)=>{
    const historyState = api?.history?.sharedState?.currentState?.();
    return (historyState?.done?.eventCount ?? 0) > 0 || (historyState?.undone?.eventCount ?? 0) > 0;
};
async function $de973e9ead6dfe2c$export$5ac754b16bef384(api, stepsDatabase, editorView, isActiveTab, options) {
    if (api?.connectivity?.sharedState.currentState()?.mode === 'offline') return;
    let status = 'init';
    let previousStatus = 'init';
    const lockCallback = async (granted)=>{
        previousStatus = status;
        status = $de973e9ead6dfe2c$export$33afc5c2570a827c(status, granted);
        // If we're transitioning to the same state, we might be in a loop.
        // This can happen if repeated timeouts occur (e.g., waiting_recovery -> waiting_recovery).
        if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
            if (status === previousStatus) {
                // Fallback: enable the editor and give up on syncing
                api?.core?.actions?.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
                return;
            }
        }
        const { steps: steps, docJSON: docJSON, version: version } = await stepsDatabase.getData(editorView?.state?.schema);
        const sendResyncAnalytics = ()=>{
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: (0, $d925B.ACTION).OFFLINE_STORAGE_RESYNC_ONLINE,
                resyncStatus: status,
                isActiveTab: isActiveTab
            });
        };
        const unconfirmedSteps = (0, $9NwnH.getCollabState)(editorView.state)?.unconfirmed ?? [];
        switch(status){
            case 'granted_initial':
                if (steps.length > 0) {
                    sendResyncAnalytics();
                    // Clear offline lock on unconfirmed steps
                    unconfirmedSteps.forEach((s)=>{
                        if (s.origin instanceof (0, $ks2lK.Transaction)) {
                            s.origin.setMeta('isOffline', false);
                            s.origin.setMeta('wasOffline', true);
                        }
                    });
                    if ((0, $9wGTI.fg)('platform_editor_offline_version_sync')) // Create the offline version based on a snapshot of the doc at the time of returning online
                    options.createOfflineVersion?.({
                        doc: editorView.state.doc,
                        steps: unconfirmedSteps.map((s)=>s.step)
                    });
                    setTimeout(()=>{
                        api?.core?.actions?.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
                    }, $de973e9ead6dfe2c$var$ENABLE_EDITOR_TIMEOUT);
                } else if (docJSON && version !== null && unconfirmedSteps.length !== 0) {
                    // So we're here because another tab has already synced but the steps in the DB have been deleted
                    // In this case we revert to the document before going offline and allow collab to resync us
                    sendResyncAnalytics();
                    if ($de973e9ead6dfe2c$export$b79afd6d47f11781(api)) (0, $8755c63771d651df$export$43d640f3b62db5ab)(editorView);
                    const tr = (0, $9NwnH.syncFromAnotherSource)(editorView.state, version, docJSON, []);
                    (0, $85a440c10c4579b2$export$e62d02f588ae224b)(true)({
                        tr: tr
                    });
                    editorView.dispatch(tr);
                    stepsDatabase.acquireSyncLock(lockCallback, true, 'resync');
                } else // At this point we've synced and can enable the editor
                setTimeout(()=>{
                    api?.core?.actions?.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
                }, $de973e9ead6dfe2c$var$ENABLE_EDITOR_TIMEOUT);
                break;
            case 'waiting_initial':
                // Reset to base document so we don't duplicate the unconfirmed steps, when we come back online we'll sync with the latest changes
                if (docJSON && version !== null && unconfirmedSteps?.length !== 0) {
                    sendResyncAnalytics();
                    if ($de973e9ead6dfe2c$export$b79afd6d47f11781(api)) (0, $8755c63771d651df$export$43d640f3b62db5ab)(editorView);
                    const tr = (0, $9NwnH.syncFromAnotherSource)(editorView.state, version, docJSON, []);
                    (0, $85a440c10c4579b2$export$e62d02f588ae224b)(true)({
                        tr: tr
                    });
                    editorView.dispatch(tr);
                    stepsDatabase.acquireSyncLock(lockCallback, true, 'resync');
                }
                break;
            case 'granted_recovery':
                if (steps.length > 0 && docJSON && version !== null) {
                    sendResyncAnalytics();
                    if ($de973e9ead6dfe2c$export$b79afd6d47f11781(api)) (0, $8755c63771d651df$export$43d640f3b62db5ab)(editorView);
                    editorView.dispatch((0, $9NwnH.syncFromAnotherSource)(editorView.state, version, docJSON, steps));
                }
                setTimeout(()=>{
                    api?.core?.actions?.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
                }, $de973e9ead6dfe2c$var$ENABLE_EDITOR_TIMEOUT);
                break;
            case 'waiting_recovery':
                if (steps.length > 0 && docJSON && version !== null) sendResyncAnalytics();
                api?.core?.actions?.execute((0, $85a440c10c4579b2$export$e62d02f588ae224b)(false));
                stepsDatabase.acquireSyncLock(lockCallback, true, 'resync');
                break;
            default:
                break;
        }
    };
    stepsDatabase.acquireSyncLock(lockCallback, false, 'resync');
}




/** @graphql cc **/ 
var $diswb = parcelRequire("diswb");













var $eSUdr = parcelRequire("eSUdr");











var $bQm3c = parcelRequire("bQm3c");









var $3sFtD = parcelRequire("3sFtD");


var $744ND = parcelRequire("744ND");

const $bf60d5cebe6d196a$var$i18n = (0, $cgtv4.defineMessages)({
    errorTitle: {
        id: "editor-offline-storage.version-insertion-error-flag.title",
        defaultMessage: "Error saving version history"
    },
    errorTitleRetry: {
        id: "editor-offline-storage.version-insertion-error-flag.title-retry",
        defaultMessage: "Failed to save"
    },
    errorDescription: {
        id: "editor-offline-storage.version-insertion-error-flag.description",
        defaultMessage: "We couldn't save a version history of your offline edits. Your changes are safe, but if you want a backup please try again."
    },
    errorDescriptionRetry: {
        id: "editor-offline-storage.version-insertion-error-flag.description-retry",
        defaultMessage: "We're still having trouble saving a version history of your offline edits. Please try again."
    },
    retryButton: {
        id: "editor-offline-storage.version-insertion-error-flag.retry-button",
        defaultMessage: "Try again"
    },
    successTitle: {
        id: "editor-offline-storage.version-insertion-success-flag.title",
        defaultMessage: "Version history saved"
    },
    successDescription: {
        id: "editor-offline-storage.version-insertion-success-flag.description",
        defaultMessage: "Your offline edits have been saved to version history."
    }
});
const $bf60d5cebe6d196a$var$ERROR_FLAG_ID = 'version-insertion-error-flag';
const $bf60d5cebe6d196a$var$SUCCESS_FLAG_ID = 'version-insertion-success-flag';
const $bf60d5cebe6d196a$export$ac18e6e44f1970de = (flags, intl, onRetry, onClose, manualRetryCount)=>{
    if (!flags) return;
    flags.showCustomFlag({
        id: $bf60d5cebe6d196a$var$ERROR_FLAG_ID,
        title: intl.formatMessage(manualRetryCount > 0 ? $bf60d5cebe6d196a$var$i18n.errorTitleRetry : $bf60d5cebe6d196a$var$i18n.errorTitle),
        description: intl.formatMessage(manualRetryCount > 0 ? $bf60d5cebe6d196a$var$i18n.errorDescriptionRetry : $bf60d5cebe6d196a$var$i18n.errorDescription),
        customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($744ND))), {
            color: "var(--ds-icon, #292A2E)",
            label: ""
        }),
        actions: [
            {
                content: intl.formatMessage($bf60d5cebe6d196a$var$i18n.retryButton),
                onClick: onRetry
            }
        ],
        onClose: onClose
    });
};
const $bf60d5cebe6d196a$export$fda504c08c17a634 = (flags, intl)=>{
    if (!flags) return;
    flags.showCustomFlag({
        id: $bf60d5cebe6d196a$var$SUCCESS_FLAG_ID,
        title: intl.formatMessage($bf60d5cebe6d196a$var$i18n.successTitle),
        description: intl.formatMessage($bf60d5cebe6d196a$var$i18n.successDescription),
        customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
            color: "var(--ds-icon-success, #6A9A23)",
            label: ""
        })
    });
};
const $bf60d5cebe6d196a$export$2e84f8b8ade6c591 = (flags)=>{
    if (!flags) return;
    flags.hideFlag($bf60d5cebe6d196a$var$ERROR_FLAG_ID);
};


const $185ed3c8b342a5b9$var$i18n = (0, $cgtv4.defineMessages)({
    VersionComment: {
        id: "editor-offline-storage.offline-version-comment",
        defaultMessage: "Offline edits"
    },
    VersionCommentManualRetry: {
        id: "editor-offline-storage.offline-version-comment-manual-retry",
        defaultMessage: "Offline edits (manual retry)"
    }
});
// Tech-spec:
// https://hello.atlassian.net/wiki/spaces/~712020fa3d29df95e344e18f663fa84c3d65c8/pages/5567284738/Tech+Spec+Version+History+Creation+API+with+Offline+Copy
const $185ed3c8b342a5b9$var$EditorOfflineStorageInsertOfflineVersionMutation = (0, $eSUdr.default)`mutation useCreateOfflineVersionInsertVersionMutation($cloudId:ID!$contentId:ID!$adfContent:String!$versionComment:String!){confluence_insertOfflineVersion(cloudId:$cloudId input:{contentId:$contentId adfContent:$adfContent versionComment:$versionComment}){versionNumber success errors{message}}}`;
// Limit how often we can try to create new versions
// P50 disconnection time is ~7 seconds so this tries to minimise new versions
// if someone's connection is flaky.
const $185ed3c8b342a5b9$var$MAX_INTERVAL = 20000;
const $185ed3c8b342a5b9$export$a47b53017b47e379 = ({ contentId: contentId, api: api, stepsDatabase: stepsDatabase, flags: flags })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const intl = (0, $8C5kA.default)();
    const manualRetryCountRef = (0, $42omo.useRef)(0);
    const [createOfflineVersion] = (0, $diswb.useMutation)($185ed3c8b342a5b9$var$EditorOfflineStorageInsertOfflineVersionMutation);
    const createVersionUnthrottled = (0, $42omo.useCallback)(({ cloudId: paramCloudId, contentId: paramContentId, adfContent: adfContent, versionComment: versionComment })=>{
        // Create onRetry callback that will be reused for both error paths
        const onRetry = ()=>{
            if (!flags) return;
            // Increment manual retry count when user clicks retry
            manualRetryCountRef.current += 1;
            (0, $bf60d5cebe6d196a$export$2e84f8b8ade6c591)(flags);
            createVersionUnthrottled({
                cloudId: paramCloudId,
                contentId: paramContentId,
                adfContent: adfContent,
                versionComment: intl.formatMessage($185ed3c8b342a5b9$var$i18n.VersionCommentManualRetry)
            });
        };
        const onClose = ()=>{
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: 'OFFLINE_EDITING_VERSION_INSERTION_ERROR_FLAG_DISMISSED',
                manualRetryCount: manualRetryCountRef.current
            });
        };
        createOfflineVersion({
            variables: {
                cloudId: paramCloudId,
                contentId: paramContentId,
                adfContent: adfContent,
                versionComment: versionComment
            }
        }).then(async (res)=>{
            if (res.errors) {
                (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: api,
                    action: 'OFFLINE_EDITING_FAILED_STORE_RECOVERY_VERSION',
                    errorMessage: res.errors.map((err)=>err.message).join(','),
                    manualRetryCount: manualRetryCountRef.current
                });
                // Store the backup and show flag for later retry
                if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
                    await stepsDatabase.storeVersionInsertionBackup(adfContent);
                    if (flags && paramContentId) (0, $bf60d5cebe6d196a$export$ac18e6e44f1970de)(flags, intl, onRetry, onClose, manualRetryCountRef.current);
                }
                return;
            }
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: 'OFFLINE_EDITING_SUCCESS_STORE_RECOVERY_VERSION',
                success: res.data?.confluence_insertOfflineVersion?.success,
                manualRetryCount: manualRetryCountRef.current
            });
            // Show success flag only after manual retries
            if (manualRetryCountRef.current > 0 && flags) (0, $bf60d5cebe6d196a$export$fda504c08c17a634)(flags, intl);
            // Reset manual retry count on success
            manualRetryCountRef.current = 0;
            // Clear the stored backup on any successful version insertion
            if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) await stepsDatabase.clearVersionInsertionBackup();
        }).catch(async (e)=>{
            (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                api: api,
                action: 'OFFLINE_EDITING_FAILED_STORE_RECOVERY_VERSION',
                errorMessage: (0, $1a899df20ad45f18$export$91c32f1b22d29b2d)(e),
                manualRetryCount: manualRetryCountRef.current
            });
            // Store the backup and show flag for later retry
            if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
                await stepsDatabase.storeVersionInsertionBackup(adfContent);
                if (flags && paramContentId) (0, $bf60d5cebe6d196a$export$ac18e6e44f1970de)(flags, intl, onRetry, onClose, manualRetryCountRef.current);
            }
        });
    }, [
        createOfflineVersion,
        api,
        stepsDatabase,
        flags,
        intl
    ]);
    /**
   * Manually retry version insertion with stored backup content
   * Hides the flag and calls the core createVersionUnthrottled function
   */ const manualRetryCreateVersion = (0, $42omo.useCallback)((storedAdfContent)=>{
        if (!contentId || !flags) return;
        (0, $bf60d5cebe6d196a$export$2e84f8b8ade6c591)(flags);
        createVersionUnthrottled({
            cloudId: cloudId,
            contentId: contentId,
            adfContent: storedAdfContent,
            versionComment: intl.formatMessage($185ed3c8b342a5b9$var$i18n.VersionCommentManualRetry)
        });
    }, [
        contentId,
        cloudId,
        flags,
        intl,
        createVersionUnthrottled
    ]);
    const throttledCreateVersion = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))(createVersionUnthrottled, $185ed3c8b342a5b9$var$MAX_INTERVAL, {
            leading: true,
            trailing: false
        }), [
        createVersionUnthrottled
    ]);
    return {
        createVersion: (0, $42omo.useCallback)(({ doc: doc, steps: steps })=>{
            // Only create a new version if there are document changes
            // To avoid noisy versions we filter out any non-ReplaceSteps
            // Ignore ReplaceAroundSteps and other steps that aren't as likely to be intended by the user
            // Note: This is a best-effort approach and may not cover all cases
            if (steps.filter((s)=>s instanceof (0, $aXG5V.ReplaceStep)).length === 0) return;
            if (!contentId) {
                (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                    api: api,
                    action: 'OFFLINE_EDITING_FAILED_STORE_RECOVERY_VERSION',
                    errorMessage: 'No content id',
                    manualRetryCount: 0
                });
                return;
            }
            const adfContent = new (0, $h9yJL.JSONTransformer)().encode(doc);
            throttledCreateVersion({
                cloudId: cloudId,
                contentId: contentId,
                adfContent: JSON.stringify(adfContent),
                versionComment: intl.formatMessage($185ed3c8b342a5b9$var$i18n.VersionComment)
            });
        }, [
            api,
            contentId,
            throttledCreateVersion,
            cloudId,
            intl
        ]),
        manualRetryCreateVersion: manualRetryCreateVersion
    };
};


/**
 * `usePluginStateEffect` has a debounce - we avoid that here to ensure we
 * catch all states on a critical piece of code
 *
 * @param api
 * @param cb
 */ const $93f027f3fd7090c3$var$useConnectivityEffect = (api, cb)=>{
    // Get the latest effect similar to `usePluginStateEffect` (no debounce)
    const latestEffect = (0, $42omo.useRef)(cb);
    (0, $42omo.useLayoutEffect)(()=>{
        latestEffect.current = cb;
        return ()=>{
            latestEffect.current = undefined;
        };
    }, [
        cb
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        return api?.connectivity?.sharedState.onChange(({ prevSharedState: prevSharedState, nextSharedState: nextSharedState })=>{
            latestEffect.current?.({
                prevMode: prevSharedState?.mode,
                nextMode: nextSharedState?.mode
            });
        });
    }, [
        api
    ]);
};
const $93f027f3fd7090c3$export$68f4c8eca02a72d7 = ({ api: api, editorView: editorView, stepsDatabase: stepsDatabase, broadcastUpdate: broadcastUpdate, contentId: contentId, flags: flags })=>{
    const { createVersion: createOfflineVersion } = (0, $185ed3c8b342a5b9$export$a47b53017b47e379)({
        contentId: contentId,
        api: api,
        stepsDatabase: stepsDatabase,
        flags: flags
    });
    const isActivelySyncing = (0, $42omo.useRef)(false);
    $93f027f3fd7090c3$var$useConnectivityEffect(api, ({ prevMode: prevMode, nextMode: nextMode })=>{
        const { status: status, disabled: disabled } = (0, $bcc122a52e0f74cf$export$3b87fd119d006909).getState(editorView.state) ?? {};
        if (status !== 'ready' || disabled) return;
        // Only allow one sync at a time. This is to avoid flickering of the connection status causing online and offline resyncs to run at the same time.
        if (isActivelySyncing.current) return;
        isActivelySyncing.current = true;
        if (prevMode === 'offline' && nextMode === 'online') {
            // Try to prioritise the "active" tab by delaying the inactive tabs, this is to minimise
            // our chance of disrupting the user by the reset
            if (document && !document?.hasFocus?.()) // Give the active document ~1s to connect
            setTimeout(()=>(0, $de973e9ead6dfe2c$export$5ac754b16bef384)(api, stepsDatabase, editorView, false, {
                    createOfflineVersion: createOfflineVersion
                }).finally(()=>{
                    isActivelySyncing.current = false;
                }), document?.visibilityState === 'visible' ? 500 : 1000);
            else (0, $de973e9ead6dfe2c$export$5ac754b16bef384)(api, stepsDatabase, editorView, true, {
                createOfflineVersion: createOfflineVersion
            }).finally(()=>{
                isActivelySyncing.current = false;
            });
        } else if (nextMode === 'offline') stepsDatabase.validateIndexedDBAccess().then((isIndexedDBAvailable)=>{
            if (isIndexedDBAvailable) stepsDatabase.clear(true).then(async (cleared)=>{
                if (cleared) await stepsDatabase.releaseSyncLock?.();
            }).finally(()=>{
                // Resync the db with the current state of the unconfirmed steps
                const { version: version, steps: steps } = (0, $9NwnH.sendableSteps)(editorView.state) ?? {};
                if (version !== undefined && steps !== undefined) (0, $a5de712ae25052da$export$4abb9cd0bdff89ec)({
                    editorView: editorView,
                    stepsDatabase: stepsDatabase,
                    version: version,
                    steps: steps,
                    broadcast: broadcastUpdate
                }).finally(()=>{
                    isActivelySyncing.current = false;
                });
                else isActivelySyncing.current = false;
            });
            else isActivelySyncing.current = false;
        });
    });
};









const $1b00d7c59071460d$export$e3acca0d39d792dc = ({ api: api, stepsDatabase: stepsDatabase, disabledRef: disabledRef })=>{
    const queryingSyncLock = (0, $42omo.useRef)(false);
    (0, $6qdjm.usePluginStateEffect)(api, [
        'editorOfflineStorage',
        'connectivity',
        'collabEdit'
    ], ()=>{
        // Check if we're safe to re-enable the lock
        if (disabledRef.current === 'unableToSync' && !queryingSyncLock.current) {
            queryingSyncLock.current = true;
            stepsDatabase.isLocked().then((locked)=>{
                // If we're not locked (and still unable to sync) we can re-enable
                if (!locked && disabledRef.current === 'unableToSync') api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
                        disabled: false
                    }));
            }).catch(()=>{}).finally(()=>{
                queryingSyncLock.current = false;
            });
        }
    });
};





const $1d19c6d3b6d5b560$export$ea606e96c5866df5 = ({ api: api, config: config })=>{
    const stepsDatabase = new (0, $f0050ff6ee6f7eb3$export$c7a2e99e9e26da1c)();
    return {
        name: 'editorOfflineStorage',
        pmPlugins () {
            return [
                {
                    name: 'editorOfflineStoragePlugin',
                    plugin: (0, $bcc122a52e0f74cf$export$ae829ec7b2625219)(stepsDatabase)
                }
            ];
        },
        getSharedState (state) {
            if (!state) return undefined;
            const { status: status, disabled: disabled, inactiveSyncing: inactiveSyncing } = (0, $bcc122a52e0f74cf$export$3b87fd119d006909).getState(state) ?? {};
            const { version: version, steps: steps } = (0, $9NwnH.sendableSteps)(state) ?? {};
            return {
                version: version ?? 0,
                steps: steps ?? [],
                status: status ?? 'pending',
                disabled: disabled ?? false,
                inactiveSyncing: inactiveSyncing ?? false
            };
        },
        usePluginHook: ({ editorView: editorView })=>{
            const [contentId] = (0, $ep3mz.usePageContentId)();
            const disabledRef = (0, $42omo.useRef)(false);
            const hasCheckedForVersionInsertionBackupRef = (0, $42omo.useRef)(false);
            const intl = (0, $8C5kA.default)();
            (0, $6qdjm.usePluginStateEffect)(api, [
                'editorOfflineStorage'
            ], ({ editorOfflineStorageState: editorOfflineStorageState })=>{
                disabledRef.current = editorOfflineStorageState?.disabled ?? false;
            });
            const { createVersion: createOfflineVersion, manualRetryCreateVersion: manualRetryCreateVersion } = (0, $185ed3c8b342a5b9$export$a47b53017b47e379)({
                contentId: contentId,
                api: api,
                stepsDatabase: stepsDatabase,
                flags: config?.flags ?? null
            });
            (0, $42omo.useEffect)(()=>{
                if (contentId && !stepsDatabase.dbName && !disabledRef.current) stepsDatabase.init(contentId, api).then(async (initialized)=>{
                    if (!initialized) return;
                    if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
                        // Check and clear expired data before checking for backup
                        await stepsDatabase.checkAndClearExpiredData();
                        // Check for existing version insertion backup
                        if (!hasCheckedForVersionInsertionBackupRef.current) {
                            hasCheckedForVersionInsertionBackupRef.current = true;
                            const versionInsertionBackup = await stepsDatabase.getVersionInsertionBackup();
                            if (versionInsertionBackup) (0, $bf60d5cebe6d196a$export$ac18e6e44f1970de)(config?.flags, intl, // onRetry: Call manual retry with stored content
                            ()=>{
                                manualRetryCreateVersion(versionInsertionBackup.adfContent);
                            }, // onClose: Track when user dismisses the version insertion error flag
                            ()=>{
                                (0, $1a899df20ad45f18$export$6bd08bb9f59ca292)({
                                    api: api,
                                    action: 'OFFLINE_EDITING_VERSION_INSERTION_ERROR_FLAG_DISMISSED',
                                    manualRetryCount: 0
                                });
                            }, 0);
                        }
                    }
                });
            // We need stepsDatabase in deps to detect when DB is no longer initialised on re-render, e.g. when page goes full-width.
            }, [
                contentId,
                stepsDatabase,
                api,
                intl,
                manualRetryCreateVersion
            ]); // eslint-disable-line react-hooks/exhaustive-deps
            const broadcastUpdate = (0, $c71be5c341006c26$export$e38c76da774a8077)({
                api: api,
                editorView: editorView,
                stepsDatabase: stepsDatabase
            });
            /**
       * This is to resync the document online once we move from offline -> online
       */ (0, $93f027f3fd7090c3$export$68f4c8eca02a72d7)({
                api: api,
                editorView: editorView,
                broadcastUpdate: broadcastUpdate,
                stepsDatabase: stepsDatabase,
                contentId: contentId,
                flags: config?.flags ?? null
            });
            /**
       * See if it's safe to re-enable the plugin if it's been disabled due to the lock being held
       */ (0, $1b00d7c59071460d$export$e3acca0d39d792dc)({
                api: api,
                stepsDatabase: stepsDatabase,
                disabledRef: disabledRef
            });
            // Clean up the sync timeout on unmount
            // Otherwise its possible that it will fire with stale data after unmount
            (0, $42omo.useEffect)(()=>{
                return ()=>{
                    (0, $a5de712ae25052da$export$fed59d57957883a7).cancel();
                };
            }, [
                contentId,
                editorView
            ]);
            /**
       * This is to handle the initial load of the editor and syncing it from the indexeddb
       */ (0, $6qdjm.usePluginStateEffect)(api, [
                'editorOfflineStorage',
                'connectivity',
                'collabEdit'
            ], ({ editorOfflineStorageState: editorOfflineStorageState, connectivityState: connectivityState, collabEditState: collabEditState })=>{
                const { status: status, steps: steps, version: version, disabled: disabled } = editorOfflineStorageState ?? {};
                if (disabledRef.current) return;
                if (window?.indexedDB === undefined) {
                    // If indexeddb is not available disable offline editing here
                    if (!disabled) api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
                            disabled: 'stepsDatabaseError'
                        }));
                    return;
                }
                // Both the restore (init) sync lock and the resync online (online <-> offline) sync lock are released here.
                // We confirm the steps have synced with NCS before clearing the database and releasing the lock.
                if (steps?.length === 0 && stepsDatabase.hasLock) stepsDatabase.clear(false).then(async (cleared)=>{
                    if (cleared) {
                        if (stepsDatabase.lockPurpose === 'restore') // After we've the steps confirmed with NCS, we update the doc and version in the database.
                        await stepsDatabase.updateDocAndVersion(editorView).then((isUpdated)=>{
                            if (isUpdated) // Notify other tabs to sync from the updated doc/version in IndexedDB.
                            broadcastUpdate('restore');
                        });
                        await stepsDatabase.releaseSyncLock?.();
                    }
                });
                switch(status){
                    case 'pending':
                        // Restore steps once collab edit plugin is initialised
                        if (collabEditState?.initialised.collabInitialisedAt) {
                            const tr = editorView.state.tr;
                            tr.setMeta('addToHistory', false);
                            tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
                                status: 'restoring'
                            });
                            editorView.dispatch(tr);
                            (0, $576038989d33c4bf$export$312d5d76abf7691a)(api, stepsDatabase, editorView, 0, {
                                createOfflineVersion: createOfflineVersion
                            })(editorView.state.schema);
                        }
                        break;
                    case 'restoring':
                        break;
                    case 'ready':
                        const isFocusedAndVisible = document.visibilityState === 'visible' && document.hasFocus();
                        // If we are offline and we have steps to store, update the steps in the database
                        if (isFocusedAndVisible && steps && version !== undefined && connectivityState?.mode === 'offline') (0, $a5de712ae25052da$export$fed59d57957883a7)({
                            editorView: editorView,
                            stepsDatabase: stepsDatabase,
                            version: version,
                            steps: steps,
                            broadcast: broadcastUpdate
                        });
                        break;
                    case 'tooManyRetries':
                        // Unable to restore steps - ensure we disable the offline editing session to be safe
                        // in case there's something wrong with the DB.
                        if (!disabled) api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $bcc122a52e0f74cf$export$3b87fd119d006909), {
                                disabled: 'tooManyRetries'
                            }));
                        break;
                    default:
                        break;
                }
            });
        }
    };
};






var $jTxSS = parcelRequire("jTxSS");





var $jSnXV = parcelRequire("jSnXV");







const $d4ec92cbc00adf4b$export$3e69d3882a51f072 = 'heading-links';
const $d4ec92cbc00adf4b$export$2dd355223baa0569 = new (0, $ks2lK.PluginKey)($d4ec92cbc00adf4b$export$3e69d3882a51f072);
var $d4ec92cbc00adf4b$export$ad105db915eb8d4a = /*#__PURE__*/ function(EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS) {
    EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS["NOT_ENROLLED"] = "not-enrolled";
    EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS["CONTROL"] = "control";
    EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS["VARIANT"] = "variant";
    return EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS;
}({});















var $cOrQJ = parcelRequire("cOrQJ");


var $202oG = parcelRequire("202oG");

const $4b64eb8446c0685a$export$9030f1f7cf11a203 = async (node, getHeadingLinkPath)=>{
    try {
        const headingId = (0, $202oG.getHeadingIdForNode)(node);
        if (!headingId) return false;
        const path = getHeadingLinkPath();
        if (!path) return false;
        const url = new URL(location.origin + path);
        url.hash = encodeURIComponent(headingId);
        const href = url.toString();
        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            await navigator.clipboard.writeText(href);
            return true;
        }
        return false;
    } catch  {
        return false;
    }
};


const $a9415ea089d2d14f$var$i18n = (0, $cgtv4.defineMessages)({
    tooltipCopyMessage: {
        id: "editor-heading-links.link-component.tooltip.copy",
        defaultMessage: "Copy link to heading"
    },
    tooltipCopiedMessage: {
        id: "editor-heading-links.link-component.tooltip.copied",
        defaultMessage: "Copied!"
    },
    iconLabel: {
        id: "editor-heading-links.link-component.icon.label",
        defaultMessage: "Link icon"
    }
});
const $a9415ea089d2d14f$export$f356b7f7371242f8 = ({ node: node, intl: intl, analytics: analytics, isRightAligned: isRightAligned, getHeadingLinkPath: getHeadingLinkPath })=>{
    const [didCopy, setDidCopy] = (0, $42omo.useState)(false);
    const updateTooltip = (0, $42omo.useRef)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    (0, $42omo.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        didCopy
    ]);
    const handleClick = (0, $42omo.useCallback)(async ()=>{
        const didCopySucceed = await (0, $4b64eb8446c0685a$export$9030f1f7cf11a203)(node, getHeadingLinkPath);
        if (didCopySucceed) setDidCopy(true);
        // Should match the event fired for heading links on the view page
        // platform/packages/editor/renderer/src/react/nodes/heading.tsx
        analytics?.fireAnalyticsEvent?.({
            action: (0, $d925B.ACTION).CLICKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
            eventType: (0, $d925B.EVENT_TYPE).UI
        });
    }, [
        node,
        analytics,
        getHeadingLinkPath
    ]);
    const tooltipContentFn = (0, $42omo.useCallback)(({ update: update })=>{
        updateTooltip.current = update;
        return didCopy ? intl.formatMessage($a9415ea089d2d14f$var$i18n.tooltipCopiedMessage) : intl.formatMessage($a9415ea089d2d14f$var$i18n.tooltipCopyMessage);
    }, [
        didCopy,
        intl
    ]);
    const handleMouseOut = (0, $42omo.useCallback)(()=>{
        setDidCopy(false);
    }, []);
    const headingLevel = node.attrs['level'];
    const alignmentClass = isRightAligned ? 'link-widget-right' : 'link-widget-left';
    const sizeClass = headingLevel > 3 ? 'link-widget-small' : 'link-widget-medium';
    let colorClass;
    if (didCopy) colorClass = colorMode === 'dark' ? 'link-widget-clicked-dark' : 'link-widget-clicked-light';
    else colorClass = colorMode === 'dark' ? 'link-widget-hovered-dark' : 'link-widget-hovered-light';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        tag: "span",
        delay: 0,
        position: "top",
        content: tooltipContentFn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "heading-link-copy-button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `link-widget ${alignmentClass} ${sizeClass} ${colorClass}`,
        onClick: handleClick,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: handleMouseOut
    }));
};


const $61a2a9c96b4df241$export$181fa0f15c7f1584 = (position, node, isRightAligned, intl, analytics, getHeadingLinkPath)=>{
    return (0, $ftzrq.Decoration).widget(position, ()=>{
        const elem = document.createElement('span');
        // Trying to avoid both React and ProseMirror changing the same elements,
        // hence the nested container
        const container = document.createElement('span');
        // eslint-disable-next-line react/no-deprecated
        (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a9415ea089d2d14f$export$f356b7f7371242f8), {
            node: node,
            intl: intl,
            analytics: analytics,
            isRightAligned: isRightAligned,
            getHeadingLinkPath: getHeadingLinkPath
        }), container);
        elem.appendChild(container);
        return elem;
    }, {
        side: isRightAligned ? -1 : 1,
        key: `heading-link-${position}`,
        ignoreSelection: false
    });
};
const $61a2a9c96b4df241$export$ae829ec7b2625219 = (intl, analytics, getHeadingLinkPath)=>{
    const handleMouseOver = (view, event)=>{
        // Get the position of the cursor
        const result = view.posAtCoords({
            left: event.clientX,
            top: event.clientY
        });
        const pos = result?.pos;
        if (pos !== undefined) {
            // Resolve the position to a node
            let range = view.state.doc.resolve(pos);
            if (range.parent.type.name !== 'heading') {
                // There was an issue where, if you hovered over a heading from top to bottom,
                // the position would resolve to the document node rather than the heading.
                // Offsetting by 1 seems to fix the issue. However, we need to check both
                // pos and pos+1. If we only check the latter, there's a similar problem when
                // hovering headings from right to left.
                const adjPos = Math.min(pos + 1, view.state.doc.content.size);
                range = view.state.doc.resolve(adjPos);
            }
            // If the node is a heading, dispatch metadata to add a link decoration
            if (range.parent.type.name === 'heading') view.dispatch(view.state.tr.setMeta((0, $d4ec92cbc00adf4b$export$2dd355223baa0569), {
                applyHoverDecoration: true,
                from: range.start(),
                node: range.parent
            }));
        }
        return false;
    };
    const debouncedHandleMouseOver = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(handleMouseOver, 150);
    const plugin = new (0, $1S4f7.SafePlugin)({
        key: (0, $d4ec92cbc00adf4b$export$2dd355223baa0569),
        state: {
            init () {
                return {
                    hoveredHeading: undefined,
                    start: undefined
                };
            },
            apply: (tr, old, _, newState)=>{
                // Get the metadata that was dispatched from the mouseover event
                const hoverDecoration = tr.getMeta((0, $d4ec92cbc00adf4b$export$2dd355223baa0569));
                // If the metadata `applyHoverDecoration` property is present,
                // add a link decoration to the heading node. Note: Only one
                // decoration will ever exist on the page. When a new heading
                // is hovered, the old decoration will be replaced.
                if (hoverDecoration?.applyHoverDecoration) {
                    const node = hoverDecoration.node;
                    return {
                        hoveredHeading: node,
                        start: hoverDecoration.from
                    };
                }
                if (old.start !== undefined) {
                    const newStart = tr.mapping.map(old.start);
                    const newHeadingNode = newState.doc.resolve(newStart);
                    if (newHeadingNode.parent.content.size === 0 || newHeadingNode.parent.type.name !== 'heading') return {
                        hoveredHeading: undefined,
                        start: undefined
                    };
                    // If the heading is prepended, the start position will be off by 1,
                    // so we need to use the .start() method to get the correct position.
                    return {
                        hoveredHeading: newHeadingNode.parent,
                        start: newHeadingNode.start()
                    };
                }
                return old;
            }
        },
        props: {
            decorations (state) {
                const pluginState = plugin.getState(state);
                const heading = pluginState?.hoveredHeading;
                const start = pluginState?.start;
                if (heading && start !== undefined) {
                    const endMark = heading.marks.find((mark)=>mark.attrs?.align === 'end');
                    const position = endMark ? start : start + heading.content.size;
                    const link = $61a2a9c96b4df241$export$181fa0f15c7f1584(position, heading, endMark !== undefined, intl, analytics, getHeadingLinkPath);
                    return (0, $ftzrq.DecorationSet).create(state.doc, [
                        link
                    ]);
                }
                return (0, $ftzrq.DecorationSet).empty;
            },
            handleDOMEvents: {
                mouseover: debouncedHandleMouseOver
            }
        }
    });
    return plugin;
};
const $61a2a9c96b4df241$export$96df4e1ee1c54b95 = ({ api: api, config: { getHeadingLinkPath: getHeadingLinkPath } })=>({
        name: (0, $d4ec92cbc00adf4b$export$3e69d3882a51f072),
        pmPlugins () {
            return [
                {
                    name: (0, $d4ec92cbc00adf4b$export$3e69d3882a51f072),
                    plugin: ({ getIntl: getIntl })=>{
                        return $61a2a9c96b4df241$export$ae829ec7b2625219(getIntl(), api?.analytics?.actions, getHeadingLinkPath);
                    }
                }
            ];
        }
    });









var $a4TK8 = parcelRequire("a4TK8");













const $402b4b60c57df829$var$i18n = (0, $cgtv4.defineMessages)({
    title: {
        id: "editor-presets.conflicts-resolved-flag.title",
        defaultMessage: "All conflicts have been resolved"
    },
    description: {
        id: "editor-presets.conflicts-resolved-flag.description",
        defaultMessage: "Your offline edits have been successfully synced."
    },
    viewHistoryButton: {
        id: "editor-presets.conflicts-resolved-flag.view-history-button",
        defaultMessage: "View version history"
    }
});
const $402b4b60c57df829$var$FLAG_ID = 'conflicts-resolved-flag';
const $402b4b60c57df829$export$f4728fbe8fc5d546 = (flags, intl, contentId, spaceKey)=>{
    if (!flags) return;
    const versionHistoryUrl = (0, $1NBp8.CONTENT_HISTORY).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    flags.showSuccessFlag({
        id: $402b4b60c57df829$var$FLAG_ID,
        title: intl.formatMessage($402b4b60c57df829$var$i18n.title),
        description: intl.formatMessage($402b4b60c57df829$var$i18n.description),
        actions: [
            {
                content: intl.formatMessage($402b4b60c57df829$var$i18n.viewHistoryButton),
                href: versionHistoryUrl,
                onClick: ()=>{
                    $402b4b60c57df829$export$d04b5033a065369f(flags);
                }
            }
        ]
    });
};
const $402b4b60c57df829$export$d04b5033a065369f = (flags)=>{
    if (!flags) return;
    flags.hideFlag($402b4b60c57df829$var$FLAG_ID);
};









var $24P9d = parcelRequire("24P9d");





var $djYcq = parcelRequire("djYcq");


var $cyZvy = parcelRequire("cyZvy");










// Apply strike mark to deleted text
function $33fd45b068629a29$var$applyMarkToFragment(fragment, markType) {
    if (!markType) return fragment;
    // Create a mark of the given type
    const mark = markType.create({});
    const nodes = [];
    fragment.forEach((node)=>{
        if (node.isText) nodes.push(node.mark([
            ...node.marks,
            mark
        ]));
        else nodes.push(node.copy($33fd45b068629a29$var$applyMarkToFragment(node.content, markType)));
    });
    // Map over each node in the fragment and apply the mark
    return (0, $5SAOw.Fragment).fromArray(nodes);
}
const $33fd45b068629a29$export$f34037fb3390566b = (conflict, tr, selected = false)=>{
    return (0, $ftzrq.Decoration).widget(conflict.from, ()=>{
        const strikenText = document.createElement('span');
        const style = (0, $24P9d.convertToInlineCss)({
            background: selected ? "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)" : "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
            textDecoration: 'underline',
            textDecorationStyle: 'dotted',
            textDecorationThickness: "var(--ds-space-025, 2px)",
            textDecorationColor: "var(--ds-border-accent-orange, #E06C00)"
        });
        strikenText.setAttribute('style', style);
        // Render striken text fragment
        strikenText.appendChild((0, $5SAOw.DOMSerializer).fromSchema(tr.doc.type.schema).serializeFragment($33fd45b068629a29$var$applyMarkToFragment(conflict?.local.content, tr.doc.type.schema.marks.strike)));
        return strikenText;
    }, {
        side: -1,
        ignoreSelection: false
    });
};





/**
 * We have a couple of nodes that require us to compute style
 * on different elements, ideally all nodes should be able to
 * compute the appropriate styles based on their wrapper.
 */ const $3f8f658555914fb4$var$nestedCases = {
    'tableView-content-wrap': 'table',
    'mediaSingleView-content-wrap': '.rich-media-item',
    'bodiedExtensionView-content-wrap': '.extension-container',
    'multiBodiedExtensionView-content-wrap': '.multiBodiedExtension--container',
    'embedCardView-content-wrap': '.rich-media-item',
    'datasourceView-content-wrap': '.datasourceView-content-inner-wrap'
};
const $3f8f658555914fb4$var$computeNestedStyle = (dom)=>{
    const foundKey = Object.keys($3f8f658555914fb4$var$nestedCases).find((className)=>dom.classList.contains(className));
    const nestedSelector = foundKey && $3f8f658555914fb4$var$nestedCases[foundKey];
    if (nestedSelector) {
        const nestedElement = dom.querySelector(nestedSelector);
        if (nestedElement) return window.getComputedStyle(nestedElement);
    }
};
const $3f8f658555914fb4$var$measureHeight = (style)=>{
    return $3f8f658555914fb4$var$measureValue(style, [
        'height',
        'padding-top',
        'padding-bottom',
        'border-top-width',
        'border-bottom-width'
    ]);
};
const $3f8f658555914fb4$var$measureValue = (style, measureValues)=>{
    const [base, ...contentBoxValues] = measureValues;
    const measures = [
        style.getPropertyValue(base)
    ];
    const boxSizing = style.getPropertyValue('box-sizing');
    if (boxSizing === 'content-box') contentBoxValues.forEach((value)=>{
        measures.push(style.getPropertyValue(value));
    });
    let result = 0;
    for(let i = 0; i < measures.length; i++)result += parseFloat(measures[i]);
    return result;
};
function $3f8f658555914fb4$var$getLayoutModeFromTargetNode(node) {
    let layout;
    if (node.attrs.layout) layout = node.attrs.layout;
    if (node.marks && node.marks.length) layout = (node.marks.find((mark)=>mark.type.name === 'breakout') || {
        attrs: {
            mode: ''
        }
    }).attrs.mode;
    if (node.type.name === 'table' && node.attrs.width) layout = 'fixed-width';
    if ([
        'wide',
        'full-width',
        'fixed-width'
    ].indexOf(layout) === -1) return '';
    return layout;
}
/**
 * Converts a camelCased CSS property name to a hyphenated CSS property name.
 *
 * @param property - CamelCased CSS property name.
 * @returns Hyphenated CSS property name.
 */ function $3f8f658555914fb4$var$hyphenate(property) {
    // Ignored via go/ees005
    return property.replace(/[A-Z]/gu, (match)=>`-${match.toLowerCase()}`).replace(/^ms/u, '-ms');
}
const $3f8f658555914fb4$export$dfadf4096b7e8b0c = (node, pos)=>{
    return (0, $ftzrq.Decoration).widget(pos, (view, getPos)=>{
        const nodeStart = getPos();
        const element = document.createElement('span');
        element.className = 'conflictmarker';
        element.appendChild(document.createElement('span'));
        const dom = nodeStart !== undefined ? view.nodeDOM(nodeStart) : null;
        if (dom instanceof HTMLElement && element.firstChild) {
            const style = $3f8f658555914fb4$var$computeNestedStyle(dom) || window.getComputedStyle(dom);
            const conflictmarker = element.firstChild;
            conflictmarker.style.height = `${$3f8f658555914fb4$var$measureHeight(style)}px`;
            const layoutMode = node && $3f8f658555914fb4$var$getLayoutModeFromTargetNode(node);
            if (nodeStart !== 0 || layoutMode || node?.type.name === 'table') conflictmarker.style.marginTop = style.getPropertyValue('margin-top');
            const conflictMarkerCursorStyles = {
                content: "''",
                position: 'absolute',
                background: "var(--ds-background-accent-red-bolder, #C9372C)",
                width: "var(--ds-space-075, 6px)",
                marginLeft: "var(--ds-space-negative-075, -6px)",
                borderRadius: `${"var(--ds-radius-small, 4px)"} 0 0 ${"var(--ds-radius-small, 4px)"}`
            };
            for (const [rule, value] of Object.entries(conflictMarkerCursorStyles))conflictmarker.style.setProperty($3f8f658555914fb4$var$hyphenate(rule), value);
            conflictmarker.className = 'conflictmarker';
            conflictmarker.setAttribute('data-testid', 'conflictmarker');
        }
        return element;
    }, {
        side: -1
    });
};


const $d80773f42a527d1c$var$getBlockNodeAtPos = (pos, tr)=>{
    const $pos = tr.doc.resolve(pos);
    const node = $pos?.node();
    return node && node.isBlock && !node.isTextblock ? node : null;
};
const $d80773f42a527d1c$var$createInsertedDecoration = (conflict, tr, resolutionMode)=>{
    const node = $d80773f42a527d1c$var$getBlockNodeAtPos(conflict.from + 1, tr);
    if (node) return (0, $3f8f658555914fb4$export$dfadf4096b7e8b0c)(node, conflict.from);
    const styles = {
        textDecoration: 'underline',
        textDecorationStyle: 'dotted',
        textDecorationThickness: "var(--ds-space-025, 2px)",
        textDecorationColor: "var(--ds-border-accent-orange, #E06C00)"
    };
    // Background highlight behavior:
    // - Gate OFF (old behavior): Always show orange background
    // - Gate ON (new behavior): Only show orange background when actively resolving
    if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
        if (resolutionMode === 'resolving') styles.background = "var(--ds-background-accent-orange-subtlest, #FFF5DB)";
    } else // Old behavior: always show background
    styles.background = "var(--ds-background-accent-orange-subtlest, #FFF5DB)";
    return (0, $ftzrq.Decoration).inline(conflict.from, conflict.to, {
        style: (0, $24P9d.convertToInlineCss)(styles)
    });
};
const $d80773f42a527d1c$var$createSelectedDecoration = (conflict, tr)=>{
    if (conflict.type === 'deleted') return (0, $33fd45b068629a29$export$f34037fb3390566b)(conflict, tr, true);
    const node = $d80773f42a527d1c$var$getBlockNodeAtPos(conflict.from + 1, tr);
    if (node) return (0, $3f8f658555914fb4$export$dfadf4096b7e8b0c)(node, conflict.from);
    return (0, $ftzrq.Decoration).inline(conflict.from, conflict.to, {
        style: (0, $24P9d.convertToInlineCss)({
            background: "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
            textDecoration: 'underline',
            textDecorationStyle: 'dotted',
            textDecorationThickness: "var(--ds-space-025, 2px)",
            textDecorationColor: "var(--ds-border-accent-orange, #E06C00)"
        })
    });
};
function $d80773f42a527d1c$var$filterUndefined(c) {
    return c !== undefined;
}
const $d80773f42a527d1c$var$createDecorationsFromConflicts = (conflicts, selectedConflict, tr, resolutionMode)=>{
    if (!conflicts) return [];
    if (selectedConflict) {
        const selectedDecoration = $d80773f42a527d1c$var$createSelectedDecoration(selectedConflict, tr);
        const conflictDecorations = [
            ...conflicts.inserted.filter((c)=>c.id !== selectedConflict.id).map((c)=>$d80773f42a527d1c$var$createInsertedDecoration(c, tr, resolutionMode)),
            ...conflicts.deleted.filter((c)=>c.id !== selectedConflict.id).map((c)=>(0, $33fd45b068629a29$export$f34037fb3390566b)(c, tr)).filter($d80773f42a527d1c$var$filterUndefined)
        ];
        if (selectedDecoration) return conflictDecorations.concat(selectedDecoration);
        return conflictDecorations;
    } else return [
        ...conflicts.inserted.map((c)=>$d80773f42a527d1c$var$createInsertedDecoration(c, tr, resolutionMode)),
        ...conflicts.deleted.map((c)=>(0, $33fd45b068629a29$export$f34037fb3390566b)(c, tr)).filter($d80773f42a527d1c$var$filterUndefined)
    ];
};
const $d80773f42a527d1c$var$mapConflict = (change, mapping, type)=>{
    const from = mapping.map(change.from);
    const to = mapping.map(change.to);
    // We've collapsed the change and there's no visible marker to the user this conflict is no longer useful to us
    // These are "orphaned" conflicts similar to orphaned comments and for now we handle by resolving these since there
    // are no appropriate user actions.
    if (type === 'inserted' && from === to) return undefined;
    return {
        ...change,
        from: from,
        to: to
    };
};
const $d80773f42a527d1c$var$findSelectedConflict = (conflict, selection)=>selection.from >= conflict.from && selection.from <= conflict.to || selection.to >= conflict.from && selection.to <= conflict.to;
const $d80773f42a527d1c$var$getSelectedConflict = (conflicts, selection)=>{
    if (!conflicts) return undefined;
    const insertedSelectedConflict = conflicts?.inserted.find((conflict)=>$d80773f42a527d1c$var$findSelectedConflict(conflict, selection));
    const deletedSelectedConflict = conflicts?.deleted.find((conflict)=>$d80773f42a527d1c$var$findSelectedConflict(conflict, selection));
    if (insertedSelectedConflict) return {
        ...insertedSelectedConflict,
        type: 'inserted'
    };
    if (deletedSelectedConflict) return {
        ...deletedSelectedConflict,
        type: 'deleted'
    };
    return undefined;
};
const $d80773f42a527d1c$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $cyZvy.conflictResolutionPluginKey),
        state: {
            init: ()=>{
                return {
                    decorations: (0, $ftzrq.DecorationSet).empty,
                    conflicts: undefined,
                    selected: undefined,
                    isNextEnabled: false,
                    isPreviousEnabled: false,
                    resolutionMode: 'viewing'
                };
            },
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta((0, $cyZvy.conflictResolutionPluginKey));
                const navigatedConflict = tr.getMeta('nextConflict');
                // Early escape hatch to avoid running all the code below if not necessary
                if (pluginState.conflicts === undefined && meta === undefined) return pluginState;
                const conflicts = (0, $djYcq.getNewConflicts)(meta, pluginState.conflicts);
                const mappedConflicts = pluginState.conflicts ? {
                    inserted: pluginState.conflicts.inserted.map((c)=>$d80773f42a527d1c$var$mapConflict(c, tr.mapping, 'inserted')).filter($d80773f42a527d1c$var$filterUndefined),
                    deleted: pluginState.conflicts.deleted.map((c)=>$d80773f42a527d1c$var$mapConflict(c, tr.mapping, 'deleted')).filter($d80773f42a527d1c$var$filterUndefined)
                } : undefined;
                const conflictsRemaining = conflicts ?? mappedConflicts;
                // Update resolution mode based on metadata
                let resolutionMode = pluginState.resolutionMode;
                if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
                    if (meta?.type === 'startResolving') resolutionMode = 'resolving';
                    else if (meta?.type === 'stopResolving') resolutionMode = 'viewing';
                    else if (conflicts && !pluginState.conflicts) // Reset to viewing mode when new conflicts arrive
                    resolutionMode = 'viewing';
                }
                // Only select conflicts if explicitly navigated to OR if actively resolving with cursor selection
                let selectedConflict;
                if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) {
                    if (navigatedConflict) selectedConflict = navigatedConflict;
                    else if (resolutionMode === 'resolving') selectedConflict = $d80773f42a527d1c$var$getSelectedConflict(conflictsRemaining, tr.selection);
                } else selectedConflict = navigatedConflict ?? $d80773f42a527d1c$var$getSelectedConflict(conflictsRemaining, tr.selection);
                const decorations = conflicts || selectedConflict || pluginState.selected ? (0, $ftzrq.DecorationSet).create(tr.doc, $d80773f42a527d1c$var$createDecorationsFromConflicts(conflictsRemaining, selectedConflict, tr, resolutionMode)) : pluginState.decorations.map(tr.mapping, tr.doc);
                return {
                    decorations: decorations,
                    conflicts: conflictsRemaining,
                    selected: selectedConflict,
                    isPreviousEnabled: conflictsRemaining && selectedConflict ? (0, $djYcq.getNavigationInfo)(conflictsRemaining, selectedConflict, 'previous').isAbleToNavigate : false,
                    isNextEnabled: conflictsRemaining && selectedConflict ? (0, $djYcq.getNavigationInfo)(conflictsRemaining, selectedConflict, 'next').isAbleToNavigate : false,
                    resolutionMode: resolutionMode
                };
            }
        },
        props: {
            decorations: (state)=>(0, $cyZvy.conflictResolutionPluginKey).getState(state)?.decorations
        }
    });
};









const $751b8c45ea51c6cb$var$LazyContentComponent = /*#__PURE__*/ (0, $42omo.lazy)(async ()=>({
        default: (await (parcelRequire("fEcUb"))).ContentComponent
    }));
const $751b8c45ea51c6cb$var$ContentComponentWrapper = ({ api: api, config: config, editorView: editorView })=>{
    const intl = (0, $8C5kA.default)();
    const lastConflictCount = (0, $42omo.useRef)(0);
    // Watch for conflicts being resolved. This is so we can show the success flag.
    (0, $6qdjm.usePluginStateEffect)(api, [
        'conflictResolutionUI'
    ], ({ conflictResolutionUIState: conflictResolutionUIState })=>{
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) return;
        if (!config?.flags) return;
        if (!config?.contentId || !config?.spaceKey) return;
        const currentConflictCount = (conflictResolutionUIState?.conflicts?.inserted?.length ?? 0) + (conflictResolutionUIState?.conflicts?.deleted?.length ?? 0);
        // If we had conflicts and now we don't, show success flag
        if (lastConflictCount.current > 0 && currentConflictCount === 0) (0, $402b4b60c57df829$export$f4728fbe8fc5d546)(config.flags, intl, config.contentId, config.spaceKey);
        lastConflictCount.current = currentConflictCount;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($751b8c45ea51c6cb$var$LazyContentComponent, {
        api: api,
        editorView: editorView
    }));
};
const $751b8c45ea51c6cb$export$bb9d066eb8005e17 = ({ api: api, config: config })=>{
    return {
        name: 'conflictResolutionUI',
        contentComponent: ({ editorView: editorView })=>{
            if (!editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($751b8c45ea51c6cb$var$ContentComponentWrapper, {
                api: api,
                config: config,
                editorView: editorView
            });
        },
        getSharedState: (state)=>{
            if (!state) return undefined;
            return {
                selected: (0, $cyZvy.conflictResolutionPluginKey).getState(state)?.selected,
                isNextEnabled: (0, $cyZvy.conflictResolutionPluginKey).getState(state)?.isNextEnabled ?? true,
                isPreviousEnabled: (0, $cyZvy.conflictResolutionPluginKey).getState(state)?.isPreviousEnabled ?? true,
                conflicts: (0, $cyZvy.conflictResolutionPluginKey).getState(state)?.conflicts,
                resolutionMode: (0, $cyZvy.conflictResolutionPluginKey).getState(state)?.resolutionMode ?? 'viewing'
            };
        },
        commands: {
            navigateToFirstConflict: ({ tr: tr })=>{
                const conflicts = api?.conflictResolutionUI?.sharedState.currentState()?.conflicts;
                if (conflicts && (conflicts.inserted.length > 0 || conflicts?.deleted.length > 0)) return (0, $djYcq.navigateToAvailable)(undefined, tr, conflicts);
                return null;
            },
            startResolvingConflicts: ({ tr: tr })=>{
                const conflicts = api?.conflictResolutionUI?.sharedState.currentState()?.conflicts;
                // Early exit when we've no conflicts to resolve.
                if (!conflicts || conflicts.inserted.length === 0 && conflicts.deleted.length === 0) return null;
                // First, start resolving mode
                const trWithMode = tr.setMeta((0, $cyZvy.conflictResolutionPluginKey), {
                    type: 'startResolving'
                });
                // Then navigate to first conflict
                const trWithNavigation = (0, $djYcq.navigateToAvailable)(undefined, trWithMode, conflicts);
                return trWithNavigation || trWithMode;
            }
        },
        pmPlugins: ()=>{
            return [
                {
                    name: 'conflictResolutionPlugin',
                    plugin: (0, $d80773f42a527d1c$export$ae829ec7b2625219)
                }
            ];
        },
        usePluginHook: ({ editorView: editorView })=>{
            const lastReconnectionConflictMetadataRef = (0, $42omo.useRef)();
            (0, $6qdjm.usePluginStateEffect)(api, [
                'collabEdit'
            ], ({ collabEditState: collabEditState })=>{
                const { lastReconnectionConflictMetadata: lastReconnectionConflictMetadata } = collabEditState ?? {};
                if (lastReconnectionConflictMetadata && !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(lastReconnectionConflictMetadataRef.current, lastReconnectionConflictMetadata)) {
                    (0, $djYcq.setMetadata)(editorView, {
                        type: 'update',
                        data: lastReconnectionConflictMetadata
                    }, {
                        api: api
                    });
                    lastReconnectionConflictMetadataRef.current = lastReconnectionConflictMetadata;
                }
            });
        }
    };
};



var $2pjJ5 = parcelRequire("2pjJ5");

const $cadd3bfd971d84fd$export$67504bcc111d98ac = ()=>({
        name: 'empty',
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return {
                editorIsEmpty: (0, $2pjJ5.isEmptyDocument)(editorState.doc)
            };
        }
    });





const $fe598058b05d810f$var$pluginName = 'ssr-plugin';
const $fe598058b05d810f$var$pmPluginName = 'ssr-disable-transactions';
const $fe598058b05d810f$export$bfca3f3ccfec3116 = ()=>{
    return {
        name: $fe598058b05d810f$var$pluginName,
        pmPlugins () {
            return [
                {
                    name: $fe598058b05d810f$var$pmPluginName,
                    plugin () {
                        return new (0, $1S4f7.SafePlugin)({
                            filterTransaction () {
                                // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                                return true;
                            }
                        });
                    }
                }
            ];
        }
    };
};



var $adhil = parcelRequire("adhil");

var $1gpr6 = parcelRequire("1gpr6");




const $3c910faa900bb0f6$var$selectDocStart = ()=>({ tr: tr })=>{
        const docStartSelection = (0, $1gpr6.isValidTargetNode)(tr.doc.firstChild) ? new (0, $adhil.GapCursorSelection)(tr.doc.resolve(0)) : (0, $ks2lK.Selection).atStart(tr.doc);
        tr.setSelection(docStartSelection);
        return tr;
    };
const $3c910faa900bb0f6$var$insertNewLineAtDocStart = ()=>({ tr: tr })=>{
        const { paragraph: paragraph, heading: heading } = tr.doc.type.schema.nodes;
        const firstChild = tr.doc.firstChild;
        if (firstChild && [
            paragraph,
            heading
        ].includes(firstChild.type) && !firstChild.childCount) return $3c910faa900bb0f6$var$selectDocStart()({
            tr: tr
        });
        const emptyParagraph = tr.doc.type.schema.nodes.paragraph.create();
        tr.insert(0, emptyParagraph);
        tr.setSelection((0, $ks2lK.TextSelection).near(tr.doc.resolve(0)));
        return tr;
    };
const $3c910faa900bb0f6$export$c7c689ff4e6df96c = ()=>{
    return {
        name: 'pageTitleUtils',
        dependencies: [],
        commands: {
            selectDocStart: $3c910faa900bb0f6$var$selectDocStart,
            insertNewLineAtDocStart: $3c910faa900bb0f6$var$insertNewLineAtDocStart
        }
    };
};


function $83c8a91574f9bbb4$export$7cb04b251abcb35b(options) {
    const { intl: intl, appearance: appearance, prevAppearance: prevAppearance } = options;
    return (0, $2b80134f192952c5$export$9f1bd789d5e1fd40)({
        intl: intl,
        pluginOptions: {
            base: {
                __livePage: options.__livePage
            },
            helpDialog: {
                imageUploadProviderExists: false,
                aiEnabled: options.isAIEnabledForContent ?? false
            },
            hyperlink: {
                editorAppearance: appearance,
                linkPicker: options.linking?.linkPicker,
                onClickCallback: options.linking?.smartLinks?.onClickCallback
            },
            quickInsert: {
                emptyStateHandler: options.elementBrowser?.emptyStateHandler,
                quickInsert: options.quickInsert
            },
            placeholder: {
                viewMode: options.viewMode,
                isAIEnabled: options.isAIEnabledForContent ?? false
            },
            selection: {
                __livePage: options.__livePage
            },
            editorDisabled: {
                disabled: options.disabled
            },
            breakout: {
                editorAppearance: appearance
            },
            expand: {
                editorAppearance: appearance,
                __livePage: options.__livePage
            },
            annotation: {
                annotationManager: options.annotationProviders?.annotationManager,
                createCommentExperience: (0, $3YBks.createInlineCommentCompoundExperience),
                selectCommentExperience: (0, $4EKKB.selectInlineCommentCompoundExperience),
                viewInlineCommentTraceUFOPress: ()=>(0, $4TXTZ.default)('view-inline-comment-action')
            },
            media: {
                editorAppearance: appearance
            },
            mentions: {
                handleMentionsChanged: options.handleMentionsChanged
            },
            table: {
                editorAppearance: appearance,
                prevEditorAppearance: prevAppearance
            },
            tasksAndDecisions: {
                hasEditPermission: options.hasEditPermission,
                requestToEditContent: options.requestToEditContent,
                hasRequestedEditPermission: options.hasRequestedEditPermission
            },
            collabEdit: {
                collabEdit: options.collabEdit,
                __livePage: options.__livePage
            },
            // Remove the options.contextPanelOptions undefined checking after cleaning `platform_editor_ai_object_sidebar_injection` FG
            // and options.contextPanelOptions will be always defined.
            contextPanel: options.contextPanelOptions ? {
                objectSideBar: options.contextPanelOptions.objectSideBar
            } : undefined,
            extension: {
                extensionHandlers: options.extensionHandlers,
                editorAppearance: appearance,
                __rendererExtensionOptions: options.__rendererExtensionOptions,
                getExtensionHeight: options.getExtensionHeight
            },
            layout: {
                editorAppearance: appearance
            },
            card: {
                editorAppearance: appearance,
                linkPicker: options.linking?.linkPicker,
                onClickCallback: options.linking?.smartLinks?.onClickCallback,
                __livePage: options.__livePage,
                CompetitorPrompt: options.isEligibleCreateNewWhiteboard ? (0, $bODUD.PromptPopupContainer) : undefined
            },
            insertBlock: {
                editorAppearance: appearance,
                toolbarButtons: (0, $9wGTI.fg)('platform_editor_toolbar_aifc_undo_redo_confluence') ? {
                    emoji: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    insert: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    layout: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    media: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    mention: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    table: {
                        enabled: true,
                        showAt: 'md'
                    },
                    taskList: {
                        enabled: true,
                        showAt: 'lg'
                    }
                } : undefined
            },
            avatarGroup: {
                // Avatars are moved to Confluence codebase for Edit in Context
                // When Edit in Context is enabled primaryToolbarComponents is undefined
                // For more details please check
                // https://hello.atlassian.net/wiki/spaces/PCG/pages/2851572180/Editor+toolbar+for+live+pages+and+edit+in+context+projects
                collabEdit: options.collabEdit
            },
            codeBidiWarning: {
                editorAppearance: appearance
            },
            referentiality: {
                referentialityContext: options.referentialityContext
            },
            ai: options.editorPluginAIOptions,
            loom: {
                renderButton: options.loomPluginOptions.renderButton
            },
            editorViewMode: {
                viewMode: options.viewMode
            },
            aiDefinitions: options.editorPluginAIDefinitionsConfig,
            aiProactive: options.editorPluginAIProactiveConfig,
            selectionMarker: {
                __livePage: options.__livePage ?? false
            },
            engagementPlatform: {
                coordinationClient: options.editorEngagementPlatformPluginConfig.coordinationClient
            },
            selectionExtension: (0, $9wGTI.fg)('platform_editor_controls_selection_extension') ? options.selectionExtensionPluginOptions : {},
            metrics: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
            (0, $6mKj3.expValEquals)('platform_editor_controls', 'cohort', 'variant1') ? {
                userPreferencesProvider: options.userPreferencesProvider
            } : undefined,
            primaryToolbar: {
                contextualFormattingEnabled: options.contextualFormattingEnabled
            },
            selectionToolbar: {
                contextualFormattingEnabled: options.contextualFormattingEnabled
            },
            blockMenu: {
                getLinkPath: options.getHeadingLinkPath,
                blockLinkHashPrefix: options.blockLinkHashPrefix
            },
            showDiff: options.showDiffPluginParams,
            syncedBlock: options.syncedBlockProvider && (0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true) ? {
                syncedBlockRenderer: (0, $110d37d9cdb1248f$export$8add922a5c506966)({
                    syncBlockRendererOptions: undefined
                }),
                syncBlockDataProvider: options.syncedBlockProvider
            } : undefined,
            limitedMode: options.limitedModePluginOptions || {},
            toolbar: {
                contextualFormattingEnabled: (0, $9wGTI.fg)('platform_editor_toolbar_aifc_placement_config') ? 'controlled' : undefined
            },
            trackChanges: {
                ButtonWrapper: options.trackChangesPluginOptions?.ButtonWrapper
            }
        },
        providers: {
            userPreferencesProvider: options.userPreferencesProvider,
            userPreferencesProviderNext: options.userPreferencesProviderNext,
            cardProvider: options.linking?.smartLinks?.provider,
            contextIdentifierProvider: options.contextIdentifierProvider,
            inlineCommentAnnotationProvider: options.annotationProviders?.inlineComment,
            mediaProvider: options.media?.provider,
            syncMediaProvider: options.media?.syncProvider,
            mentionProvider: options.mentionProvider,
            profilecardProvider: options.mention?.profilecardProvider,
            emojiProvider: options.emojiProvider,
            emojiNodeDataProvider: options.emojiNodeDataProvider,
            collabEditProvider: options.collabEdit?.provider,
            autoformattingProvider: options.autoformattingProvider,
            taskDecisionProvider: options.taskDecisionProvider
        },
        enabledOptionalPlugins: {
            limitedMode: false,
            findReplace: Boolean(options.allowFindReplace),
            referentiality: Boolean(options.referentialityContext.plugin),
            loom: options.isLoomPluginEnabled,
            aiDefinitions: (0, $9wGTI.fg)('confluence_ai_access_policy') ? true : options.editorPluginAIDefinitionsEnabled,
            aiProactive: options.editorPluginAIProactiveEnabled,
            connectivity: options.isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false),
            metrics: (0, $9wGTI.fg)('platform_editor_ease_of_use_metrics'),
            ncsStepMetrics: true,
            codeBlockAdvanced: true,
            selectionExtension: (0, $6mKj3.expValEquals)('platform_editor_controls', 'cohort', 'variant1'),
            aiExperience: Boolean(options.editorPluginAIOptions.aiGlobalOptIn.status !== 'disabled'),
            interaction: Boolean(options?.__livePage) || (0, $6mKj3.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true),
            userPreferences: (0, $9wGTI.fg)('platform_editor_use_preferences_plugin'),
            trackChanges: (0, $9wGTI.fg)('platform_editor_ai_aifc_streaming'),
            showDiff: Boolean(options?.showDiffPluginParams) || (0, $9wGTI.fg)('platform_editor_ai_aifc_streaming'),
            toolbar: !options?.disableToolbar && ((0, $9wGTI.fg)('platform_editor_ai_aifc_streaming') || options.editorPluginAIOptions.aiGlobalOptIn.status !== 'enabled' && (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true)),
            blockMenu: (0, $6mKj3.expValEquals)('platform_editor_block_menu', 'isEnabled', true),
            localId: (0, $9wGTI.fg)('platform_editor_adf_with_localid'),
            aiStreamingOrchestrator: (0, $9wGTI.fg)('platform_editor_ai_aifc_streaming'),
            syncedBlock: (0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true),
            floatingToolbar: !options?.disableFloatingToolbar,
            codeBidiWarning: !(0, $6mKj3.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true)
        }
    }).add((0, $fe598058b05d810f$export$bfca3f3ccfec3116)).add([
        (0, $61a2a9c96b4df241$export$96df4e1ee1c54b95),
        {
            getHeadingLinkPath: options.getHeadingLinkPath
        }
    ]).add((0, $3c910faa900bb0f6$export$c7c689ff4e6df96c)).add((0, $b6333eeaeea6365c$export$53933ef6873e4a9f)).add((0, $dMGoR.forgeEditorPlugin)).maybeAdd([
        (0, $1d19c6d3b6d5b560$export$ea606e96c5866df5),
        {
            flags: options.flags
        }
    ], options.isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)).maybeAdd([
        (0, $751b8c45ea51c6cb$export$bb9d066eb8005e17),
        {
            flags: options.flags,
            contentId: options.contentId,
            spaceKey: options.spaceKey
        }
    ], options.isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)).add((0, $cadd3bfd971d84fd$export$67504bcc111d98ac)).add((0, $iHrpD.legacyContentMacroPlugin)).maybeAdd((0, $8c3629cd1d541fcd$export$d82c0e619eaaa2c2), options.isCompanyHub);
}
module.exports["createFullPageEditorPreset"] = $83c8a91574f9bbb4$export$7cb04b251abcb35b;

});

parcelRegister("djYcq", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $ks2lK = parcelRequire("ks2lK");


var $d925B = parcelRequire("d925B");


var $cyZvy = parcelRequire("cyZvy");

const $ea625f5574c5221d$export$bd9824d426074790 = (api)=>(payload)=>{
        return api?.attachAnalyticsEvent(payload);
    };


const $5899ae1a7b0c1755$export$cb5777189008ecf = (metadata, existingConflicts)=>{
    if (!metadata) return undefined;
    switch(metadata.type){
        // Navigate between conflicts using arrows - doesn't modify conflicts
        case 'navigate':
        // Enter/exit conflict resolution mode - doesn't modify conflicts
        case 'startResolving':
        case 'stopResolving':
            return existingConflicts;
        // Receive new conflicts from server after reconnection
        case 'update':
            return {
                inserted: metadata.data.inserted.map((c)=>({
                        ...c,
                        id: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
                    })),
                deleted: metadata.data.deleted.map((c)=>({
                        ...c,
                        id: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
                    }))
            };
        // User accepts/dismisses a single conflict (removes it from the list)
        case 'resolve':
        // User chooses to keep deleted text (restores it, then removes conflict from the list)
        case 'restore':
            if (!existingConflicts) return existingConflicts;
            return {
                inserted: existingConflicts.inserted.filter((conflict)=>conflict.id !== metadata.data.id),
                deleted: existingConflicts.deleted.filter((conflict)=>conflict.id !== metadata.data.id)
            };
        // User accepts all conflicts at once (clears the entire list)
        case 'resolveAll':
            return {
                inserted: [],
                deleted: []
            };
        default:
            return undefined;
    }
};
const $5899ae1a7b0c1755$export$6804620b9d3be6a7 = (conflicts, selected, direction)=>{
    const allConflicts = [
        ...conflicts?.inserted ?? [],
        ...conflicts?.deleted ?? []
    ].sort((a, b)=>a.from - b.from);
    if (!selected) return {
        isAbleToNavigate: true,
        newConflict: allConflicts.length > 0 ? allConflicts[0] : undefined
    };
    const idx = allConflicts.findIndex((c)=>c.id === selected.id);
    if (direction === 'next') {
        const isAbleToNavigate = idx < allConflicts.length - 1;
        return {
            isAbleToNavigate: isAbleToNavigate,
            newConflict: isAbleToNavigate ? allConflicts[idx + 1] : undefined
        };
    } else {
        const isAbleToNavigate = idx > 0;
        return {
            isAbleToNavigate: isAbleToNavigate,
            newConflict: isAbleToNavigate ? allConflicts[idx - 1] : undefined
        };
    }
};
const $5899ae1a7b0c1755$var$addTypeToConflict = (conflict, conflicts)=>{
    const type = conflicts.deleted.find((c)=>c.id === conflict.id) ? 'deleted' : 'inserted';
    return {
        ...conflict,
        type: type
    };
};
const $5899ae1a7b0c1755$var$navigateToSelection = (meta, tr, conflicts)=>{
    const { isAbleToNavigate: isAbleToNavigate, newConflict: newConflict } = $5899ae1a7b0c1755$export$6804620b9d3be6a7(conflicts, meta.data, meta.direction);
    if (isAbleToNavigate && newConflict) return tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, newConflict.from, newConflict.to)).setMeta('nextConflict', $5899ae1a7b0c1755$var$addTypeToConflict(newConflict, conflicts)).scrollIntoView();
    else return null;
};
const $5899ae1a7b0c1755$export$995f88ef5b52af82 = (currentConflict, tr, conflicts)=>{
    return $5899ae1a7b0c1755$var$navigateToSelection({
        type: 'navigate',
        direction: 'next',
        data: currentConflict
    }, tr, conflicts) ?? $5899ae1a7b0c1755$var$navigateToSelection({
        type: 'navigate',
        direction: 'previous',
        data: currentConflict
    }, tr, conflicts);
};
const $5899ae1a7b0c1755$export$f8685c902e685023 = (editorView, meta, options)=>{
    const { dispatch: dispatch, state: { tr: tr } } = editorView;
    if (meta.type === 'navigate') {
        const pluginState = (0, $cyZvy.conflictResolutionPluginKey).getState(editorView.state);
        if (pluginState?.conflicts) $5899ae1a7b0c1755$var$navigateToSelection(meta, tr, pluginState?.conflicts);
    } else if (meta.type === 'restore') tr.replace(meta.data.from, meta.data.to, meta.data.local);
    else if (meta.type === 'update') (0, $ea625f5574c5221d$export$bd9824d426074790)(options?.api?.analytics?.actions)({
        actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
        attributes: {
            inserted: meta.data.inserted.length,
            deleted: meta.data.deleted.length
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        action: 'offlineReconnectionConflict'
    })?.(tr);
    else if (meta.type === 'resolve') {
        const pluginState = (0, $cyZvy.conflictResolutionPluginKey).getState(editorView.state);
        if (pluginState?.conflicts) $5899ae1a7b0c1755$export$995f88ef5b52af82(meta.data, tr, pluginState?.conflicts);
    }
    dispatch(tr.setMeta((0, $cyZvy.conflictResolutionPluginKey), meta));
};
module.exports["getNewConflicts"] = $5899ae1a7b0c1755$export$cb5777189008ecf;
module.exports["getNavigationInfo"] = $5899ae1a7b0c1755$export$6804620b9d3be6a7;
module.exports["navigateToAvailable"] = $5899ae1a7b0c1755$export$995f88ef5b52af82;
module.exports["setMetadata"] = $5899ae1a7b0c1755$export$f8685c902e685023;

});

parcelRegister("fEcUb", function(module, exports) {

let $b6449a1e86f5b759$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b6449a1e86f5b759$var$load("4LYSa").then(()=>parcelRequire('50nRh'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("ijGoX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $axAnW = parcelRequire("axAnW");

var $kkQZq = parcelRequire("kkQZq");

var $iPfZG = parcelRequire("iPfZG");

var $hwWwS = parcelRequire("hwWwS");


var $lwNi3 = parcelRequire("lwNi3");

const $e86ccba267113370$export$4d97def4de07dcc1 = ()=>{
    const coordinationClient = (0, $lwNi3.useCoordinationClient)();
    // [ED-27497] IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/engagementPlatformPluginOptions.ts
    return (0, $42omo.useMemo)(()=>{
        const config = {
            epComponents: {
                EngagementSpotlight: $iPfZG.EngagementSpotlight,
                EngagementInlineDialog: $kkQZq.default,
                Coordination: $axAnW.default
            },
            epHooks: {
                useCoordination: $hwWwS.useCoordination
            },
            coordinationClient: coordinationClient
        };
        return {
            config: config
        };
    }, [
        coordinationClient
    ]);
};
module.exports["useEditorEngagementPlatform"] = $e86ccba267113370$export$4d97def4de07dcc1;

});

parcelRegister("bDgLc", function(module, exports) {

var $lzcvT = parcelRequire("lzcvT");


var $42omo = parcelRequire("42omo");


var $kyKWe = parcelRequire("kyKWe");


var $gKr8t = parcelRequire("gKr8t");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $eSUdr = parcelRequire("eSUdr");

const $770d1260eccad933$export$b855f1e1a990429f = (0, $eSUdr.default)`query HighlightKeywordsQuery($pageARI:String$workspaceId:String){knowledgeDiscovery{keyPhrases(entityAri:$pageARI workspaceId:$workspaceId)@optIn(to:"KnowledgeDiscovery Get Key Phrases"){__typename ...on KnowledgeDiscoveryKeyPhraseConnection{nodes{...on KnowledgeDiscoveryKeyPhrase{keyPhrase category}}}...on QueryError{message}}}}`;



var $7rLBD = parcelRequire("7rLBD");

const $70f493264a46a679$var$cachedAcronymRegex = {
    pageARI: '',
    regex: new RegExp('(?!)')
};
const $70f493264a46a679$var$getAcronymRegex = (acronyms, pageARI = '', ignoreCase = false)=>{
    if (pageARI === $70f493264a46a679$var$cachedAcronymRegex.pageARI) return $70f493264a46a679$var$cachedAcronymRegex.regex;
    let regex;
    try {
        regex = new RegExp(acronyms.map((node)=>`\\b${node.phrase}\\b`).join('|'), ignoreCase ? 'gi' : 'g');
    } catch (_e) {
        regex = new RegExp('(?!)');
    }
    $70f493264a46a679$var$cachedAcronymRegex.pageARI = pageARI;
    $70f493264a46a679$var$cachedAcronymRegex.regex = regex;
    return regex;
};
const $70f493264a46a679$export$ce57c3ee398efaad = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const pageARI = contentId ? (0, $7rLBD.generatePageARI)(contentId, cloudId, contentType) : undefined;
    const workspaceId = (0, $7rLBD.generateWorkspaceId)(activationId, cloudId);
    const queryHighlightAcronyms = (0, $42omo.useCallback)(async ({ cacheKey: cacheKey = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))() } = {})=>{
        if (!workspaceId || !pageARI) return {
            acronyms: []
        };
        const client = (0, $gKr8t.getAGGClient)();
        try {
            // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
            const { data: data } = await client.query({
                query: (0, $770d1260eccad933$export$b855f1e1a990429f),
                fetchPolicy: 'network-only',
                errorPolicy: 'ignore',
                variables: {
                    cacheKey: // comment from confluence/next/packages/content-appearance/src/contentAppearance.ts
                    // This is dummy variable is used to force "network-only" requests to only be run as network calls.
                    // A bug in Apollo sometimes makes this query return data from the cache even if the policy is "network-only"
                    // See for more details: https://pug.jira-dev.com/wiki/spaces/~683304838/pages/5971970200/Apollo+Client+-+weird+refetch+behavior
                    cacheKey,
                    pageARI: pageARI,
                    workspaceId: workspaceId
                }
            });
            const keyPhrases = data?.knowledgeDiscovery?.keyPhrases?.nodes ? data.knowledgeDiscovery.keyPhrases.nodes.map((node)=>({
                    phrase: node.keyPhrase,
                    category: node.category
                })) : [];
            // getAcronymRegex use pageARI to cache the regex for the page
            // but for live edit pages we should be careful with the cache
            // because the page content is changing constantly
            const pageARIWithCacheKey = `${pageARI}-${cacheKey}`;
            let acronymRegex = undefined;
            if (keyPhrases.length) acronymRegex = $70f493264a46a679$var$getAcronymRegex(keyPhrases, pageARIWithCacheKey, true);
            return {
                acronyms: keyPhrases,
                acronymRegex: acronymRegex
            };
        } catch (err) {
            return {
                acronyms: []
            };
        }
    }, [
        pageARI,
        workspaceId
    ]);
    return {
        queryHighlightAcronyms: queryHighlightAcronyms
    };
};






var $2Jxlo = parcelRequire("2Jxlo");








var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $7mpOv = parcelRequire("7mpOv");

const $5ea2be36e6b2ae4f$export$718b2890e94c1d28 = ()=>{
    /**
	 * see comments in `AIDefinitionsPluginConfig` for more details about why not checking `isLivePage` here
	 * const isLivePage = useIsCurrentPageLive();
	 */ const [contentId] = (0, $ep3mz.usePageContentId)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    // use a separate variable to help debug
    const notFedRamp = !(0, $lzcvT.isFedRamp)();
    const featureEnabled = isAIEnabledForContent || isRovoEnabledForContent;
    return notFedRamp && featureEnabled;
};
const $5ea2be36e6b2ae4f$export$eeb7064aa16baa7e = ()=>{
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    return (isAIEnabledForContent || isRovoEnabledForContent) && locale.startsWith('en') && !JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_READING_AIDS_AUTO_HIGHLIGHT) || '""');
};
const $5ea2be36e6b2ae4f$export$538319b84b3e9de0 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const enabled = $5ea2be36e6b2ae4f$export$718b2890e94c1d28();
    const autoHighlightEnabled = $5ea2be36e6b2ae4f$export$eeb7064aa16baa7e();
    const { queryHighlightAcronyms: queryHighlightAcronyms } = (0, $70f493264a46a679$export$ce57c3ee398efaad)();
    const { isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const enablementSource = isRovoEnabledForContent ? 'rovo' : 'general-ai';
    return {
        enabled: enabled,
        contentId: contentId,
        autoHighlightEnabled: autoHighlightEnabled,
        queryHighlightAcronyms: queryHighlightAcronyms,
        ReadingAidsPopup: $2Jxlo.ReadingAidsPopup,
        enablementSource: enablementSource,
        readingAidsMaxWordCount: (0, $7rLBD.READING_AIDS_MAX_WORD_COUNT)
    };
};
module.exports["useEditorPluginAIDefinitionsEnabled"] = $5ea2be36e6b2ae4f$export$718b2890e94c1d28;
module.exports["useEditorPluginAIDefinitionsConfig"] = $5ea2be36e6b2ae4f$export$538319b84b3e9de0;

});

parcelRegister("cyZvy", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $6a5fd4c39fa17a5b$export$f4d7eeb0b3cec670 = new (0, $ks2lK.PluginKey)('conflictResolutionPluginKey');
module.exports["conflictResolutionPluginKey"] = $6a5fd4c39fa17a5b$export$f4d7eeb0b3cec670;

});


//# sourceMappingURL=FullPageEditorComponent.b2b37f7b.js.map
